(function(){"use strict";try{if(typeof document!="undefined"){var e=document.createElement("style");e.appendChild(document.createTextNode('.room-provider[data-v-9668b9ac]{width:100%;height:100%;position:relative}.participant-video[data-v-487bad4f]{width:100%;height:100%;object-fit:cover;background-color:transparent}.participant-tag[data-v-bc836abf]{position:absolute;z-index:3;pointer-events:none;width:95%}.tag-content[data-v-bc836abf]{display:flex;align-items:center;gap:6px;width:fit-content;transition:all .2s ease}.mic-icon[data-v-bc836abf]{color:#f87171;flex-shrink:0}.pin-icon[data-v-bc836abf]{color:#3b82f6;flex-shrink:0}.participant-name[data-v-bc836abf]{color:#fff;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0}.participant-tile[data-v-a61d33cb]{position:relative;border-radius:20px;overflow:hidden;border:2px solid transparent;cursor:pointer;transition:all .2s ease}.participant-tile[data-v-a61d33cb]:hover{border-color:#ffffff4d}.participant-tile.speaking[data-v-a61d33cb]{border-color:#0f0;box-shadow:0 0 0 2px #0f06;transition:border-color .1s ease,box-shadow .1s ease}.participant-tile[data-v-a61d33cb]:not(.speaking){transition:border-color 3s ease,box-shadow 3s ease}.tile-avatar[data-v-a61d33cb]{position:absolute;inset:0;display:flex;align-items:center;justify-content:center}.tile-video[data-v-a61d33cb]{position:absolute;inset:0}.participant-tile[data-size=small][data-v-a61d33cb]{min-height:80px;border-radius:12px}.participant-tile[data-size=small] .tile-name[data-v-a61d33cb]{font-size:10px}.participant-tile[data-size=medium][data-v-a61d33cb]{min-height:120px;border-radius:20px}.participant-tile[data-size=large][data-v-a61d33cb]{min-height:200px;border-radius:20px}.participant-tile[data-size=fullscreen][data-v-a61d33cb]{min-height:300px;border-radius:20px}.participant-tile[data-size=fullscreen] .tile-name[data-v-a61d33cb]{font-size:16px}.menu-button[data-v-a61d33cb]{position:absolute;top:4px;right:4px;display:flex;align-items:center;justify-content:center;width:32px;height:32px;border-radius:50%;border:2px solid rgba(255,255,255,.8);background:#000000b3;color:#ffffffe6;cursor:pointer;backdrop-filter:blur(4px);z-index:15;opacity:0;transform:scale(.8);transition:all .2s ease}.hand-raised-indicator[data-v-a61d33cb]{position:absolute;top:8px;left:8px;display:flex;align-items:center;justify-content:center;z-index:15;opacity:1}.hand-emoji[data-v-a61d33cb]{font-size:32px;line-height:1;display:block;filter:drop-shadow(0 2px 4px rgba(0,0,0,.5))}.menu-button.menu-animate-in[data-v-a61d33cb]{opacity:1;transform:scale(1);transition:all .2s ease}.menu-button[data-v-a61d33cb]:hover{background:#000000e6;border-color:#fff;color:#fff;transform:scale(1.1)}.participant-tile[data-size=small] .menu-button[data-v-a61d33cb]{width:24px;height:24px;border:1px solid rgba(255,255,255,.8)}.participant-tile[data-size=medium] .menu-button[data-v-a61d33cb]{width:32px;height:32px}.participant-tile[data-size=large] .menu-button[data-v-a61d33cb]{width:36px;height:36px}.participant-tile[data-size=fullscreen] .menu-button[data-v-a61d33cb]{width:40px;height:40px;top:12px;right:12px}.participant-tile[data-size=small] .hand-emoji[data-v-a61d33cb]{font-size:16px}.participant-tile[data-size=medium] .hand-emoji[data-v-a61d33cb]{font-size:24px}.participant-tile[data-size=large] .hand-emoji[data-v-a61d33cb]{font-size:28px}.participant-tile[data-size=fullscreen] .hand-emoji[data-v-a61d33cb]{font-size:32px}.participant-tile[data-size=fullscreen] .hand-raised-indicator[data-v-a61d33cb]{top:12px;left:12px}.tile-moderation-dropdown[data-v-a61d33cb]{background:#1e293bf2;backdrop-filter:blur(12px);border-radius:12px;box-shadow:0 8px 24px #0006;border:1px solid rgba(255,255,255,.1);padding:6px;min-width:140px;max-height:300px;overflow-y:auto;transform:translate(-100%)}.tile-moderation-dropdown.dropdown-centered[data-v-a61d33cb]{transform:translate(-50%,-50%)}.tile-moderation-dropdown.dropdown-size-small[data-v-a61d33cb]{min-width:110px;padding:4px;border-radius:8px}.tile-moderation-dropdown.dropdown-size-medium[data-v-a61d33cb]{min-width:140px}.tile-moderation-dropdown.dropdown-size-large[data-v-a61d33cb],.tile-moderation-dropdown.dropdown-size-fullscreen[data-v-a61d33cb]{min-width:160px}.dropdown-item[data-v-a61d33cb]{display:flex;align-items:center;gap:10px;width:100%;padding:10px 12px;background:none;border:none;border-radius:8px;font-size:14px;font-weight:500;color:#fff;cursor:pointer;transition:all .2s;text-align:left}.dropdown-size-small .dropdown-item[data-v-a61d33cb]{padding:8px 10px;font-size:12px;gap:8px;border-radius:6px}.dropdown-item[data-v-a61d33cb]:hover{background-color:#ffffff1a}.dropdown-item.dropdown-item-danger[data-v-a61d33cb]{color:#ff6b6b}.dropdown-item.dropdown-item-danger[data-v-a61d33cb]:hover{background-color:#ff6b6b26}.dropdown-item svg[data-v-a61d33cb]{flex-shrink:0}.dropdown-backdrop[data-v-a61d33cb]{position:fixed;inset:0;z-index:9998;background:transparent}.stage-grid[data-v-18e03a2a]{width:100%;height:100%;min-height:0;position:relative;overflow:hidden;box-sizing:border-box;padding:4px}.stage-tile[data-v-18e03a2a]{position:absolute;background:#ffffff0d;border-radius:8px;overflow:hidden;border:2px solid rgba(255,255,255,.1);cursor:pointer;transition:border-color .2s ease;box-sizing:border-box;max-width:100%;max-height:100%;margin:4px}.stage-tile[data-v-18e03a2a]:hover{border-color:#ffffff4d}.stage-tile-big[data-v-18e03a2a]{border-color:#1a73e8;background:#1a73e81a}.tile-placeholder[data-v-18e03a2a]{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background-color:#0000004d;z-index:1}.tile-video[data-v-18e03a2a]{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;z-index:2}.tile-info[data-v-18e03a2a]{position:absolute;bottom:8px;left:8px;right:8px;background:#000000b3;padding:4px 8px;border-radius:4px;backdrop-filter:blur(4px);z-index:3}.tile-name[data-v-18e03a2a]{font-size:12px;font-weight:500;color:#fff;display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.stage-area[data-v-c84dd164]{width:100%;height:100%;min-height:0;position:relative;border-radius:12px;overflow:hidden;display:flex;flex-direction:row;align-items:center;box-sizing:border-box}.pagination-button[data-v-c84dd164]{position:absolute;top:50%;transform:translateY(-50%);z-index:100;display:flex;flex-direction:column;align-items:center;gap:8px;padding:16px 12px;background:#0009;backdrop-filter:blur(10px);border:1px solid rgba(255,255,255,.1);border-radius:8px;color:#fff;cursor:pointer;transition:all .2s ease}.pagination-button[data-v-c84dd164]:hover:not(:disabled){background:#000c;border-color:#fff3;transform:translateY(-50%) scale(1.05)}.pagination-button[data-v-c84dd164]:disabled{opacity:.3;cursor:not-allowed}.pagination-button svg[data-v-c84dd164]{width:24px;height:24px;color:#fff}.page-indicator[data-v-c84dd164]{font-size:14px;font-weight:600;color:#fff;white-space:nowrap}.pagination-prev[data-v-c84dd164]{left:16px}.pagination-next[data-v-c84dd164]{right:16px}@media (max-width: 768px){.pagination-button[data-v-c84dd164]{padding:12px 8px;gap:4px}.pagination-button svg[data-v-c84dd164]{width:20px;height:20px}.page-indicator[data-v-c84dd164]{font-size:12px}.pagination-prev[data-v-c84dd164]{left:8px}.pagination-next[data-v-c84dd164]{right:8px}}.pagination-dots[data-v-c84dd164]{position:absolute;bottom:8px;left:50%;transform:translate(-50%);z-index:100;display:flex;gap:8px;align-items:center;justify-content:center;padding:8px 16px;background:#0003;backdrop-filter:blur(10px);border-radius:20px;border:1px solid rgba(255,255,255,.1)}.pagination-dot[data-v-c84dd164]{width:10px;height:10px;border-radius:50%;border:2px solid rgba(255,255,255,.6);background:transparent;cursor:pointer;transition:all .2s ease;padding:0}.pagination-dot[data-v-c84dd164]:hover{border-color:#ffffffe6;transform:scale(1.2)}.pagination-dot.active[data-v-c84dd164]{background:#fff;border-color:#fff}@media (max-width: 768px){.pagination-button[data-v-c84dd164]{display:none!important}.pagination-dots[data-v-c84dd164]{display:flex}}@media (min-width: 769px){.pagination-dots[data-v-c84dd164]{display:none!important}}.participants-list-container[data-v-4f9f128e]{display:flex;flex-direction:column;background:#fff;border-radius:12px;box-shadow:0 4px 6px #0000001a;width:100%;max-width:400px;max-height:500px;overflow:hidden}.participants-header[data-v-4f9f128e]{display:flex;align-items:center;justify-content:space-between;padding:16px 20px;border-bottom:1px solid #e5e7eb}.participants-title[data-v-4f9f128e]{margin:0;font-size:18px;font-weight:600;color:#1f2937}.close-button[data-v-4f9f128e]{background:none;border:none;font-size:20px;color:#6b7280;cursor:pointer;padding:4px;width:28px;height:28px;display:flex;align-items:center;justify-content:center;border-radius:4px;transition:all .2s}.close-button[data-v-4f9f128e]:hover{background:#f3f4f6;color:#1f2937}.participants-scroll-area[data-v-4f9f128e]{flex:1;overflow-y:auto;padding:8px 0}.participant-item[data-v-4f9f128e]{display:flex;align-items:center;padding:12px 20px;gap:6px;transition:background-color .2s}.participant-item[data-v-4f9f128e]:hover{background-color:#f9fafb}.participant-avatar[data-v-4f9f128e]{flex-shrink:0}.participant-info[data-v-4f9f128e]{flex:1;min-width:0}.participant-name[data-v-4f9f128e]{font-size:14px;font-weight:500;color:#1f2937;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.participant-role[data-v-4f9f128e]{font-size:12px;color:#6b7280;margin-top:2px}.participant-controls[data-v-4f9f128e]{display:flex;align-items:center;flex-shrink:0}.media-control[data-v-4f9f128e]{background:transparent;border:none;cursor:pointer;padding:8px;border-radius:8px;display:flex;align-items:center;justify-content:center;transition:all .2s;color:#000}.media-control[data-v-4f9f128e]:hover:not(:disabled){background:#f3f4f6}.media-control[data-v-4f9f128e]:disabled{cursor:default;opacity:.5}.media-control.active[data-v-4f9f128e],.media-control.muted[data-v-4f9f128e]{color:#000}.more-options[data-v-4f9f128e]{background:transparent;border:none;cursor:pointer;padding:8px;border-radius:8px;display:flex;align-items:center;justify-content:center;color:#6b7280;transition:all .2s}.more-options[data-v-4f9f128e]:hover{background:#f3f4f6;color:#1f2937}.search-container[data-v-4f9f128e]{position:relative;padding:12px 20px}.search-input[data-v-4f9f128e]{width:100%;padding:10px 40px 10px 12px;border:1px solid #d1d5db;border-radius:8px;font-size:14px;color:#1f2937;background:#f9fafb;transition:all .2s;box-sizing:border-box}.search-input[data-v-4f9f128e]:focus{outline:none;border-color:#3b82f6;background:#fff;box-shadow:0 0 0 3px #3b82f61a}.search-input[data-v-4f9f128e]::placeholder{color:#9ca3af}.search-icon[data-v-4f9f128e]{position:absolute;right:32px;top:50%;transform:translateY(-50%);color:#6b7280;pointer-events:none}.participants-footer[data-v-4f9f128e]{padding:16px 20px;border-top:1px solid #e5e7eb;display:flex;justify-content:flex-end;gap:12px;background:#fff;position:sticky;bottom:0;z-index:10}.action-button[data-v-4f9f128e]{padding:10px 20px;border-radius:8px;font-size:14px;font-weight:500;cursor:pointer;transition:all .2s;border:none;display:flex;align-items:center;gap:8px}.action-button.mute-all[data-v-4f9f128e]{background:#3b82f6;color:#fff}.action-button.mute-all[data-v-4f9f128e]:hover{background:#2563eb}.participants-scroll-area[data-v-4f9f128e]::-webkit-scrollbar{width:6px}.participants-scroll-area[data-v-4f9f128e]::-webkit-scrollbar-track{background:#f9fafb;border-radius:3px}.participants-scroll-area[data-v-4f9f128e]::-webkit-scrollbar-thumb{background:#d1d5db;border-radius:3px}.participants-scroll-area[data-v-4f9f128e]::-webkit-scrollbar-thumb:hover{background:#9ca3af}.moderation-dropdown[data-v-4f9f128e]{background:#fff;border-radius:8px;box-shadow:0 4px 12px #00000026;border:1px solid #e5e7eb;padding:4px;min-width:200px;max-height:400px;overflow-y:auto}.dropdown-section[data-v-4f9f128e]{padding:4px 0}.dropdown-section[data-v-4f9f128e]:not(:last-child){border-bottom:1px solid #e5e7eb;margin-bottom:4px}.dropdown-item[data-v-4f9f128e]{display:flex;align-items:center;gap:8px;width:100%;padding:8px 12px;background:none;border:none;border-radius:4px;font-size:14px;color:#1f2937;cursor:pointer;transition:background-color .2s;text-align:left}.dropdown-item[data-v-4f9f128e]:hover{background-color:#f3f4f6}.dropdown-item.dropdown-item-danger[data-v-4f9f128e]{color:#dc2626}.dropdown-item.dropdown-item-danger[data-v-4f9f128e]:hover{background-color:#fee2e2}.dropdown-item svg[data-v-4f9f128e]{flex-shrink:0}.dropdown-backdrop[data-v-4f9f128e]{position:fixed;inset:0;z-index:9998;background:transparent}.participants-modal-overlay[data-v-a338f334]{position:absolute;top:0;left:0;width:100%;height:100%;background-color:#00000080;display:flex;align-items:center;justify-content:center;z-index:1000;backdrop-filter:blur(2px)}.floating-reactions-container[data-v-90dfe2b5]{position:absolute;inset:0;pointer-events:none;overflow:hidden;z-index:100}.reaction-animate[data-v-90dfe2b5]{position:absolute;font-size:3em;will-change:transform;display:flex;flex-direction:column;align-items:center;gap:4px;bottom:20px}.emoji-text[data-v-90dfe2b5]{font-size:1em;line-height:1;filter:drop-shadow(0 2px 4px rgba(0,0,0,.3))}.reaction-name[data-v-90dfe2b5]{font-size:.25em;color:#fff;background:#000000b3;padding:4px 8px;border-radius:12px;white-space:nowrap;font-weight:500;box-shadow:0 2px 8px #0000004d;backdrop-filter:blur(8px);border:1px solid rgba(255,255,255,.1)}.reaction-animate[data-v-90dfe2b5]{animation:floatUp-90dfe2b5 8s cubic-bezier(.47,.48,.44,.86) forwards,fadeInOut-90dfe2b5 8s ease-out forwards}.reaction-animate.wiggle-1[data-v-90dfe2b5]{animation:floatUp-90dfe2b5 8s cubic-bezier(.47,.48,.44,.86) forwards,wiggle1-90dfe2b5 8s ease-in-out forwards,fadeInOut-90dfe2b5 8s ease-out forwards}.reaction-animate.wiggle-2[data-v-90dfe2b5]{animation:floatUp-90dfe2b5 8s cubic-bezier(.47,.48,.44,.86) forwards,wiggle2-90dfe2b5 8s ease-in-out forwards,fadeInOut-90dfe2b5 8s ease-out forwards}.reaction-animate.wiggle-3[data-v-90dfe2b5]{animation:floatUp-90dfe2b5 8s cubic-bezier(.47,.48,.44,.86) forwards,wiggle3-90dfe2b5 8s ease-in-out forwards,fadeInOut-90dfe2b5 8s ease-out forwards}@keyframes floatUp-90dfe2b5{0%{transform:translateY(0) scale(.3)}10%{transform:translateY(-50px) scale(1)}to{transform:translateY(calc(-100vh - 100px)) scale(1.1)}}@keyframes fadeInOut-90dfe2b5{0%{opacity:0}10%{opacity:1}70%{opacity:1}to{opacity:0}}@keyframes wiggle1-90dfe2b5{0%,to{margin-left:0}20%{margin-left:-30px}40%{margin-left:20px}60%{margin-left:-20px}80%{margin-left:30px}}@keyframes wiggle2-90dfe2b5{0%,to{margin-left:0}20%{margin-left:20px}40%{margin-left:-30px}60%{margin-left:30px}80%{margin-left:-20px}}@keyframes wiggle3-90dfe2b5{0%,to{margin-left:0}25%{margin-left:-25px}50%{margin-left:25px}75%{margin-left:-15px}}.floating-reactions-container.position-bottom-right .reaction-animate[data-v-90dfe2b5]{right:20px;left:auto}.floating-reactions-container.position-top-left .reaction-animate[data-v-90dfe2b5]{top:20px;bottom:auto}.floating-reactions-container.position-top-left .reaction-animate[data-v-90dfe2b5]{animation:floatDown-90dfe2b5 8s cubic-bezier(.47,.48,.44,.86) forwards,fadeInOut-90dfe2b5 8s ease-out forwards}.floating-reactions-container.position-top-left .reaction-animate.wiggle-1[data-v-90dfe2b5],.floating-reactions-container.position-top-left .reaction-animate.wiggle-2[data-v-90dfe2b5],.floating-reactions-container.position-top-left .reaction-animate.wiggle-3[data-v-90dfe2b5]{animation:floatDown-90dfe2b5 8s cubic-bezier(.47,.48,.44,.86) forwards,wiggle1-90dfe2b5 8s ease-in-out forwards,fadeInOut-90dfe2b5 8s ease-out forwards}.floating-reactions-container.position-top-right .reaction-animate[data-v-90dfe2b5]{inset:20px 20px auto auto}.floating-reactions-container.position-top-right .reaction-animate[data-v-90dfe2b5]{animation:floatDown-90dfe2b5 5s cubic-bezier(.47,.48,.44,.86) forwards,fadeInOut-90dfe2b5 5s ease-out forwards}@keyframes floatDown-90dfe2b5{0%{transform:translateY(0) scale(.3)}10%{transform:translateY(50px) scale(1)}to{transform:translateY(calc(100vh + 100px)) scale(1.1)}}@media (max-width: 768px){.reaction-animate[data-v-90dfe2b5]{font-size:2.5em}.reaction-name[data-v-90dfe2b5]{font-size:.3em;padding:3px 6px}.reaction-animate.wiggle-1[data-v-90dfe2b5],.reaction-animate.wiggle-2[data-v-90dfe2b5],.reaction-animate.wiggle-3[data-v-90dfe2b5]{animation:floatUp-90dfe2b5 8s cubic-bezier(.47,.48,.44,.86) forwards,fadeInOut-90dfe2b5 8s ease-out forwards}}@media (prefers-reduced-motion: reduce){.reaction-animate[data-v-90dfe2b5],.reaction-animate.wiggle-1[data-v-90dfe2b5],.reaction-animate.wiggle-2[data-v-90dfe2b5],.reaction-animate.wiggle-3[data-v-90dfe2b5]{animation:floatUpSimple-90dfe2b5 2s ease-out forwards,fadeInOut-90dfe2b5 2s ease-out forwards}@keyframes floatUpSimple-90dfe2b5{0%{transform:translateY(0)}to{transform:translateY(-100vh)}}}.participants-strip-container[data-v-4ceb413c]{flex-shrink:0;width:100%;display:flex;align-items:center;background:#000c;border-bottom:1px solid rgba(255,255,255,.1);position:relative}.nav-button[data-v-4ceb413c]{position:absolute;top:50%;transform:translateY(-50%);z-index:100;display:flex;flex-direction:row;align-items:center;gap:6px;padding:8px 10px;background:#0009;backdrop-filter:blur(10px);border:1px solid rgba(255,255,255,.1);border-radius:8px;color:#fff;cursor:pointer;transition:all .2s ease}.nav-button[data-v-4ceb413c]:hover{background:#000c;border-color:#fff3;transform:translateY(-50%) scale(1.05)}.nav-button svg[data-v-4ceb413c]{width:20px;height:20px;color:#fff;transition:transform .2s ease}.nav-button:hover svg[data-v-4ceb413c]{transform:scale(1.1)}.page-indicator[data-v-4ceb413c]{font-size:12px;font-weight:600;color:#fff;white-space:nowrap}.nav-button-prev[data-v-4ceb413c]{left:12px}.nav-button-next[data-v-4ceb413c]{right:12px}.participants-strip[data-v-4ceb413c]{flex:1;display:flex;align-items:center;justify-content:center;gap:var(--0c95dd62);padding:12px 16px;overflow-x:auto;overflow-y:hidden;-webkit-overflow-scrolling:touch;scroll-behavior:smooth;scrollbar-width:none;-ms-overflow-style:none}.participants-strip.centered[data-v-4ceb413c]{justify-content:center;flex-direction:row}.participants-strip[data-v-4ceb413c]::-webkit-scrollbar{display:none}.strip-participant-tile[data-v-4ceb413c]{flex-shrink:0;width:var(--2d633a9e);height:var(--134b219c);border-radius:8px;overflow:hidden;border:2px solid rgba(255,255,255,.2);transition:all .2s ease;cursor:pointer}.strip-participant-tile[data-v-4ceb413c]:hover{border-color:#ffffff80;transform:scale(1.05)}.strip-participant-tile[data-v-4ceb413c] .participant-tag{bottom:2px;left:2px}.strip-participant-tile[data-v-4ceb413c] .tag-content{max-width:calc(100% - 8px);font-size:10px}.strip-participant-tile[data-v-4ceb413c] .participant-name{font-size:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:calc(var(--2d633a9e) - 20px)}@media (max-width: 1024px) and (min-width: 769px){.participants-strip[data-v-4ceb413c]{padding:10px 14px}.nav-button[data-v-4ceb413c]{padding:6px 8px;gap:4px}.nav-button svg[data-v-4ceb413c]{width:16px;height:16px}.page-indicator[data-v-4ceb413c]{font-size:10px}.nav-button-prev[data-v-4ceb413c]{left:10px}.nav-button-next[data-v-4ceb413c]{right:10px}.strip-participant-tile[data-v-4ceb413c] .participant-name{max-width:calc(var(--2d633a9e) - 20px);font-size:9px}.strip-participant-tile[data-v-4ceb413c] .tag-content{font-size:9px}}@media (max-width: 768px){.participants-strip[data-v-4ceb413c]{padding:8px}.nav-button[data-v-4ceb413c]{padding:6px;gap:3px}.nav-button svg[data-v-4ceb413c]{width:14px;height:14px}.page-indicator[data-v-4ceb413c]{font-size:9px}.nav-button-prev[data-v-4ceb413c]{left:8px}.nav-button-next[data-v-4ceb413c]{right:8px}.strip-participant-tile[data-v-4ceb413c]:hover{transform:scale(1.02)}.strip-participant-tile[data-v-4ceb413c] .participant-name{max-width:calc(var(--2d633a9e) - 20px);font-size:9px}}.screenshare-view[data-v-ab40f479]{width:100%;height:100%;display:flex;flex-direction:column}.screenshare-container[data-v-ab40f479]{width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:#000;padding:4px}.screenshare-tile[data-v-ab40f479]{width:calc(100% - 8px);height:calc(100% - 8px);border-radius:12px}.screenshare-tile[data-v-ab40f479] .tile-video{border-radius:8px;overflow:hidden}.screenshare-tile[data-v-ab40f479] video{object-fit:contain;background:#000}c .screenshare-tile[data-v-ab40f479] .tile-video{cursor:grab;touch-action:pan-x pan-y pinch-zoom}.screenshare-tile[data-v-ab40f479] .tile-video:active{cursor:grabbing}.screenshare-placeholder[data-v-ab40f479]{display:flex;align-items:center;justify-content:center;width:100%;height:200px;color:#fff;font-size:18px;background:#000c;border-radius:8px}@media (max-width: 768px){.screenshare-container[data-v-ab40f479]{overflow:auto;-webkit-overflow-scrolling:touch}.screenshare-tile[data-v-ab40f479]:after{content:"👆 Tap to interact";position:absolute;bottom:8px;right:8px;background:#000000b3;color:#fff;padding:4px 8px;border-radius:4px;font-size:12px;opacity:.7;pointer-events:none;animation:fade-in-out-ab40f479 3s ease-in-out}}@keyframes fade-in-out-ab40f479{0%,to{opacity:0}20%,80%{opacity:.7}}.speaker-view[data-v-bb29316c]{width:100%;height:100%;display:flex;flex-direction:column}.pinned-grid-container[data-v-bb29316c]{width:100%;height:100%}.speaker-container[data-v-bb29316c]{width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:#000;padding:4px}.speaker-tile[data-v-bb29316c]{width:calc(100% - 8px);height:calc(100% - 8px);border-radius:12px}.speaker-tile[data-v-bb29316c] .tile-video{border-radius:8px;overflow:hidden}.speaker-tile[data-v-bb29316c] video{object-fit:cover;background:#000}.speaker-placeholder[data-v-bb29316c]{display:flex;align-items:center;justify-content:center;width:100%;height:200px;color:#fff;font-size:18px;background:#000c;border-radius:8px}@media (max-width: 768px){.speaker-container[data-v-bb29316c]{padding:2px}.speaker-tile[data-v-bb29316c]{width:calc(100% - 4px);height:calc(100% - 4px)}}.room-view[data-v-350ec68b]{position:relative;width:100%;min-height:400px;background-color:var(--4d51db6d);color:#fff;border-radius:var(--1995c374);overflow:hidden}.room-container[data-v-350ec68b]{width:100%;height:100%;border-radius:var(--1995c374);overflow:hidden;background-color:var(--4d51db6d);position:relative}.preview-container[data-v-350ec68b]{position:relative;width:100%;height:100%;display:flex;align-items:center;justify-content:center}.preview-video[data-v-350ec68b]{width:100%;height:100%;object-fit:var(--05280004);background-color:var(--4d51db6d)}.preview-placeholder[data-v-350ec68b]{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;background-color:var(--4d51db6d);gap:16px}.permission-button-overlay[data-v-350ec68b]{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;z-index:15}.permission-prompt-container[data-v-350ec68b]{display:flex;flex-direction:column;align-items:center;gap:24px;text-align:center;max-width:600px;padding:40px 32px;background:#0000004d;border-radius:16px;backdrop-filter:blur(10px)}.permission-revoked-container[data-v-350ec68b]{display:flex;flex-direction:column;align-items:flex-end;gap:24px;text-align:center;max-width:600px;padding:40px 32px;background:#fff;border-radius:16px;backdrop-filter:blur(10px)}.permission-prompt-text[data-v-350ec68b]{color:#fff;font-size:20px;margin:0;line-height:1.4;text-shadow:0 1px 3px rgba(0,0,0,.5)}.permission-revoked-text[data-v-350ec68b]{color:#000;font-size:20px;margin:0;line-height:1.4}@media (max-width: 768px){.permission-prompt-container[data-v-350ec68b],.permission-revoked-container[data-v-350ec68b]{max-width:90%;padding:32px 24px;gap:20px}.permission-prompt-text[data-v-350ec68b],.permission-revoked-text[data-v-350ec68b]{font-size:18px}}@media (max-width: 480px){.permission-prompt-container[data-v-350ec68b],.permission-revoked-container[data-v-350ec68b]{max-width:90%;padding:24px 16px;gap:16px}.permission-prompt-text[data-v-350ec68b],.permission-revoked-text[data-v-350ec68b]{font-size:16px}}.permission-button[data-v-350ec68b],.permission-revoked-button[data-v-350ec68b]{background:#1976d2;color:#fff;border:none;border-radius:8px;padding:12px 20px;font-size:14px;font-weight:500;cursor:pointer;display:flex;align-items:center;gap:8px;transition:all .2s ease;box-shadow:0 2px 8px #1976d24d}.permission-button[data-v-350ec68b]:hover,.permission-revoked-button[data-v-350ec68b]:hover{background:#1565c0;transform:translateY(-1px);box-shadow:0 4px 12px #1976d266}.permission-button svg[data-v-350ec68b]{color:#ea4335}.room-content[data-v-350ec68b]{width:100%;height:100%;position:relative;display:flex;flex-direction:column;overflow:hidden}.filmstrip-section[data-v-350ec68b]{flex-shrink:0;width:100%;display:flex;justify-content:center;padding:8px 16px 0;box-sizing:border-box;max-width:100%;overflow:visible}.stage-section[data-v-350ec68b]{flex:1;width:100%;min-height:0;display:flex;flex-direction:column;padding:8px;box-sizing:border-box;overflow:hidden}.stage-section.fullscreen-stage[data-v-350ec68b]{padding:8px;height:100vh;max-height:100vh;background-color:#040404}.status-overlay[data-v-350ec68b]{position:absolute;top:16px;right:16px;display:flex;flex-direction:column;gap:8px;z-index:10}.room-status[data-v-350ec68b]{display:flex;align-items:center;gap:8px;background:#000000b3;padding:8px 12px;border-radius:20px;backdrop-filter:blur(4px)}.status-dot[data-v-350ec68b]{width:8px;height:8px;border-radius:50%;background:#34a853;animation:pulse-350ec68b 2s infinite}@keyframes pulse-350ec68b{0%,to{opacity:1}50%{opacity:.5}}.status-text[data-v-350ec68b]{font-size:12px;font-weight:500;color:#34a853}.participant-count[data-v-350ec68b]{background:#000000b3;padding:6px 12px;border-radius:16px;backdrop-filter:blur(4px);font-size:12px;text-align:center;color:#ffffffe6}.loading-overlay[data-v-350ec68b]{position:absolute;inset:0;background:#000000b3;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px;z-index:20}.spinner[data-v-350ec68b]{width:40px;height:40px;border:3px solid rgba(255,255,255,.2);border-radius:50%;border-top-color:#fff;animation:spin-350ec68b 1s linear infinite}@keyframes spin-350ec68b{to{transform:rotate(360deg)}}.connection-message[data-v-350ec68b]{font-size:16px;font-weight:500;color:#fff;text-align:center;margin:0}.error-overlay[data-v-350ec68b]{position:absolute;inset:0;background:#000c;display:flex;align-items:center;justify-content:center;z-index:30}.error-message[data-v-350ec68b]{background:#ea4335e6;padding:24px;border-radius:12px;text-align:center;max-width:400px}.error-message h3[data-v-350ec68b]{margin:0 0 8px;font-size:18px;color:#fff}.error-message p[data-v-350ec68b]{margin:0;font-size:14px;color:#ffffffe6}@media (max-width: 768px){.status-overlay[data-v-350ec68b]{top:12px;right:12px}.filmstrip-section[data-v-350ec68b]{padding:8px 12px 0}}.permission-modal-overlay[data-v-350ec68b]{position:fixed;inset:0;background:#00000080;display:flex;align-items:center;justify-content:center;z-index:10000;backdrop-filter:blur(2px)}.permission-modal[data-v-350ec68b]{background:#fff;border-radius:12px;padding:24px;width:380px;max-width:90vw;box-shadow:0 10px 25px #0003;text-align:left;font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif}@media (max-width: 639px){.permission-modal[data-v-350ec68b]{width:320px}}.permission-modal-message[data-v-350ec68b]{font-size:16px;color:#101828;margin:0 0 24px;line-height:1.5;font-weight:500}.permission-modal-button[data-v-350ec68b]{background:#155eef;color:#fff;border:none;border-radius:8px;padding:10px 20px;font-size:14px;font-weight:500;font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif;cursor:pointer;transition:background-color .2s;float:right;min-width:60px}.permission-modal-button[data-v-350ec68b]:hover{background:#2563eb}.permission-modal-button[data-v-350ec68b]:active{background:#1d4ed8}.recording-consent-modal-overlay[data-v-350ec68b]{position:fixed;inset:0;background:#00000080;display:flex;align-items:center;justify-content:center;z-index:10000;backdrop-filter:blur(2px)}.recording-consent-modal[data-v-350ec68b]{background:#fff;border-radius:12px;padding:20px;width:434px;max-width:90vw;box-shadow:0 10px 25px #0003;text-align:left;font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif}@media (max-width: 639px){.recording-consent-modal[data-v-350ec68b]{width:320px}}.recording-consent-header[data-v-350ec68b]{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:8px}.recording-consent-title[data-v-350ec68b]{font-size:18px;font-weight:600;color:#101828;margin:0;line-height:1.4;flex:1}.recording-consent-close[data-v-350ec68b]{background:none;border:none;cursor:pointer;padding:4px;margin:-4px -4px 0 0;color:#667085;border-radius:4px;transition:all .2s;display:flex;align-items:center;justify-content:center}.recording-consent-close[data-v-350ec68b]:hover{background:#f9fafb;color:#344054}.recording-consent-close[data-v-350ec68b]:active{background:#f2f4f7}.recording-consent-message[data-v-350ec68b]{font-size:14px;color:#475467;margin:0 0 20px;line-height:1.5}.recording-consent-footer[data-v-350ec68b]{border-top:1px solid #e5e7eb;margin:0 -20px -20px;padding:16px 20px;background:#fafafa;border-radius:0 0 12px 12px}.recording-consent-buttons[data-v-350ec68b]{display:flex;gap:12px;justify-content:flex-end}.recording-consent-button[data-v-350ec68b]{border:none;border-radius:8px;padding:12px 20px;font-size:14px;font-weight:500;font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif;cursor:pointer;transition:background-color .2s}.recording-consent-continue[data-v-350ec68b]{background:#1d4981;color:#fff}.recording-consent-continue[data-v-350ec68b]:hover{background:#1e3a72;transform:translateY(-1px);box-shadow:0 4px 8px #1d49814d}.recording-consent-continue[data-v-350ec68b]:active{background:#162f5f;transform:translateY(0);box-shadow:0 2px 4px #1d498133}.recording-consent-leave[data-v-350ec68b]{background:#fff;color:#1f2937;border:1px solid #d1d5db}.recording-consent-leave[data-v-350ec68b]:hover{background:#f9fafb;border-color:#9ca3af}.recording-consent-leave[data-v-350ec68b]:active{background:#f3f4f6}.connection-minutes-modal-overlay[data-v-350ec68b]{position:fixed;inset:0;background:#00000080;display:flex;align-items:center;justify-content:center;z-index:10000;backdrop-filter:blur(2px)}.connection-minutes-modal[data-v-350ec68b]{background:#fff;border-radius:12px;padding:24px;width:434px;max-width:90vw;box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a;text-align:center;font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif;position:relative}@media (max-width: 639px){.connection-minutes-modal[data-v-350ec68b]{width:320px;padding:20px}}.connection-minutes-close[data-v-350ec68b]{position:absolute;top:16px;right:16px;background:none;border:none;cursor:pointer;padding:4px;color:#667085;border-radius:4px;transition:all .2s;display:flex;align-items:center;justify-content:center}.connection-minutes-close[data-v-350ec68b]:hover{background:#f9fafb;color:#344054}.connection-minutes-close[data-v-350ec68b]:active{background:#f2f4f7}.connection-minutes-icon[data-v-350ec68b]{margin:24px auto 16px;display:flex;justify-content:center;align-items:center;width:56px;height:56px;background-color:#d1e0ff;border-radius:50%}.connection-minutes-title[data-v-350ec68b]{font-size:24px;font-weight:500;color:#101828;margin:0 0 8px;line-height:1.4}.connection-minutes-message[data-v-350ec68b]{font-size:16px;color:#475467;margin:0;line-height:1.5}.connection-minutes-footer[data-v-350ec68b]{border-top:1px solid #e5e7eb;margin:24px -24px -24px;padding:16px 24px}@media (max-width: 639px){.connection-minutes-footer[data-v-350ec68b]{margin:24px -20px -20px;padding:16px 20px}}.connection-minutes-buttons[data-v-350ec68b]{display:flex;gap:12px;justify-content:center}.connection-minutes-button[data-v-350ec68b]{border:none;border-radius:8px;padding:12px 20px;font-size:14px;font-weight:500;font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif;cursor:pointer;transition:background-color .2s;font-size:16px;flex:1}.connection-minutes-close-btn[data-v-350ec68b]{background:#fff;color:#344054;border:1px solid #d0d5dd}.connection-minutes-close-btn[data-v-350ec68b]:hover{background:#f9fafb;border-color:#b0b7c3}.connection-minutes-close-btn[data-v-350ec68b]:active{background:#f2f4f7}.connection-minutes-upgrade[data-v-350ec68b]{background:#155eef;color:#fff}.connection-minutes-upgrade[data-v-350ec68b]:hover{background:#2563eb}.connection-minutes-upgrade[data-v-350ec68b]:active{background:#1d4ed8}.leave-session-modal-overlay[data-v-350ec68b]{position:fixed;inset:0;background:#0009;display:flex;align-items:center;justify-content:center;z-index:2011;backdrop-filter:blur(4px)}.leave-session-modal[data-v-350ec68b]{background:#fff;border-radius:12px;box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a;max-width:550px;width:90%;max-height:90vh;overflow:hidden;position:relative;font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif}.leave-session-header[data-v-350ec68b]{display:flex;align-items:center;justify-content:space-between;padding:20px 24px 0}.leave-session-title[data-v-350ec68b]{font-size:18px;font-weight:600;color:#111827;margin:0}.leave-session-body[data-v-350ec68b]{padding:16px 24px 24px}.leave-session-message[data-v-350ec68b]{font-size:14px;line-height:1.5;color:#6b7280;margin:0}.leave-session-actions[data-v-350ec68b]{display:flex;gap:12px;padding:0 24px 24px;justify-content:flex-end}.leave-session-button[data-v-350ec68b]{padding:10px 16px;border-radius:8px;font-size:14px;font-weight:500;cursor:pointer;transition:all .2s;border:none;min-width:80px}.leave-session-button.cancel-button[data-v-350ec68b]{background:#fff;color:#374151;border:1px solid #d1d5db}.leave-session-button.cancel-button[data-v-350ec68b]:hover{background:#fff;border-color:#9ca3af;transform:translateY(-1px);box-shadow:0 4px 8px #1d49814d}.leave-session-button.confirm-button[data-v-350ec68b]{background:#ef4444;color:#fff}.leave-session-button.confirm-button[data-v-350ec68b]:hover{background:#dc2626;transform:translateY(-1px);box-shadow:0 4px 8px #1d49814d}.leave-session-button.confirm-button[data-v-350ec68b]:active{background:#b91c1c;transform:translateY(0);box-shadow:0 2px 4px #1d498133}@media (max-width: 480px){.leave-session-modal[data-v-350ec68b]{margin:16px;width:calc(100% - 32px)}.leave-session-header[data-v-350ec68b]{padding:16px 20px 0}.leave-session-title[data-v-350ec68b]{font-size:16px}.leave-session-body[data-v-350ec68b]{padding:12px 20px 20px}.leave-session-actions[data-v-350ec68b]{padding:0 20px 20px;flex-direction:column-reverse}.leave-session-button[data-v-350ec68b]{width:100%;padding:12px 16px}}.reaction-picker[data-v-206cd94d]{position:fixed;z-index:1000;padding:8px;backdrop-filter:blur(10px);border:1px solid rgba(255,255,255,.1)}.picker-content[data-v-206cd94d]{display:flex;gap:4px;align-items:center}.emoji-button[data-v-206cd94d]{width:44px;height:44px;display:flex;align-items:center;justify-content:center;background:transparent;border:none;border-radius:8px;cursor:pointer;transition:all .2s ease;position:relative}.emoji-button[data-v-206cd94d]:hover{background:#ffffff1a;transform:scale(1.1)}.emoji-button[data-v-206cd94d]:active{transform:scale(.95)}.emoji-text[data-v-206cd94d]{font-size:24px;line-height:1;user-select:none}.emoji-button:hover .emoji-text[data-v-206cd94d]{animation:wiggle-206cd94d .5s ease-in-out}@keyframes wiggle-206cd94d{0%,to{transform:rotate(0)}25%{transform:rotate(-10deg)}75%{transform:rotate(10deg)}}.picker-fade-enter-active[data-v-206cd94d],.picker-fade-leave-active[data-v-206cd94d]{transition:all .2s ease}.picker-fade-enter-from[data-v-206cd94d],.picker-fade-leave-to[data-v-206cd94d]{opacity:0;transform:translate(-50%) scale(.9)}@media (max-width: 480px){.emoji-button[data-v-206cd94d]{width:40px;height:40px}.emoji-text[data-v-206cd94d]{font-size:20px}}.control-bar[data-v-d4b4f36a]{display:flex;justify-content:center;align-items:center;gap:var(--4a14ae46);padding:var(--235b40fc);background:var(--548027c2);border-radius:var(--de9086ee);box-sizing:border-box;width:fit-content;z-index:80;--control-size: var(--4f3ff542);--icon-size: var(--42501ba3);--icon-color: var(--717c87dc);--text-color: var(--f2f660b0);--active-color: var(--717c87dc);font-size:var(--5c1a86fc);color:var(--f2f660b0)}.control-bar.position-bottom[data-v-d4b4f36a]{position:absolute;bottom:var(--4eeffa4d);left:50%;transform:translate(-50%)}.control-bar.position-top[data-v-d4b4f36a]{position:absolute;top:var(--4eeffa4d);left:50%;transform:translate(-50%)}.control-bar.position-left[data-v-d4b4f36a]{position:absolute;left:var(--4eeffa4d);top:50%;transform:translateY(-50%)}.control-bar.position-right[data-v-d4b4f36a]{position:absolute;right:var(--4eeffa4d);top:50%;transform:translateY(-50%)}.control-bar.vertical[data-v-d4b4f36a]{flex-direction:column;width:fit-content}.control-bar.vertical .controls-group[data-v-d4b4f36a]{flex-direction:column}.controls-group[data-v-d4b4f36a]{display:flex;align-items:center;gap:var(--4a14ae46);transition:all .3s ease-in-out}.controls-end[data-v-d4b4f36a]{display:flex;align-items:center;gap:var(--4a14ae46)}.control-item[data-v-d4b4f36a]{flex:0 0 auto;width:var(--control-size);height:var(--control-size);display:flex;align-items:center;justify-content:center;box-sizing:border-box;position:relative}.permission-indicator[data-v-d4b4f36a]{position:absolute;top:-5px;right:-5px;background:#fa7b16;color:#fff;border-radius:50%;width:16px;height:16px;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;z-index:10}.permission-denied[data-v-d4b4f36a]{background-color:#ea4335;border:1px solid rgb(234,67,53);border-radius:10px}.permission-denied[data-v-d4b4f36a]:hover{opacity:1;transform:scale(1.05)}.settings-container[data-v-d4b4f36a],.reactions-container[data-v-d4b4f36a]{position:relative}.settings-dropdown[data-v-d4b4f36a]{position:absolute;background:var(--7a7bd876);border-radius:var(--ff19aaae);box-shadow:0 4px 24px #0000004d;z-index:1000;width:var(--be676770);max-width:90vw;overflow:hidden;padding:6px;border:1px solid rgba(255,255,255,.1);color:var(--717c87dc)}.dropdown-content[data-v-d4b4f36a]{display:flex;flex-direction:column;gap:var(--2c4bd543)}.device-select[data-v-d4b4f36a]{display:flex;flex-direction:column}.select-wrapper[data-v-d4b4f36a]{position:relative;display:flex;align-items:center;background:var(--44473046);border-radius:var(--ff19aaae);padding:var(--9e9e5e2a) var(--11691f6a);border:1px solid rgba(255,255,255,.3)}.device-icon[data-v-d4b4f36a]{width:var(--a9615236);height:var(--a9615236);margin-right:8px;opacity:.7;color:var(--717c87dc)}.arrow-icon[data-v-d4b4f36a]{position:absolute;right:10px;top:50%;transform:translateY(-50%);width:var(--a9615236);height:var(--a9615236);color:var(--717c87dc);opacity:.7;pointer-events:none}.device-select select[data-v-d4b4f36a]{background:transparent;border:none;color:var(--f2f660b0);font-size:var(--7788f0ce);appearance:none;width:100%;padding:var(--e20baf50) var(--424dd5c3) var(--e20baf50) 0;background-image:none;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;height:100%;flex:1}.device-select select[data-v-d4b4f36a]:focus{outline:none}.device-select select option[data-v-d4b4f36a]{background:var(--ed0767a2);color:var(--f2f660b0);padding:var(--e20baf50);font-size:var(--7788f0ce)}.control-bar.position-bottom .settings-dropdown[data-v-d4b4f36a]{top:auto;bottom:100%;left:50%;transform:translate(-50%);margin-bottom:12px}.control-bar.position-top .settings-dropdown[data-v-d4b4f36a]{bottom:auto;top:100%;left:50%;transform:translate(-50%);margin-top:12px}.control-bar.position-left .settings-dropdown[data-v-d4b4f36a]{bottom:auto;top:50%;left:100%;transform:translateY(-50%);margin-left:12px}.control-bar.position-right .settings-dropdown[data-v-d4b4f36a]{bottom:auto;top:50%;right:100%;transform:translateY(-50%);margin-right:12px}.control-bar.no-background[data-v-d4b4f36a]{padding:0;background:transparent;backdrop-filter:none;border-radius:0;box-shadow:none}.controls-animation-enter-active[data-v-d4b4f36a],.controls-animation-leave-active[data-v-d4b4f36a]{transition:all .3s ease-in-out}.controls-animation-enter-from[data-v-d4b4f36a],.controls-animation-leave-to[data-v-d4b4f36a]{opacity:0;transform:scale(.8);width:0;height:0;margin-right:calc(-1 * var(--27398867) + "px");margin-left:calc(-1 * var(--27398867) + "px")}.mic-meter-wrapper[data-v-d4b4f36a]{width:100%;padding:6px 0}.mic-disabled-message[data-v-d4b4f36a]{width:100%;text-align:center;padding:4px 0 4px 6px;font-size:12px;opacity:.7;color:var(--f2f660b0)}@media (max-width: 480px){.settings-dropdown[data-v-d4b4f36a]{position:fixed;left:50%;right:auto;bottom:auto;transform:translate(-50%,-50%)}.dropdown-content[data-v-d4b4f36a]{max-height:80vh;overflow-y:auto}}.room-chat[data-v-2416e366]{display:flex;flex-direction:column;height:100%;background:#fefeff;color:#333;overflow:hidden;position:relative}.file-size-error-notification[data-v-2416e366]{padding:16px;animation:slideInFromBottom-2416e366 .3s ease-out}.error-content[data-v-2416e366]{background:gold;color:#8b4513;padding:12px 16px;border-radius:8px;display:flex;align-items:center;justify-content:space-between;box-shadow:0 4px 12px #00000026;border:1px solid #e6c200}.error-text[data-v-2416e366]{font-size:14px;font-weight:500;flex:1;margin-right:12px}.error-dismiss-button[data-v-2416e366]{background:none;border:none;color:#8b4513;font-size:18px;font-weight:700;cursor:pointer;padding:0;width:24px;height:24px;display:flex;align-items:center;justify-content:center;border-radius:50%;transition:background-color .2s}.error-dismiss-button[data-v-2416e366]:hover{background-color:#8b45131a}@keyframes slideInFromBottom-2416e366{0%{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}.room-chat.inside-player[data-v-2416e366]{background:transparent;color:#fff}.message-list[data-v-2416e366]{flex:1;overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:12px;scrollbar-width:none;-ms-overflow-style:none}.message-list[data-v-2416e366]::-webkit-scrollbar{display:none}.message-spacer[data-v-2416e366]{flex:1;min-height:0}.empty-state[data-v-2416e366]{flex:1;display:flex;align-items:center;justify-content:center;padding:40px 20px;text-align:center}.empty-state-content[data-v-2416e366]{max-width:300px;animation:fadeIn-2416e366 .5s ease-out}.empty-state-icon[data-v-2416e366]{margin-bottom:16px;display:flex;justify-content:center}.empty-state-illustration[data-v-2416e366]{margin-bottom:16px;object-fit:contain;display:block;margin-left:auto;margin-right:auto;width:100px;height:100px;@media (min-width: 768px){width:120px;height:120px}@media (min-width: 1024px){width:160px;height:160px}@media (min-width: 1440px){width:180px;height:180px}}.icon-circle-outer[data-v-2416e366]{width:56px;height:56px;border-radius:50%;background-color:#f0f4ff;display:flex;align-items:center;justify-content:center}.icon-circle-inner[data-v-2416e366]{width:40px;height:40px;border-radius:50%;background-color:#e0e7ff;display:flex;align-items:center;justify-content:center;color:#2563eb}.empty-state-heading[data-v-2416e366]{font-size:18px;font-weight:600;color:#333;margin:0 0 8px;line-height:1.3}.empty-state-message[data-v-2416e366]{font-size:14px;color:#666;margin:0;line-height:1.4}.room-chat.inside-player .empty-state-heading[data-v-2416e366]{color:#fff;text-shadow:0 1px 2px rgba(0,0,0,.5)}.room-chat.inside-player .empty-state-message[data-v-2416e366]{color:#fffc;text-shadow:0 1px 2px rgba(0,0,0,.5)}.room-chat.inside-player .icon-circle-outer[data-v-2416e366]{background-color:#ffffff0d;backdrop-filter:blur(8px)}.room-chat.inside-player .icon-circle-inner[data-v-2416e366]{background-color:#ffffff1a;color:#fffc}.message-wrapper[data-v-2416e366]{display:flex;gap:8px;align-items:flex-start}.message-wrapper.own-message[data-v-2416e366]{flex-direction:row}.message-avatar[data-v-2416e366]{flex-shrink:0}.message-content[data-v-2416e366]{display:flex;flex-direction:column;gap:4px;max-width:95%;width:fit-content;min-width:0;align-items:flex-start}.own-message .message-content[data-v-2416e366]{align-items:flex-start}.message-sender[data-v-2416e366]{font-size:12px;font-weight:600;color:#666;display:flex;align-items:center;gap:6px}.room-chat.inside-player .message-sender[data-v-2416e366]{color:#fff}.host-tag[data-v-2416e366]{background:#5773ff;color:#fff;font-size:10px;font-weight:600;padding:2px 6px;border-radius:8px;text-transform:uppercase;letter-spacing:.5px}.room-chat.inside-player .host-tag[data-v-2416e366]{background:#5773ffe6;backdrop-filter:blur(4px)}.message-bubble[data-v-2416e366]{background:#f8f9fa;padding:8px 12px;overflow-wrap:break-word;word-break:break-word;hyphens:auto;width:fit-content;border:1px solid #e9ecef;border-radius:16px;box-shadow:0 1px 2px #0000000d}.own-message .message-bubble[data-v-2416e366]{background:#e3f2fd;border-color:#bbdefb}.room-chat.inside-player .message-bubble[data-v-2416e366]{background:#ffffff26;padding:8px 12px;border:2px solid rgba(255,255,255,.2);width:fit-content;min-width:60px}.room-chat.inside-player .own-message .message-bubble[data-v-2416e366]{background:#e3f2fd33;border-color:#ffffff4d}.bubble-rounded[data-v-2416e366]{border-radius:16px}.bubble-square[data-v-2416e366]{border-radius:4px}.bubble-minimal[data-v-2416e366]{border-radius:0;background:transparent;padding:4px 0}.message-text[data-v-2416e366]{margin:0;line-height:1.5;font-size:16px;color:#333;text-align:left;overflow-wrap:break-word;word-break:break-word;hyphens:auto}.message-text.preserve-whitespace[data-v-2416e366]{white-space:pre-wrap}.message-attachment-container[data-v-2416e366]{margin:8px 0}.own-message .message-text[data-v-2416e366]{text-align:left}.room-chat.inside-player .message-text[data-v-2416e366]{color:#fff;text-align:left}.room-chat.inside-player .own-message .message-text[data-v-2416e366]{text-align:left}.message-timestamp[data-v-2416e366]{font-size:11px;opacity:.5;color:#666}.message-timestamp.inline[data-v-2416e366]{font-size:11px;opacity:.6;color:#999;font-weight:400}.room-chat.inside-player .message-timestamp[data-v-2416e366]{color:#fff}.room-chat.inside-player .message-timestamp.inline[data-v-2416e366]{color:#ffffffb3}.message-attachment-container[data-v-2416e366]{width:100%}.message-attachment[data-v-2416e366]{border-radius:8px;overflow:hidden}.image-attachment[data-v-2416e366]{cursor:pointer;max-width:300px}.attachment-preview-image[data-v-2416e366]{width:100%;height:auto;max-height:300px;object-fit:cover;display:block;border-radius:8px}.video-attachment[data-v-2416e366]{max-width:400px}.attachment-preview-video[data-v-2416e366]{width:100%;height:auto;max-height:300px;border-radius:8px;background:#000}.document-attachment[data-v-2416e366]{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:12px;background:#f8f9fa;border:1px solid #e5e5e5;border-radius:8px}.room-chat.inside-player .document-attachment[data-v-2416e366]{background:#ffffff1a;border-color:#fff3}.attachment-info[data-v-2416e366]{display:flex;align-items:center;gap:8px;flex:1;min-width:0}.attachment-details[data-v-2416e366]{display:flex;flex-direction:column;min-width:0;text-align:left}.own-message .attachment-details[data-v-2416e366]{text-align:left}.attachment-name[data-v-2416e366]{font-size:14px;font-weight:500;color:#333;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.room-chat.inside-player .attachment-name[data-v-2416e366]{color:#fff}.attachment-size[data-v-2416e366]{font-size:12px;color:#6c757d;margin-top:2px}.room-chat.inside-player .attachment-size[data-v-2416e366]{color:#ffffffb3}.room-chat.inside-player .attachment-details[data-v-2416e366],.room-chat.inside-player .own-message .attachment-details[data-v-2416e366]{text-align:left}.download-button[data-v-2416e366]{flex-shrink:0;width:36px;height:36px;background:#fff;border:1px solid #e5e5e5;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#6c757d;transition:all .2s}.download-button[data-v-2416e366]:hover{background:#f8f9fa;color:#495057;transform:scale(1.05)}.room-chat.inside-player .download-button[data-v-2416e366]{background:#ffffff1a;border-color:#ffffff4d;color:#fff}.room-chat.inside-player .download-button[data-v-2416e366]:hover{background:#fff3}.input-container[data-v-2416e366]{display:flex;flex-direction:column;gap:8px;padding:12px;background:#fff;border:1px solid #e5e5e5;border-radius:12px;margin:16px}.room-chat.inside-player .input-container[data-v-2416e366]{flex-direction:row;gap:8px;padding:12px;background:transparent;border:none;border-radius:0;margin:0;border-top:1px solid rgba(255,255,255,.1)}.input-wrapper[data-v-2416e366]{flex:1;display:flex;position:relative}.buttons-row[data-v-2416e366]{display:flex;justify-content:space-between;align-items:center}.icons-group[data-v-2416e366]{display:flex;align-items:center}.icons-group .attachment-button[data-v-2416e366],.icons-group .emoji-button[data-v-2416e366]{width:36px;height:36px}.message-input[data-v-2416e366]{flex:1;background:#f0f0f0;border:1px solid #d1d5db;transition:border-color .2s,box-shadow .2s;padding:0;color:#333;font-size:14px;outline:none;transition:all .2s}.message-input.standalone[data-v-2416e366]{width:100%;border:none;border-radius:12px;padding:12px 16px;min-height:44px;max-height:120px;box-sizing:border-box;resize:none;font-family:inherit;line-height:1.4;overflow-y:auto;scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.2) transparent}.message-input.standalone[data-v-2416e366]::-webkit-scrollbar{width:4px}.message-input.standalone[data-v-2416e366]::-webkit-scrollbar-track{background:transparent}.message-input.standalone[data-v-2416e366]::-webkit-scrollbar-thumb{background:#0003;border-radius:2px}.message-input.standalone[data-v-2416e366]::-webkit-scrollbar-thumb:hover{background:#0000004d}.room-chat.inside-player .message-input[data-v-2416e366]{background:#ffffff1a;border:1px solid rgba(255,255,255);border-radius:8px;padding:8px 12px;color:#fff}.message-input[data-v-2416e366]:focus{outline:none}.message-input.standalone[data-v-2416e366]:focus{background:#f0f0f0}.room-chat.inside-player .message-input[data-v-2416e366]:focus{background:#ffffff26;border-color:#ffffff4d}.message-input[data-v-2416e366]::placeholder{color:#999}.room-chat.inside-player .message-input[data-v-2416e366]::placeholder{color:#fff}.message-input[data-v-2416e366]:disabled{opacity:.5;cursor:not-allowed}.attachment-button[data-v-2416e366],.emoji-button[data-v-2416e366],.send-button[data-v-2416e366]{background:transparent;border:none;color:#6c757d;cursor:pointer;padding:8px;border-radius:8px;transition:all .2s;display:flex;align-items:center;justify-content:center}.attachment-button[data-v-2416e366]:hover,.emoji-button[data-v-2416e366]:hover{background:#0000000d;color:#495057}.room-chat.inside-player .attachment-button[data-v-2416e366],.room-chat.inside-player .emoji-button[data-v-2416e366],.room-chat.inside-player .send-button[data-v-2416e366]{color:#fff}.room-chat.inside-player .attachment-button[data-v-2416e366]:hover,.room-chat.inside-player .emoji-button[data-v-2416e366]:hover,.room-chat.inside-player .send-button[data-v-2416e366]:hover:not(:disabled){background:#ffffff1a}.attachment-button[data-v-2416e366]:disabled,.emoji-button[data-v-2416e366]:disabled,.send-button[data-v-2416e366]:disabled{opacity:.5;cursor:not-allowed}.send-button[data-v-2416e366]{background:#5773ff;color:#fff;width:36px;height:36px;border-radius:12px}.send-button[data-v-2416e366]:hover:not(:disabled){background:#4361ee}.room-chat.inside-player .send-button[data-v-2416e366]{background:#0084ff;color:#fff;width:36px;height:36px}.room-chat.inside-player .send-button[data-v-2416e366]:hover:not(:disabled){background:#0073e6}.room-chat.inside-player .input-wrapper .attachment-button[data-v-2416e366]{position:static;margin-right:8px}.room-chat.inside-player[data-v-2416e366]{position:absolute;bottom:0;left:0;right:0;height:40%;max-height:400px;z-index:50}.room-chat.inside-player .message-list[data-v-2416e366]{background:transparent;padding:12px 16px;max-height:calc(100% - 60px);mask:linear-gradient(to bottom,transparent 0%,black 10%,black 100%);-webkit-mask:linear-gradient(to bottom,transparent 0%,black 10%,black 100%)}.room-chat.inside-player .message-wrapper.own-message[data-v-2416e366]{flex-direction:row}.room-chat.inside-player .own-message .message-content[data-v-2416e366]{align-items:flex-start}.room-chat.inside-player .message-content[data-v-2416e366]{width:auto}.file-preview[data-v-2416e366]{display:flex;align-items:center;gap:12px;background:#f0f2f5;border-radius:8px;width:100%;padding:12px;box-sizing:border-box}.file-icon[data-v-2416e366]{flex-shrink:0;width:40px;height:40px;background:#e9ecef;border-radius:8px;display:flex;align-items:center;justify-content:center;color:#6c757d}.file-preview-thumbnail[data-v-2416e366]{flex-shrink:0;width:40px;height:40px;border-radius:8px;overflow:hidden}.file-preview-thumbnail img[data-v-2416e366]{width:100%;height:100%;object-fit:cover}.file-info[data-v-2416e366]{flex:1;min-width:0}.file-name[data-v-2416e366]{font-size:14px;font-weight:500;color:#333;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.file-size[data-v-2416e366]{font-size:12px;color:#6c757d;margin-top:2px}.file-remove-button[data-v-2416e366]{flex-shrink:0;width:32px;height:32px;background:transparent;border:none;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#6c757d;transition:all .2s}.file-remove-button[data-v-2416e366]:hover:not(:disabled){background:#0000000d;color:#dc3545}.file-remove-button[data-v-2416e366]:disabled{opacity:.5;cursor:not-allowed}.progress-ring[data-v-2416e366]{animation:rotate-2416e366 2s linear infinite}.progress-ring-circle[data-v-2416e366]{transition:stroke-dasharray .3s ease}@keyframes rotate-2416e366{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.loading-more-indicator[data-v-2416e366]{display:flex;align-items:center;justify-content:center;gap:8px;padding:16px;margin-bottom:8px;animation:fadeInDown-2416e366 .3s ease-out}.loading-spinner[data-v-2416e366]{width:16px;height:16px;border:2px solid #e5e5e5;border-top:2px solid #5773ff;border-radius:50%;animation:spin-2416e366 1s linear infinite}.loading-text[data-v-2416e366]{font-size:12px;color:#666;font-weight:500}.room-chat.inside-player .loading-text[data-v-2416e366]{color:#fffc}.room-chat.inside-player .loading-spinner[data-v-2416e366]{border-color:#ffffff4d;border-top-color:#fff}.no-more-indicator[data-v-2416e366]{display:flex;align-items:center;justify-content:center;padding:12px;margin-bottom:8px;animation:fadeInDown-2416e366 .3s ease-out}.no-more-text[data-v-2416e366]{font-size:11px;color:#999;text-align:center}.room-chat.inside-player .no-more-text[data-v-2416e366]{color:#fff9}.initial-loading-bottom[data-v-2416e366]{padding:16px;animation:slideInFromBottom-2416e366 .4s ease-out;background:#00000003}.message-skeleton[data-v-2416e366]{display:flex;gap:8px;align-items:flex-start;margin-bottom:16px;animation:pulse-2416e366 1.5s ease-in-out infinite}.skeleton-avatar[data-v-2416e366]{width:32px;height:32px;border-radius:50%;background:linear-gradient(90deg,#f0f0f0 25%,#e0e0e0,#f0f0f0 75%);background-size:200% 100%;animation:shimmer-2416e366 1.5s infinite}.skeleton-content[data-v-2416e366]{flex:1;display:flex;flex-direction:column;gap:6px;max-width:70%}.skeleton-name[data-v-2416e366]{width:80px;height:12px;border-radius:6px;background:linear-gradient(90deg,#f0f0f0 25%,#e0e0e0,#f0f0f0 75%);background-size:200% 100%;animation:shimmer-2416e366 1.5s infinite}.skeleton-text[data-v-2416e366]{height:14px;border-radius:7px;background:linear-gradient(90deg,#f0f0f0 25%,#e0e0e0,#f0f0f0 75%);background-size:200% 100%;animation:shimmer-2416e366 1.5s infinite}.skeleton-text[data-v-2416e366]:not(.short){width:100%}.skeleton-text.short[data-v-2416e366]{width:60%}.room-chat.inside-player .initial-loading-bottom[data-v-2416e366]{background:#ffffff0d;padding:8px 16px}.room-chat.inside-player .message-skeleton[data-v-2416e366]{margin-bottom:8px}.room-chat.inside-player .skeleton-avatar[data-v-2416e366],.room-chat.inside-player .skeleton-name[data-v-2416e366],.room-chat.inside-player .skeleton-text[data-v-2416e366]{background:linear-gradient(90deg,#ffffff1a 25%,#fff3,#ffffff1a 75%);background-size:200% 100%}.new-message-notification[data-v-2416e366]{position:absolute;bottom:180px;left:50%;transform:translate(-50%);background:#5773ff;color:#fff;border:none;border-radius:24px;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px;padding:6px 10px;box-shadow:0 4px 12px #5773ff4d;transition:all .3s cubic-bezier(.4,0,.2,1);z-index:10;min-width:120px}.new-message-notification[data-v-2416e366]:hover{transform:translate(-50%) translateY(-2px);box-shadow:0 6px 20px #5773ff66;background:#4361ee}.new-message-notification[data-v-2416e366]:active{transform:translate(-50%) translateY(0)}.new-message-text[data-v-2416e366]{font-size:13px;font-weight:500}.room-chat.inside-player .new-message-notification[data-v-2416e366]{background:#000c;backdrop-filter:blur(10px);box-shadow:0 4px 12px #0006;bottom:80px}.room-chat.inside-player .new-message-notification[data-v-2416e366]:hover{background:#000000e6;box-shadow:0 6px 20px #00000080}.scroll-to-bottom-button[data-v-2416e366]{position:absolute;bottom:140px;right:16px;width:48px;height:48px;background:#5773ff;color:#fff;border:none;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 12px #5773ff4d;transition:all .3s cubic-bezier(.4,0,.2,1);z-index:10}.scroll-to-bottom-button[data-v-2416e366]:hover{transform:translateY(-2px);box-shadow:0 6px 20px #5773ff66}.scroll-to-bottom-button[data-v-2416e366]:active{transform:translateY(0)}.scroll-to-bottom-button.inside-player[data-v-2416e366]{background:#000000b3;backdrop-filter:blur(10px);box-shadow:0 4px 12px #0000004d}.scroll-to-bottom-button.inside-player[data-v-2416e366]:hover{background:#000c;box-shadow:0 6px 20px #0006}.scroll-button-enter-active[data-v-2416e366],.scroll-button-leave-active[data-v-2416e366]{transition:all .3s cubic-bezier(.4,0,.2,1)}.scroll-button-enter-from[data-v-2416e366],.scroll-button-leave-to[data-v-2416e366]{opacity:0;transform:translateY(20px) scale(.8)}.new-message-notification-enter-active[data-v-2416e366],.new-message-notification-leave-active[data-v-2416e366]{transition:all .3s cubic-bezier(.4,0,.2,1)}.new-message-notification-enter-from[data-v-2416e366],.new-message-notification-leave-to[data-v-2416e366]{opacity:0;transform:translate(-50%) translateY(20px) scale(.9)}@keyframes spin-2416e366{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes shimmer-2416e366{0%{background-position:-200% 0}to{background-position:200% 0}}@keyframes fadeIn-2416e366{0%{opacity:0}to{opacity:1}}@keyframes fadeInDown-2416e366{0%{opacity:0;transform:translateY(-10px)}to{opacity:1;transform:translateY(0)}}@keyframes pulse-2416e366{0%,to{opacity:1}50%{opacity:.7}}@keyframes bounce-2416e366{0%,20%,53%,80%,to{transform:translateZ(0)}40%,43%{transform:translate3d(0,-8px,0)}70%{transform:translate3d(0,-4px,0)}90%{transform:translate3d(0,-2px,0)}}@media (max-width: 768px){.message-list[data-v-2416e366]{padding:12px}.message-content[data-v-2416e366]{max-width:85%}.input-container[data-v-2416e366]{padding:8px}.room-chat.inside-player[data-v-2416e366]{height:50%;max-height:300px}.image-attachment[data-v-2416e366],.video-attachment[data-v-2416e366]{max-width:100%}.attachment-preview-image[data-v-2416e366],.attachment-preview-video[data-v-2416e366]{max-height:200px}.document-attachment[data-v-2416e366]{padding:10px}.attachment-name[data-v-2416e366]{font-size:13px}.scroll-to-bottom-button[data-v-2416e366]{width:44px;height:44px;bottom:70px;right:12px}.loading-more-indicator[data-v-2416e366],.initial-loading[data-v-2416e366]{padding:12px}}')),document.head.appendChild(e)}}catch(a){console.error("vite-plugin-css-injected-by-js",a)}})();
var ba = Object.defineProperty, wa = Object.defineProperties;
var Ca = Object.getOwnPropertyDescriptors;
var la = Object.getOwnPropertySymbols;
var Pa = Object.prototype.hasOwnProperty, Ra = Object.prototype.propertyIsEnumerable;
var ca = (O, M, k) => M in O ? ba(O, M, { enumerable: !0, configurable: !0, writable: !0, value: k }) : O[M] = k, y = (O, M) => {
  for (var k in M || (M = {}))
    Pa.call(M, k) && ca(O, k, M[k]);
  if (la)
    for (var k of la(M))
      Ra.call(M, k) && ca(O, k, M[k]);
  return O;
}, wt = (O, M) => wa(O, Ca(M));
var me = (O, M, k) => new Promise((e, s) => {
  var C = (a) => {
    try {
      v(k.next(a));
    } catch (b) {
      s(b);
    }
  }, g = (a) => {
    try {
      v(k.throw(a));
    } catch (b) {
      s(b);
    }
  }, v = (a) => a.done ? e(a.value) : Promise.resolve(a.value).then(C, g);
  v((k = k.apply(O, M)).next());
});
import { inject as Pe, ref as A, computed as n, watch as Ce, nextTick as Lt, watchEffect as Bt, onUnmounted as ut, reactive as Ta, readonly as Qt, defineComponent as je, provide as at, onMounted as ht, createElementBlock as c, openBlock as i, renderSlot as _t, mergeProps as Ea, normalizeStyle as I, createElementVNode as t, createBlock as be, createCommentVNode as F, toDisplayString as se, withModifiers as Ze, normalizeClass as De, createVNode as Q, Teleport as jt, Fragment as He, renderList as tt, unref as S, withDirectives as ta, vModelText as aa, useCssVars as oa, Transition as na, withCtx as nt, TransitionGroup as Ma, createTextVNode as Aa, withKeys as ua } from "vue";
import { c as Ut, e as st, w as xa, x as Ia, f as $a, y as za, h as La, u as Gt, O as Ba, a as Kt, v as sa, N as Wt, A as Yt, j as _a, z as Na, B as Fa, k as Ha, l as Da, C as vt, P as ha, m as pt, n as Oa, o as Va, p as ja, q as Wa, r as Ua, s as Ga, t as Ka } from "./useChatPagination-x-ZuSkpz.js";
import { T as ve, c as da, d as Ya, e as Ja, t as Za, R as et, P as Dt, C as Ot } from "./live-vendor-DtCPNuLC.js";
import { a as Xa, j as fa, M as Le, A as Qa, L as qt } from "./index-BmGD5jiK.js";
import { _ as We } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { u as ya } from "./useContainerObserver-vDxyyGDS.js";
import { h as mt, e as $t, i as ia, k as qa, d as en, _ as tn, a as Vt, l as an, f as nn, b as ea, g as pa, j as va } from "./SpeakerIcon.vue_vue_type_script_setup_true_lang-B7QhZ13r.js";
import { b as ga, T as ka, _ as on, R as sn, c as rn, a as ln } from "./TripleDotIcon-CnE5eu_G.js";
function cn(O, M, k) {
  const { remoteParticipants: e } = Ut(), s = st(), C = M || Pe("speechDetection"), g = k || Pe("raiseHand"), v = A("grid"), a = A([]), b = A(null), r = A(/* @__PURE__ */ new Map()), u = A([]), m = A([]), V = A(!1), h = A(Date.now()), D = A(/* @__PURE__ */ new Set()), T = A(/* @__PURE__ */ new Set()), f = A(/* @__PURE__ */ new Set()), w = n(() => {
    if (typeof window == "undefined") return "desktop";
    const E = window.innerWidth;
    return E < 768 ? "mobile" : E < 1024 ? "tablet" : "desktop";
  }), j = n(() => {
    switch (w.value) {
      case "mobile":
        return 6;
      case "tablet":
        return 10;
      case "desktop":
        return 16;
      default:
        return 10;
    }
  }), p = n(() => {
    switch (w.value) {
      case "mobile":
        return 6;
      case "tablet":
        return 12;
      case "desktop":
        return 16;
      default:
        return 16;
    }
  }), z = n(() => {
    switch (w.value) {
      case "mobile":
        return 6;
      case "tablet":
        return 12;
      case "desktop":
        return 16;
      default:
        return 16;
    }
  }), R = n(() => {
    switch (w.value) {
      case "mobile":
        return 2;
      case "tablet":
        return 4;
      case "desktop":
        return 6;
      default:
        return 6;
    }
  }), U = n(() => {
    var W;
    const E = [], _ = (W = s.value) == null ? void 0 : W.localParticipant;
    return _ && E.push(_), e.value && E.push(
      ...e.value
    ), E;
  }), Z = (E) => {
    const _ = new Set(u.value);
    return E.some(
      (Y) => !_.has(Y)
    );
  }, H = (E, _) => {
    !_.some(
      (Y) => !D.value.has(Y)
    ) && E === "active-speakers-changed" || Z(_) && (m.value = [..._], u.value = [..._], V.value = !0, h.value = Date.now(), Lt(() => {
      V.value = !1, m.value = [];
    }));
  }, ee = (E) => {
    T.value = new Set(E), we();
  }, ae = (E) => {
    f.value = new Set(E), we();
  }, we = () => {
    const E = /* @__PURE__ */ new Set();
    T.value.forEach((_) => E.add(_)), f.value.forEach((_) => E.add(_)), D.value = E;
  }, Te = (E, _ = {}) => {
    const { excludePinned: W = !1 } = _, Y = new Set(
      E.filter((ue) => ue.type === "screen-share").map((ue) => {
        var re;
        return (re = ue.screenShare) == null ? void 0 : re.participant.identity;
      }).filter(Boolean)
    ), oe = (ue) => {
      var Me, Ne;
      if (ue.type === "screen-share")
        return (Ne = (Me = ue.screenShare) == null ? void 0 : Me.participant) != null && Ne.identity, 0;
      if (ue.type !== "participant" || !ue.participant) return 999;
      const re = ue.participant.identity;
      if (!re) return 999;
      const Se = s.value, Ie = (Se == null ? void 0 : Se.localParticipant.identity) === re ? Se.localParticipant : Se == null ? void 0 : Se.remoteParticipants.get(re), ne = Y.has(re), $e = ye(ue);
      return $e && X.value.length === 0 ? ne ? 0.5 : 1 : ($e && X.value.length > 0, m.value.includes(re) ? ne ? 1.5 : 2 : (g == null ? void 0 : g.getParticipantHandState(re)) || !1 ? ne ? 2.5 : 3 : Ie != null && Ie.lastSpokeAt && Date.now() - Ie.lastSpokeAt.getTime() < 1e4 ? ne ? 3.5 : 4 : Ie != null && Ie.isCameraEnabled ? ne ? 4.5 : 5 : ne ? 5.5 : 6);
    };
    let ce = E;
    if (W) {
      const ue = new Set(a.value.map((re) => re.id));
      ce = E.filter((re) => !ue.has(re.id));
    }
    return ce.sort((ue, re) => {
      var Me, Ne, Je, qe;
      const Se = s.value, Ie = ((Me = ue.participant) == null ? void 0 : Me.identity) === (Se == null ? void 0 : Se.localParticipant.identity), ne = ((Ne = re.participant) == null ? void 0 : Ne.identity) === (Se == null ? void 0 : Se.localParticipant.identity);
      if (Ie && !ne) return -1;
      if (!Ie && ne) return 1;
      const $e = oe(ue), Qe = oe(re);
      if ($e !== Qe)
        return $e - Qe;
      const Oe = ((Je = ue.participant) == null ? void 0 : Je.identity) || ue.id, Ye = ((qe = re.participant) == null ? void 0 : qe.identity) || re.id;
      return Oe.localeCompare(Ye);
    });
  };
  C.onActiveSpeakersChange((E) => {
    H("active-speakers-changed", E);
  });
  const Ue = n(() => {
    const E = C.getInstantActiveSpeaker();
    return E && U.value.find((_) => _.identity === E) || null;
  }), _e = xa(Ue, 150), Ge = n(() => {
    if (_e.value)
      return _e.value;
    const E = s.value;
    if (E) {
      const W = Date.now();
      let Y = null, oe = 0;
      if (U.value.forEach((ce) => {
        const ue = E.localParticipant.identity === ce.identity ? E.localParticipant : E.remoteParticipants.get(ce.identity);
        if (ue != null && ue.lastSpokeAt) {
          const re = ue.lastSpokeAt.getTime();
          W - re < 1e4 && re > oe && (Y = ce, oe = re);
        }
      }), Y)
        return Y;
    }
    const _ = U.value.find((W) => W.isLocal);
    return _ || U.value[0] || null;
  }), X = A([]), Re = () => {
    const E = [], _ = O.trackReferences.value;
    U.value.forEach((W) => {
      _.filter(
        (oe) => oe.participant.identity === W.identity && oe.source === ve.Source.ScreenShare
      ).forEach((oe, ce) => {
        var ue, re;
        if ((ue = oe.publication) != null && ue.track && ((re = oe.publication) == null ? void 0 : re.isSubscribed) !== !1) {
          const Se = `${W.identity}-screenshare`;
          r.value.has(Se) || r.value.set(Se, Date.now()), E.push({
            id: Se,
            type: "screen-share",
            screenShare: {
              participant: W,
              track: {
                trackSid: oe.publication.trackSid,
                trackName: oe.publication.trackName || "Screen Share",
                source: ve.Source.ScreenShare
              },
              startTime: r.value.get(Se) || Date.now()
            }
          });
        }
      });
    }), E.sort((W, Y) => {
      var ue, re;
      const oe = ((ue = W.screenShare) == null ? void 0 : ue.startTime) || 0, ce = ((re = Y.screenShare) == null ? void 0 : re.startTime) || 0;
      return oe - ce;
    }), X.value = E;
  };
  Re();
  const he = () => {
    Re();
  }, de = n(() => {
    const E = [];
    return U.value.forEach((_) => {
      E.push({
        id: _.identity,
        type: "participant",
        participant: _
      });
    }), E.push(...X.value), E.forEach((_) => {
      _.type === "participant" || _.type;
    }), E;
  });
  Ce(
    [v, U],
    ([E, _], [W, Y]) => {
    }
  );
  const Ae = () => {
    const E = a.value.length;
    if (X.value.length > 0)
      return {
        entities: [
          X.value[X.value.length - 1]
        ],
        // Latest screenshare
        mode: "fullscreen"
      };
    if (E === 1)
      return {
        entities: [a.value[0]],
        mode: "fullscreen"
      };
    if (E >= 2)
      return {
        entities: a.value,
        mode: "grid"
      };
    switch (v.value) {
      case "speaker":
        return o();
      case "grid":
        return d();
      case "auto":
        return L();
      default:
        return { entities: [], mode: "empty" };
    }
  }, Ee = n(() => Ae()), Ve = (E, _, W) => {
    const Y = E.filter(
      (re) => !_.has(re.identity)
    ), oe = s.value, ce = oe == null ? void 0 : oe.localParticipant;
    return Y.sort((re, Se) => {
      const Ie = re.identity === (ce == null ? void 0 : ce.identity), ne = Se.identity === (ce == null ? void 0 : ce.identity);
      if (Ie && !ne) return -1;
      if (!Ie && ne) return 1;
      const $e = (Ye) => {
        const Me = Ye.identity;
        if (!Me) return 999;
        const Ne = (oe == null ? void 0 : oe.localParticipant.identity) === Me ? oe.localParticipant : oe == null ? void 0 : oe.remoteParticipants.get(Me);
        return m.value.includes(Me) ? 1 : (g == null ? void 0 : g.getParticipantHandState(Me)) || !1 ? 2 : Ne != null && Ne.lastSpokeAt && Date.now() - Ne.lastSpokeAt.getTime() < 1e4 ? 3 : Ne != null && Ne.isCameraEnabled ? 4 : 5;
      }, Qe = $e(re), Oe = $e(Se);
      return Qe !== Oe ? Qe - Oe : re.identity.localeCompare(Se.identity);
    });
  }, Ke = (E, _, W) => Ve(
    E,
    _
  ), o = () => {
    if (X.value.length > 0)
      return {
        entities: [
          X.value[X.value.length - 1]
        ],
        // Latest share
        mode: "fullscreen"
      };
    if (a.value.length > 0)
      return {
        entities: a.value,
        mode: a.value.length === 1 ? "fullscreen" : "grid"
      };
    const E = C.getInstantActiveSpeaker();
    if (E) {
      const Y = de.value.find(
        (oe) => {
          var ce;
          return oe.type === "participant" && ((ce = oe.participant) == null ? void 0 : ce.identity) === E;
        }
      );
      if (Y)
        return {
          entities: [Y],
          mode: "fullscreen"
        };
    }
    if (_e.value) {
      const Y = de.value.find(
        (oe) => {
          var ce, ue;
          return oe.type === "participant" && ((ce = oe.participant) == null ? void 0 : ce.identity) === ((ue = _e.value) == null ? void 0 : ue.identity);
        }
      );
      if (Y)
        return {
          entities: [Y],
          mode: "fullscreen"
        };
    }
    const _ = de.value.filter(
      (Y) => Y.type === "participant"
    );
    for (const Y of _)
      if (Y.participant && C.getRecentSpeakerStatus(
        Y.participant.identity
      ))
        return {
          entities: [Y],
          mode: "fullscreen"
        };
    const W = Te(
      _,
      {
        excludePinned: !1
      }
    );
    return W.length > 0 ? {
      entities: [W[0]],
      mode: "fullscreen"
    } : { entities: [], mode: "empty" };
  }, d = () => {
    if (X.value.length > 0)
      return {
        entities: [
          X.value[X.value.length - 1]
        ],
        mode: "fullscreen"
      };
    const E = de.value.filter(
      (W) => W.type === "participant"
    );
    return {
      entities: Te(
        E,
        {
          excludePinned: !1
        }
      ),
      mode: "grid"
    };
  }, L = () => {
    if (X.value.length > 0)
      return {
        entities: [
          X.value[X.value.length - 1]
        ],
        mode: "fullscreen"
      };
    const E = de.value.filter(
      (W) => W.type === "participant"
    ), _ = Te(
      E,
      {
        excludePinned: !1
      }
    );
    return _.length > 0 ? {
      entities: _,
      // Send ALL, no slicing
      mode: "grid"
    } : { entities: [], mode: "empty" };
  }, K = n(() => {
    if (!le())
      return {
        entities: [],
        visible: !1,
        capacity: j.value
      };
    const _ = Ee.value.entities.map((ce) => ce.id), W = de.value.filter(
      (ce) => !_.includes(ce.id)
    );
    return W.forEach((ce) => {
      ce.type === "participant" || ce.type;
    }), {
      entities: Te(
        W,
        {
          excludePinned: !0
        }
      ).slice(0, j.value),
      visible: !0,
      capacity: j.value
    };
  }), le = () => v.value === "grid" ? X.value.length > 0 ? !0 : a.value.length > 0 : v.value === "speaker" ? !0 : v.value === "auto" ? X.value.length > 0 ? !0 : a.value.length > 0 ? de.value.filter(
    (Y) => Y.type === "participant"
  ).length - a.value.length > 0 : de.value.filter(
    (_) => _.type === "participant"
  ).length > p.value : !0, Be = (E) => {
    v.value = E, E !== "auto" && (b.value = null);
  }, Xe = () => {
    a.value = [];
  }, fe = (E) => {
    const _ = a.value.findIndex((W) => W.id === E.id);
    if (_ > -1)
      a.value.splice(_, 1);
    else {
      const W = z.value;
      a.value.length >= W && a.value.shift(), a.value.push(E);
    }
  }, xe = (E) => {
    const _ = de.value.find(
      (W) => {
        var Y;
        return W.type === "participant" && ((Y = W.participant) == null ? void 0 : Y.identity) === E.identity;
      }
    );
    _ && fe(_);
  }, ye = (E) => a.value.some((_) => _.id === E.id), G = (E) => {
    const _ = de.value.find(
      (W) => {
        var Y;
        return W.type === "participant" && ((Y = W.participant) == null ? void 0 : Y.identity) === E.identity;
      }
    );
    return _ ? a.value.some((W) => W.id === _.id) : !1;
  }, ke = () => {
    v.value = "auto", a.value = [], b.value = null, r.value.clear();
  }, rt = (E) => {
    const _ = a.value.length;
    a.value = a.value.filter((W) => {
      var Y, oe;
      return W.type === "participant" ? ((Y = W.participant) == null ? void 0 : Y.identity) !== E : W.type === "screen-share" ? ((oe = W.screenShare) == null ? void 0 : oe.participant.identity) !== E : !0;
    }), _ - a.value.length;
  };
  return Ce(X, (E, _) => {
    if (_ && _.length > 0) {
      const W = new Set(E.map((Y) => Y.id));
      _.forEach((Y) => {
        W.has(Y.id) || r.value.delete(Y.id);
      });
    }
    v.value === "auto" && E.length === 0 && _ && _.length > 0 && (b.value = null);
  }), {
    // Core State
    layoutMode: v,
    pinnedEntities: a,
    deviceType: w,
    // Computed Zones
    stageZone: Ee,
    filmstripZone: K,
    // Entity Collections
    allParticipants: U,
    allEntities: de,
    activeSpeaker: _e,
    speakerModeParticipant: Ge,
    screenShareEntities: X,
    // Methods
    setLayoutMode: Be,
    toggleEntityPin: fe,
    toggleParticipantPin: xe,
    // Legacy
    isPinned: ye,
    isParticipantPinned: G,
    // Legacy
    clearAllPins: Xe,
    resetLayout: ke,
    removePinByParticipantId: rt,
    // Screenshare updates
    triggerScreenShareUpdate: he,
    // Priority system (shared between Stage and Filmstrip)
    prioritizeEntitiesByActivity: Te,
    // 🌟 NEW: Controlled strip participants for ParticipantStrip.vue (PHASE 5)
    getControlledStripParticipants: Ke,
    // Capacity
    filmstripCapacity: j,
    autoModeGridCapacity: p,
    // 🌟 SIMPLE APPROACH: Basic info
    stageCapacity: z,
    stripCapacity: R,
    hasNewActiveSpeakers: Z,
    // 🌟 NEW: Controlled priority recalculation (PHASE 4)
    triggerPriorityRecalculation: H,
    shouldRecalculatePriority: n(() => V.value),
    lastPriorityUpdate: n(() => h.value),
    // ✅ SIMPLE: Update visible participants from components (separate to avoid race conditions)
    updateStageVisibleParticipants: ee,
    updateStripVisibleParticipants: ae
  };
}
function ma(O, M) {
  const k = A(M);
  return Bt((e) => {
    if (!O) {
      k.value = M;
      return;
    }
    const s = O.subscribe({
      next: (C) => {
        k.value = C;
      },
      error: (C) => {
      }
    });
    e(() => {
      s.unsubscribe();
    });
  }), k;
}
function un() {
  const O = st(), M = A(/* @__PURE__ */ new Map()), k = A(/* @__PURE__ */ new Map()), e = /* @__PURE__ */ new Map(), s = ma(
    n(() => {
      const w = O.value;
      if (w) {
        const j = da(w);
        return j.subscribe({
          next: (p) => {
          },
          error: (p) => {
          }
        }), j;
      }
    }).value,
    []
  ), C = ma(
    n(() => {
      const w = O.value;
      if (w)
        return da(w).pipe(
          Ya(500)
          // 500ms debounce
        );
    }).value,
    []
  );
  let g = null;
  const v = (w) => {
    g = w;
  };
  Ce(C, (w) => {
    if (g) {
      const j = w.map((p) => p.identity);
      g(j);
    }
  });
  const a = (w) => {
    const j = w.identity;
    if (e.has(j))
      return;
    O.value, w.getTrackPublication(
      ve.Source.Microphone
    );
    const z = Ja(w).subscribe({
      next: (ee) => {
        M.value.set(j, ee), w.getTrackPublication(
          ve.Source.Microphone
        );
      },
      error: (ee) => {
      }
    });
    let R = null;
    const U = () => {
      R = setInterval(() => {
        k.value.set(j, w.audioLevel);
      }, 200);
    }, Z = () => {
      R && (clearInterval(R), R = null);
    };
    U();
    const H = {
      unsubscribe: Z
    };
    e.set(j, {
      speakingSubscription: z,
      audioLevelSubscription: H
    }), M.value.set(j, w.isSpeaking), k.value.set(j, w.audioLevel);
  }, b = (w) => {
    const j = e.get(w);
    j && (j.speakingSubscription.unsubscribe(), j.audioLevelSubscription.unsubscribe(), e.delete(w), M.value.delete(w), k.value.delete(w));
  }, r = (w) => {
    const j = M.value.get(w) || !1, p = T(w);
    return p == null || p.getTrackPublication(
      ve.Source.Microphone
    ), j;
  }, u = (w) => k.value.get(w) || 0, m = () => {
    var w;
    return ((w = s.value[0]) == null ? void 0 : w.identity) || null;
  }, V = (w) => M.value.get(w) || !1, h = (w) => {
    const j = T(w);
    return j != null && j.lastSpokeAt ? Date.now() - j.lastSpokeAt.getTime() < 1e4 : !1;
  }, D = () => {
    var w;
    return ((w = s.value[0]) == null ? void 0 : w.identity) || null;
  }, T = (w) => {
    const j = O.value;
    return j ? j.localParticipant.identity === w ? j.localParticipant : j.remoteParticipants.get(w) || null : null;
  }, f = () => {
    e.forEach((w, j) => {
      w.speakingSubscription.unsubscribe(), w.audioLevelSubscription.unsubscribe();
    }), e.clear(), M.value.clear(), k.value.clear();
  };
  return ut(() => {
    f();
  }), {
    // Main API methods
    getParticipantSpeakingStatus: r,
    getParticipantAudioLevel: u,
    getFirstActiveSpeaker: m,
    // Additional API methods (for useRoomLayout compatibility)
    getActiveSpeakerStatus: V,
    getRecentSpeakerStatus: h,
    getInstantActiveSpeaker: D,
    // Lifecycle management
    setupRemoteAudioAnalysis: a,
    cleanupAudioAnalysis: b,
    cleanup: f,
    // Reactive state for debugging/monitoring
    activeSpeakers: n(() => s.value),
    participantSpeakingStates: n(() => M.value),
    // 🌟 NEW: Debounced active speakers for layout updates (PHASE 3)
    debouncedActiveSpeakers: n(
      () => C.value.map((w) => w.identity)
    ),
    onActiveSpeakersChange: v
  };
}
function dn() {
  const O = A([]), M = A(null), k = (a) => {
    M.value && (M.value.unsubscribe(), M.value = null);
    const b = Za(
      a,
      [ve.Source.Camera, ve.Source.Microphone, ve.Source.ScreenShare],
      {
        onlySubscribed: !1,
        // Get all tracks (subscribed and unsubscribed)
        additionalRoomEvents: [
          et.TrackMuted,
          et.TrackUnmuted,
          et.TrackPublished,
          et.TrackUnpublished,
          et.TrackSubscribed,
          et.TrackUnsubscribed
        ]
      }
    ).subscribe({
      next: ({ trackReferences: r }) => {
        O.value = r;
      },
      error: (r) => {
      }
    });
    M.value = b;
  }, e = (a, b) => O.value.filter(
    (r) => r.participant.identity === a && b.includes(r.source)
  );
  return {
    // State
    trackReferences: O,
    // Methods
    setupTrackObservable: k,
    getParticipantTrackReferences: e,
    hasVideoTrack: (a) => e(a, [
      ve.Source.Camera
    ]).some(
      (r) => {
        var u, m, V;
        return ((u = r.publication) == null ? void 0 : u.track) && ((m = r.publication) == null ? void 0 : m.isSubscribed) !== !1 && !((V = r.publication) != null && V.isMuted);
      }
    ),
    hasAudioTrack: (a) => e(a, [
      ve.Source.Microphone
    ]).some(
      (r) => {
        var u, m, V;
        return ((u = r.publication) == null ? void 0 : u.track) && ((m = r.publication) == null ? void 0 : m.isSubscribed) !== !1 && !((V = r.publication) != null && V.isMuted);
      }
    ),
    hasScreenShare: (a) => e(a, [
      ve.Source.ScreenShare
    ]).some(
      (r) => {
        var u, m;
        return ((u = r.publication) == null ? void 0 : u.track) && ((m = r.publication) == null ? void 0 : m.isSubscribed) !== !1;
      }
    ),
    cleanup: () => {
      M.value && (M.value.unsubscribe(), M.value = null), O.value = [];
    }
  };
}
function pn() {
  const O = st(), { participants: M } = Ut(), k = A(!1), e = A(null), s = Ta(/* @__PURE__ */ new Map()), C = (p) => {
    try {
      if (!p) return null;
      let z;
      return typeof p == "string" ? z = JSON.parse(p) : z = p, z.handRaised !== void 0 ? {
        handRaised: !!z.handRaised,
        timestamp: typeof z.handRaisedTimestamp == "number" ? z.handRaisedTimestamp : void 0
      } : null;
    } catch (z) {
      return null;
    }
  }, g = (p) => {
    const z = O.value;
    if (!z) return JSON.stringify({ handRaised: p });
    let R = {};
    try {
      const H = z.localParticipant.metadata;
      H && (R = typeof H == "string" ? JSON.parse(H) : H);
    } catch (H) {
    }
    const U = p ? Date.now() : void 0, Z = wt(y({}, R), {
      handRaised: p,
      handRaisedTimestamp: U
    });
    return JSON.stringify(Z);
  }, v = (p) => s.get(p) || !1, a = (p) => {
    const z = C(p.metadata);
    return (z == null ? void 0 : z.handRaised) || !1;
  }, b = () => {
    const p = O.value;
    if (!p) return [];
    const z = [];
    return a(p.localParticipant) && z.push(p.localParticipant), p.remoteParticipants.forEach((R) => {
      a(R) && z.push(R);
    }), z;
  }, r = n(() => b()), u = n(() => r.value.length), m = () => me(this, null, function* () {
    const p = O.value;
    if (p)
      try {
        const z = !k.value, R = g(z);
        e.value = R, k.value = z, s.set(p.localParticipant.identity, z), yield p.localParticipant.setMetadata(R), setTimeout(() => {
          e.value === R && (e.value = null);
        }, 500);
      } catch (z) {
        const R = C(p.localParticipant.metadata);
        throw k.value = (R == null ? void 0 : R.handRaised) || !1, s.set(
          p.localParticipant.identity,
          k.value
        ), e.value = null, z;
      }
  }), V = () => me(this, null, function* () {
    k.value || (yield m());
  }), h = () => me(this, null, function* () {
    k.value && (yield m());
  });
  Ce(
    () => {
      var p;
      return (p = O.value) == null ? void 0 : p.localParticipant.metadata;
    },
    (p) => {
      if (p !== void 0) {
        if (e.value && p === e.value)
          return;
        const z = C(p), R = (z == null ? void 0 : z.handRaised) || !1;
        if (R !== k.value) {
          k.value = R;
          const U = O.value;
          U != null && U.localParticipant.identity && s.set(
            U.localParticipant.identity,
            R
          );
        }
      }
    },
    { immediate: !0 }
  );
  const D = (p) => {
    if (!p.identity) return;
    const z = C(p.metadata), R = (z == null ? void 0 : z.handRaised) || !1;
    s.set(p.identity, R);
  }, T = (p) => {
    p.localParticipant && D(p.localParticipant), p.remoteParticipants.forEach((z) => {
      D(z);
    });
  }, f = (p) => {
    if (!p) return;
    const z = (H, ee) => {
      const ae = ee.metadata, we = C(ae), Te = (we == null ? void 0 : we.handRaised) || !1;
      s.set(ee.identity, Te), ee.isLocal && (k.value = Te);
    }, R = /* @__PURE__ */ new Map(), U = (H) => {
      D(H);
      const ee = (ae) => {
        const we = C(H.metadata), Te = (we == null ? void 0 : we.handRaised) || !1;
        s.set(H.identity, Te);
      };
      R.set(H.identity, ee), H.on(Dt.ParticipantMetadataChanged, ee);
    }, Z = (H) => {
      s.delete(H.identity);
      const ee = R.get(H.identity);
      ee && (H.off(Dt.ParticipantMetadataChanged, ee), R.delete(H.identity));
    };
    return T(p), p.on(et.ParticipantMetadataChanged, z), p.on(et.ParticipantConnected, U), p.on(et.ParticipantDisconnected, Z), p.remoteParticipants.forEach((H) => {
      const ee = (ae) => {
        const we = C(H.metadata), Te = (we == null ? void 0 : we.handRaised) || !1;
        s.set(H.identity, Te);
      };
      R.set(H.identity, ee), H.on(Dt.ParticipantMetadataChanged, ee);
    }), () => {
      p.off(et.ParticipantMetadataChanged, z), p.off(et.ParticipantConnected, U), p.off(et.ParticipantDisconnected, Z), p.remoteParticipants.forEach((H) => {
        const ee = R.get(H.identity);
        ee && H.off(Dt.ParticipantMetadataChanged, ee);
      }), R.clear();
    };
  };
  let w = null;
  Bt(() => {
    const p = O.value;
    if (w && (w(), w = null), p && p.state === "connected")
      w = f(p);
    else if (p) {
      const z = () => {
        w && w(), w = f(p);
      };
      p.once(et.Connected, z), w = () => {
        p.off(et.Connected, z);
      };
    }
  }), Ce(
    () => M.value,
    (p) => {
      p.forEach((z) => {
        s.has(z.identity) || D(z);
      });
    },
    { immediate: !0, deep: !1 }
  );
  const j = () => {
    w && (w(), w = null), s.clear();
  };
  return {
    // Local state
    isHandRaised: Qt(k),
    toggleRaiseHand: m,
    raiseHand: V,
    lowerHand: h,
    // Global state
    getParticipantHandState: v,
    getRaisedHandParticipants: b,
    isParticipantHandRaised: a,
    // Reactive state
    raisedHandCount: Qt(u),
    raisedHandParticipants: Qt(r),
    // Cleanup
    cleanup: j
  };
}
const vn = ["👍", "❤️", "😂", "👏", "🎉", "😮"];
function mn(O = {}) {
  const {
    maxReactions: M = 20,
    reactionDuration: k = 5200,
    // Slightly longer than CSS animation (5000ms) to ensure cleanup after animation
    topic: e = "reactions"
  } = O, s = st(), C = A([]), g = /* @__PURE__ */ new Map(), v = Ia({
    onDataReceived: (h) => {
      if (h.topic === e)
        try {
          const D = new TextDecoder().decode(h.data), T = JSON.parse(D);
          if (T.type !== "reaction") return;
          const f = h.participant;
          if (!f) return;
          const w = {
            id: `reaction-${Date.now()}-${Math.random().toString(36).substring(2, 6)}`,
            emoji: T.emoji,
            participantId: f.identity,
            participantName: f.name || f.identity,
            timestamp: h.timestamp,
            x: Math.random() * 100
            // Random position 0-100% (component will add padding)
          };
          a(w);
        } catch (D) {
        }
    }
  }), a = (h) => {
    if (C.value.push(h), C.value.length > M) {
      const T = C.value.shift();
      T && r(T.id);
    }
    const D = setTimeout(() => {
      b(h.id);
    }, k);
    g.set(h.id, D);
  }, b = (h) => {
    const D = C.value.findIndex((T) => T.id === h);
    D !== -1 && (C.value.splice(D, 1), r(h));
  }, r = (h) => {
    const D = g.get(h);
    D && (clearTimeout(D), g.delete(h));
  }, u = (h) => me(this, null, function* () {
    const D = s.value;
    if (!D)
      return;
    const T = D.localParticipant;
    if (T)
      try {
        yield v.sendJSON(
          {
            type: "reaction",
            emoji: h
          },
          { topic: e, reliable: !1 }
          // Use unreliable for reactions (faster, ok to drop)
        );
        const f = {
          id: `reaction-${Date.now()}-${Math.random().toString(36).substring(2, 6)}`,
          emoji: h,
          participantId: T.identity,
          participantName: T.name || "You",
          timestamp: Date.now(),
          x: Math.random() * 100
          // Random position 0-100% (component will add padding)
        };
        a(f);
      } catch (f) {
        throw f;
      }
  }), m = () => {
    g.forEach((h) => clearTimeout(h)), g.clear(), C.value = [];
  }, V = () => {
    m(), v.clearMessages();
  };
  return ut(() => {
    V();
  }), {
    reactions: C,
    availableEmojis: vn,
    sendReaction: u,
    clearReactions: m,
    cleanup: V
  };
}
const hn = { class: "room-provider" }, fn = /* @__PURE__ */ je({
  __name: "RoomProvider",
  props: {
    role: { default: "attendee" },
    title: { default: "" },
    description: { default: "" },
    token: {}
  },
  setup(O) {
    const M = O;
    $a({
      roomOptions: {
        adaptiveStream: {
          pixelDensity: "screen"
        },
        dynacast: !0,
        // Enhanced audio capture defaults
        audioCaptureDefaults: Ba,
        videoCaptureDefaults: {
          resolution: {
            width: 1280,
            height: 720,
            frameRate: 30
          }
        },
        publishDefaults: {
          simulcast: !0,
          dtx: !0,
          red: !0,
          videoEncoding: {
            maxBitrate: 8e5,
            // Lower bitrate for room scenarios
            maxFramerate: 24
          },
          screenShareEncoding: {
            maxBitrate: 2e6,
            maxFramerate: 15
          },
          // Enhanced audio settings for better voice quality
          audioPreset: {
            maxBitrate: 96e3,
            // Higher bitrate for better quality
            priority: "high"
            // Prioritize audio over video
          }
        }
      }
    });
    const k = za(M.role), e = La({ skipMediaPermissions: !0 });
    at("roomControls", e);
    const s = Ut();
    at("participants", s);
    const C = un();
    at("speechDetection", C);
    const g = dn();
    at("trackReferences", g);
    const v = pn();
    at("raiseHand", v);
    const a = mn({
      maxReactions: 20,
      reactionDuration: 4e3,
      topic: "reactions"
    });
    at("reactions", a);
    const b = cn(g, C, v);
    at("roomLayout", b);
    const r = st(), { connectionState: u } = Gt(), m = n(() => u.value === "connected"), V = n(() => r.value && m.value && r.value.name || "");
    at("assetId", V);
    const h = A(""), D = (T) => {
      h.value = T;
    };
    return at("sessionToken", h), at("setSessionToken", D), Bt(() => {
      r.value && m.value && g.setupTrackObservable(r.value);
    }), Ce(
      () => g.trackReferences.value,
      () => {
        b.triggerScreenShareUpdate();
      },
      { immediate: !1 }
      // Don't trigger on initial setup
    ), Ce(
      () => M.token,
      (T) => {
        T && Xa(T);
      },
      { immediate: !0 }
      // Run immediately to handle initial token if present
    ), ht(() => {
      (M.title || M.description) && k.setRoomInfo(M.title, M.description);
    }), ut(() => {
      C.cleanup(), g.cleanup(), v.cleanup(), a.cleanup();
    }), (T, f) => (i(), c("div", hn, [
      _t(T.$slots, "default", {}, void 0, !0)
    ]));
  }
}), ts = /* @__PURE__ */ We(fn, [["__scopeId", "data-v-9668b9ac"]]), yn = ["muted"], gn = /* @__PURE__ */ je({
  inheritAttrs: !1,
  __name: "ParticipantVideo",
  props: {
    participant: {},
    videoRefHandler: {},
    muted: { type: Boolean, default: !1 },
    videoClass: { default: "participant-video" },
    trackSource: { default: ve.Source.Camera }
  },
  setup(O) {
    const M = O;
    return (k, e) => (i(), c("video", Ea({
      ref: (s) => k.videoRefHandler(k.participant.identity, s, M.trackSource),
      autoplay: "",
      playsinline: "",
      muted: k.muted,
      class: k.videoClass
    }, k.$attrs), null, 16, yn));
  }
}), kn = /* @__PURE__ */ We(gn, [["__scopeId", "data-v-487bad4f"]]);
function Sn() {
  const O = st(), { remoteParticipants: M } = Ut(), k = A(/* @__PURE__ */ new Map()), e = A(/* @__PURE__ */ new Map());
  return {
    // State
    participantVideoRefs: k,
    attachedTracks: e,
    // Methods
    setParticipantVideoRef: (a, b, r = ve.Source.Camera) => {
      var V, h;
      const u = `${a}-${r}`, m = k.value.get(u);
      if (m !== b)
        if (b && b instanceof HTMLVideoElement) {
          const D = e.value.get(u);
          if (D && m)
            try {
              D.detach(m), e.value.delete(u);
            } catch (p) {
            }
          k.value.set(u, b);
          const T = (V = M.value) == null ? void 0 : V.find(
            (p) => p.identity === a
          ), f = (h = O.value) == null ? void 0 : h.localParticipant, w = (f == null ? void 0 : f.identity) === a, j = T || (w ? f : null);
          if (j) {
            const p = Array.from(
              j.videoTrackPublications.values()
            ).find((z) => {
              const R = z.source === r;
              return T ? z.track && z.kind === "video" && z.isSubscribed && R : z.track && z.kind === "video" && R;
            });
            if (p != null && p.track && !e.value.has(u))
              try {
                p.track.attach(b), e.value.set(u, p.track);
              } catch (z) {
              }
            else p != null && p.track;
          }
        } else {
          const D = e.value.get(u);
          if (D && m)
            try {
              D.detach(m);
            } catch (T) {
            }
          k.value.delete(u), e.value.delete(u);
        }
    },
    updateParticipantVideoTrack: (a, b) => {
      const r = k.value.get(a);
      if (!r)
        return;
      const u = e.value.get(a);
      if (u)
        try {
          u.detach(r);
        } catch (m) {
        }
      try {
        b.attach(r), e.value.set(a, b);
      } catch (m) {
      }
    },
    clearParticipantVideo: (a, b) => {
      const r = k.value.get(a), u = e.value.get(a);
      b && r ? (b.detach(r), e.value.delete(a)) : u && r ? (u.detach(r), e.value.delete(a)) : r && (r.srcObject = null);
    },
    cleanup: () => {
      e.value.forEach((a, b) => {
        const r = k.value.get(b);
        if (r)
          try {
            a.detach(r);
          } catch (u) {
          }
      }), e.value.clear(), k.value.clear();
    }
  };
}
function bn() {
  return {
    updateParticipantAudioTrack: (e, s, C) => {
      try {
        const g = s.attach();
        g.setAttribute("data-participant", e.identity), g.autoplay = !0, g.setAttribute("playsinline", "true"), document.body.appendChild(g);
      } catch (g) {
      }
    },
    clearParticipantAudio: (e, s) => {
      s ? s.detach() : document.querySelectorAll(
        `[data-participant="${e}"]`
      ).forEach((g) => g.remove());
    },
    cleanupAllAudioTracks: () => {
      document.querySelectorAll("[data-participant]").forEach((s) => s.remove());
    }
  };
}
function Jt() {
  const O = st(), M = Kt(), { isConnected: k } = Gt(), e = n(() => k());
  return {
    // State
    inRoomMode: e,
    // Participant helpers
    getLocalParticipant: () => {
      if (e.value)
        try {
          return M;
        } catch (h) {
          return null;
        }
      return null;
    },
    isLocalParticipant: (h) => {
      var T;
      const D = (T = O.value) == null ? void 0 : T.localParticipant;
      return D ? h.identity === D.identity : !1;
    },
    getParticipantRole: (h) => {
      try {
        return h.metadata && JSON.parse(h.metadata).role || "attendee";
      } catch (D) {
        return "attendee";
      }
    },
    getParticipantDisplayName: (h) => h.name || h.identity,
    hasAnyVideoTrack: (h) => h.videoTrackPublications.size > 0,
    hasAnyAudioTrack: (h) => h.audioTrackPublications.size > 0,
    getParticipantConnectionQuality: (h) => {
      switch (h.connectionQuality) {
        case Ot.Unknown:
          return "unknown";
        case Ot.Poor:
          return "poor";
        case Ot.Good:
          return "good";
        case Ot.Excellent:
          return "excellent";
        default:
          return "unknown";
      }
    },
    // Room helpers
    formatParticipantCount: (h) => h === 1 ? "1 participant" : `${h} participants`,
    hasActiveSpeakers: (h) => h.some((D) => D.isSpeaking),
    getSpeakingParticipants: (h) => h.filter((D) => D.isSpeaking)
  };
}
const wn = /* @__PURE__ */ je({
  __name: "ParticipantTag",
  props: {
    participant: {},
    isPinned: { type: Boolean },
    isMicrophoneEnabled: { type: Boolean, default: !0 },
    fontSize: { default: 12 },
    iconSize: { default: 12 },
    maxWidth: { default: "calc(100% - 16px)" },
    bottomOffset: { default: 8 },
    leftOffset: { default: 8 },
    padding: {},
    borderRadius: { default: 16 },
    trackSource: { default: ve.Source.Camera }
  },
  setup(O) {
    const M = O, { getParticipantRole: k } = Jt(), e = n(() => {
      var g;
      return (g = M == null ? void 0 : M.participant) != null && g.isLocal ? "You" : k(M == null ? void 0 : M.participant) === "host" ? "Host" : null;
    }), s = n(() => {
      const C = M.participant.name || M.participant.identity;
      return M.trackSource === ve.Source.ScreenShare ? `${C}'s screen` : C;
    });
    return (C, g) => (i(), c("div", {
      class: "participant-tag",
      style: I({
        bottom: `${C.bottomOffset}px`,
        left: `${C.leftOffset}px`
      })
    }, [
      t("div", {
        class: "tag-content",
        style: I({
          maxWidth: C.maxWidth,
          padding: C.padding,
          borderRadius: `${C.borderRadius}px`
        })
      }, [
        C.isMicrophoneEnabled ? F("", !0) : (i(), be(mt, {
          key: 0,
          size: C.iconSize,
          variant: "mute",
          class: "mic-icon"
        }, null, 8, ["size"])),
        C.isPinned ? (i(), be(ga, {
          key: 1,
          size: C.iconSize,
          class: "pin-icon"
        }, null, 8, ["size"])) : F("", !0),
        t("span", {
          class: "participant-name",
          style: I({
            fontSize: `${C.fontSize}px`
          })
        }, se(s.value) + se(e.value ? ` (${e.value})` : ""), 5)
      ], 4)
    ], 4));
  }
}), Cn = /* @__PURE__ */ We(wn, [["__scopeId", "data-v-bc836abf"]]), Pn = ["data-size"], Rn = {
  key: 1,
  class: "tile-avatar"
}, Tn = ["title"], En = 500, Mn = 300, An = /* @__PURE__ */ je({
  __name: "ParticipantTile",
  props: {
    participant: {},
    participantMetadata: {},
    videoRefHandler: {},
    size: { default: "medium" },
    avatarSize: { default: "medium" },
    showRole: { type: Boolean, default: !0 },
    showStatus: { type: Boolean, default: !0 },
    isPinned: { type: Boolean, default: !1 },
    isLocal: { type: Boolean, default: !1 },
    clickAction: { default: "pin" },
    hasVideoTrack: { type: Boolean, default: !1 },
    hasAudioTrack: { type: Boolean, default: !1 },
    hasScreenShare: { type: Boolean, default: !1 },
    trackSource: { default: ve.Source.Camera },
    isSpeaking: { type: Boolean, default: void 0 },
    audioLevel: { default: void 0 },
    tagFontSize: { default: 14 },
    tagIconSize: { default: 14 }
  },
  emits: ["tile-click", "pin-click"],
  setup(O, { emit: M }) {
    const k = new fa(), e = sa(), s = O, C = M, g = Kt(), v = Pe("raiseHand"), a = Pe("speechDetection"), b = st(), r = Jt(), u = Pe("sessionToken", A("")), m = n(() => {
      var d;
      const o = (d = b.value) == null ? void 0 : d.localParticipant;
      return o ? r.getParticipantRole(o) === "host" : !1;
    }), V = n(() => {
      var o;
      return ((o = b.value) == null ? void 0 : o.name) || "";
    }), h = A(!1), D = A({ top: 0, left: 0 }), T = A(!1), f = n(() => s.isSpeaking !== void 0 ? s.isSpeaking : a.getParticipantSpeakingStatus(
      s.participant.identity
    )), w = n(() => s.audioLevel !== void 0 ? s.audioLevel : a.getParticipantAudioLevel(s.participant.identity)), j = n(() => f.value), p = n(() => (v == null ? void 0 : v.getParticipantHandState(s.participant.identity)) || !1);
    Ce(p, (o, d) => {
      o == !0 && d == !1 && e.playSound(Wt.HAND_RAISED);
    });
    const z = n(() => {
      var o;
      return s.isLocal ? g.isMicrophoneEnabled.value : (o = s.hasAudioTrack) != null ? o : !0;
    }), R = n(() => s.isLocal ? g.isCameraEnabled.value : s.hasVideoTrack), U = n(() => s.trackSource === ve.Source.ScreenShare ? !0 : R.value), Z = A(!1), H = A(!1);
    let ee = null, ae = null;
    const we = () => {
      Z.value = !0, ee && (clearTimeout(ee), ee = null), ee = setTimeout(() => {
        Z.value && (H.value = !0);
      }, Mn);
    }, Te = () => {
      Z.value = !1, ee && (clearTimeout(ee), ee = null), h.value || (H.value = !1);
    }, Ue = (o) => {
      if (s.clickAction === "none") return;
      ae && clearTimeout(ae);
      const d = o.currentTarget;
      d && (ae = setTimeout(() => {
        const L = d.getBoundingClientRect(), K = L.left + L.width / 2, le = L.top + L.height / 2;
        D.value = {
          top: le,
          left: K
        }, T.value = !0, h.value = !0;
      }, En));
    }, _e = () => {
      ae && (clearTimeout(ae), ae = null);
    }, Ge = () => {
      ae && (clearTimeout(ae), ae = null);
    }, X = () => {
      s.clickAction !== "none" && C("tile-click", {
        participant: s.participant,
        action: s.clickAction
      });
    }, Re = (o) => {
      o.stopPropagation();
      const L = o.currentTarget.getBoundingClientRect();
      D.value = {
        top: L.bottom + 8,
        left: L.right
        // Position at button's right edge, CSS will align from right
      }, T.value = !1, h.value = !0;
    }, he = () => {
      h.value = !1, H.value = !1;
    }, de = () => me(this, null, function* () {
      const o = V.value, d = u.value;
      if (!(!o || !d))
        try {
          (yield k.moderateParticipants(
            o,
            d,
            {
              action: Le.MUTE_MIC,
              participantIdentities: [s.participant.identity]
            }
          )).status;
        } catch (L) {
        } finally {
          h.value = !1, H.value = !1;
        }
    }), Ae = () => {
      C("pin-click", {
        participant: s.participant,
        isPinned: s.isPinned,
        trackSource: s.trackSource
      }), h.value = !1, H.value = !1;
    }, Ee = () => me(this, null, function* () {
      const o = V.value, d = u.value;
      if (!(!o || !d))
        try {
          (yield k.moderateParticipants(
            o,
            d,
            {
              action: Le.KICK,
              participantIdentities: [s.participant.identity]
            }
          )).status;
        } catch (L) {
        } finally {
          h.value = !1, H.value = !1;
        }
    }), Ve = n(() => {
      switch (s.size) {
        case "small":
          return 12;
        case "medium":
          return 16;
        case "large":
          return 18;
        case "fullscreen":
          return 20;
        default:
          return 16;
      }
    }), Ke = n(() => {
      const o = s.participant.name || s.participant.identity;
      function d(fe) {
        let xe = 0;
        for (let ye = 0; ye < fe.length; ye++)
          xe = fe.charCodeAt(ye) + ((xe << 5) - xe);
        return xe;
      }
      function L(fe) {
        const xe = Math.abs(d(fe)), ye = xe % 360, G = 15 + xe % 15, ke = 25 + xe % 15;
        return { hue: ye, sat: G, light: ke };
      }
      const { hue: K, sat: le, light: Be } = L(o);
      return {
        gradient: `radial-gradient(circle at 50% 40%,
    hsl(${K}, ${le}%, ${Be + 8}%) 0%,
    hsl(${K}, ${le}%, ${Be - 5}%) 100%)`,
        hue: K,
        sat: le,
        light: Be,
        // 🎨 AVATAR: Slightly darker version for depth
        avatarColor: `hsl(${K}, ${Math.min(le + 5, 35)}%, ${Math.max(
          Be - 8,
          15
        )}%)`,
        // 🎨 TEXT: Always white for dark backgrounds
        textColor: "#ffffff",
        // 🎨 SPEAKING: More vibrant but still elegant for speaking effects
        speakingColor: `hsl(${K}, ${Math.min(le + 25, 60)}%, ${Math.min(
          Be + 20,
          55
        )}%)`,
        speakingColorRgba: `hsla(${K}, ${Math.min(le + 25, 60)}%, ${Math.min(
          Be + 20,
          55
        )}%, 0.4)`
      };
    });
    return ut(() => {
      ee && (clearTimeout(ee), ee = null), ae && (clearTimeout(ae), ae = null);
    }), (o, d) => {
      var L;
      return i(), c("div", {
        class: De(["participant-tile", {
          speaking: j.value,
          muted: !z.value,
          "camera-off": !R.value,
          local: o.isLocal
        }]),
        "data-size": o.size,
        style: I({ background: Ke.value.gradient }),
        onClick: X,
        onMouseenter: we,
        onMouseleave: Te,
        onMousedown: Ue,
        onMouseup: _e,
        onTouchstart: Ue,
        onTouchend: _e,
        onTouchcancel: Ge,
        onContextmenu: d[1] || (d[1] = Ze(() => {
        }, ["prevent"]))
      }, [
        U.value ? (i(), be(kn, {
          key: 0,
          participant: o.participant,
          "video-ref-handler": o.videoRefHandler,
          "track-source": s.trackSource,
          muted: o.isLocal,
          class: "tile-video"
        }, null, 8, ["participant", "video-ref-handler", "track-source", "muted"])) : (i(), c("div", Rn, [
          Q(Yt, {
            name: o.participant.name || o.participant.identity,
            image: (L = o.participantMetadata) == null ? void 0 : L.avatar,
            size: o.avatarSize,
            "is-speaking": f.value,
            "audio-level": w.value,
            "background-color": Ke.value.avatarColor,
            "text-color": Ke.value.textColor,
            "speaking-ring-color": Ke.value.speakingColor
          }, null, 8, ["name", "image", "size", "is-speaking", "audio-level", "background-color", "text-color", "speaking-ring-color"])
        ])),
        H.value && o.clickAction === "pin" ? (i(), c("button", {
          key: 2,
          class: De(["menu-button", { "menu-animate-in": H.value }]),
          title: "Options",
          onClick: Ze(Re, ["stop"])
        }, [
          Q(ka, {
            size: Ve.value,
            color: "#ffffff",
            align: "vertical"
          }, null, 8, ["size"])
        ], 2)) : F("", !0),
        p.value ? (i(), c("div", {
          key: 3,
          class: "hand-raised-indicator",
          title: `${o.participant.name || o.participant.identity} has raised their hand`
        }, d[2] || (d[2] = [
          t("span", { class: "hand-emoji" }, "✋", -1)
        ]), 8, Tn)) : F("", !0),
        Q(Cn, {
          participant: o.participant,
          "is-pinned": o.isPinned,
          "is-microphone-enabled": z.value,
          "font-size": o.tagFontSize,
          "icon-size": o.tagIconSize,
          "bottom-offset": 4,
          "left-offset": 4,
          "track-source": s.trackSource
        }, null, 8, ["participant", "is-pinned", "is-microphone-enabled", "font-size", "icon-size", "track-source"]),
        (i(), be(jt, { to: "body" }, [
          h.value ? (i(), c("div", {
            key: 0,
            class: De(["tile-moderation-dropdown", [
              `dropdown-size-${o.size}`,
              { "dropdown-centered": T.value }
            ]]),
            style: I({
              position: "fixed",
              top: `${D.value.top}px`,
              left: `${D.value.left}px`,
              zIndex: 9999
            }),
            onClick: d[0] || (d[0] = Ze(() => {
            }, ["stop"]))
          }, [
            m.value && !o.isLocal ? (i(), c("button", {
              key: 0,
              class: "dropdown-item",
              onClick: de
            }, [
              Q(mt, {
                variant: "mute",
                size: 14
              }),
              d[3] || (d[3] = t("span", null, "Mute", -1))
            ])) : F("", !0),
            t("button", {
              class: "dropdown-item",
              onClick: Ae
            }, [
              Q(ga, {
                variant: o.isPinned ? "on" : "off",
                size: 14
              }, null, 8, ["variant"]),
              t("span", null, se(o.isPinned ? "Unpin" : "Pin"), 1)
            ]),
            m.value && !o.isLocal ? (i(), c("button", {
              key: 1,
              class: "dropdown-item dropdown-item-danger",
              onClick: Ee
            }, d[4] || (d[4] = [
              t("svg", {
                width: "14",
                height: "14",
                viewBox: "0 0 24 24",
                fill: "currentColor"
              }, [
                t("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z" })
              ], -1),
              t("span", null, "Remove", -1)
            ]))) : F("", !0)
          ], 6)) : F("", !0)
        ])),
        h.value ? (i(), c("div", {
          key: 4,
          class: "dropdown-backdrop",
          onClick: he
        })) : F("", !0)
      ], 46, Pn);
    };
  }
}), Nt = /* @__PURE__ */ We(An, [["__scopeId", "data-v-a61d33cb"]]), xn = /* @__PURE__ */ je({
  __name: "StageGrid",
  props: {
    entities: {},
    pinnedItems: {},
    deviceType: {},
    maxTiles: {},
    videoRefHandler: { type: Function },
    hasVideoTrack: { type: Function },
    hasAudioTrack: { type: Function },
    hasScreenShare: { type: Function },
    getSpeakingStatus: { type: Function }
  },
  emits: ["tile-click", "pin-click"],
  setup(O) {
    let M = null;
    const k = O, e = A(null), s = st(), C = Pe("participants"), { getParticipantMetadata: g } = C, { width: v, height: a } = ya(e), b = (T) => {
      var w;
      const f = (w = s.value) == null ? void 0 : w.localParticipant;
      return f ? T.identity === f.identity : !1;
    }, r = (T) => {
      var f;
      if (T.type === "participant" && T.participant)
        return T.participant;
      if (T.type === "screen-share" && ((f = T.screenShare) != null && f.participant))
        return T.screenShare.participant;
      throw new Error(`Invalid entity: ${T.id}`);
    }, u = (T) => g(r(T).identity), m = (T) => T.type === "screen-share" ? ve.Source.ScreenShare : ve.Source.Camera, V = n(() => k.entities.slice(0, k.maxTiles)), h = () => me(this, null, function* () {
      if (e.value)
        try {
          const { default: T } = yield import("./opentok-layout-S8dVyABm.js").then((f) => f.o);
          M = T(e.value, {
            maxRatio: 3 / 2,
            // Maximum aspect ratio
            minRatio: 9 / 16,
            // Minimum aspect ratio (portrait)
            fixedRatio: !1,
            // Allow flexible ratios
            alignItems: "center",
            bigClass: "stage-tile-big",
            bigPercentage: 0.8,
            // 80% for main tiles in focus mode
            bigFixedRatio: !1,
            bigMaxRatio: 3 / 2,
            bigMinRatio: 9 / 16,
            bigFirst: !0,
            // Big elements first
            animate: !0,
            // Smooth transitions
            scaleLastRow: !0,
            // Scale the last row to fit
            ignoreClass: "stage-tile-ignore"
          });
        } catch (T) {
        }
    }), D = () => {
      !M || !e.value || Lt(() => {
        try {
          M.layout();
        } catch (T) {
        }
      });
    };
    return Ce(
      V,
      () => {
        D();
      },
      { deep: !0 }
    ), Ce([v, a], ([T, f]) => {
      (T > 0 || f > 0) && setTimeout(() => {
        D();
      }, 100);
    }), ht(() => me(this, null, function* () {
      yield h(), D();
    })), ut(() => {
      M && (M = null);
    }), (T, f) => (i(), c("div", {
      ref_key: "stageContainer",
      ref: e,
      class: "stage-grid"
    }, [
      (i(!0), c(He, null, tt(V.value, (w) => (i(), be(Nt, {
        key: w.id,
        participant: r(w),
        "participant-metadata": u(w),
        "video-ref-handler": T.videoRefHandler,
        size: "medium",
        "avatar-size": "medium",
        "click-action": "pin",
        "is-pinned": T.pinnedItems.some((j) => (j == null ? void 0 : j.id) === w.id),
        "is-local": b(r(w)),
        "has-video-track": T.hasVideoTrack(r(w).identity),
        "has-audio-track": T.hasAudioTrack(r(w).identity),
        "has-screen-share": T.hasScreenShare(r(w).identity),
        "is-speaking": T.getSpeakingStatus(r(w).identity),
        "track-source": m(w),
        class: "stage-tile",
        onTileClick: f[0] || (f[0] = (j) => T.$emit("tile-click", j)),
        onPinClick: f[1] || (f[1] = (j) => T.$emit("pin-click", j))
      }, null, 8, ["participant", "participant-metadata", "video-ref-handler", "is-pinned", "is-local", "has-video-track", "has-audio-track", "has-screen-share", "is-speaking", "track-source"]))), 128))
    ], 512));
  }
}), Sa = /* @__PURE__ */ We(xn, [["__scopeId", "data-v-18e03a2a"]]), In = { class: "page-indicator" }, $n = { class: "page-indicator" }, zn = {
  key: 2,
  class: "pagination-dots"
}, Ln = ["aria-label", "onClick"], Bn = 50, _n = /* @__PURE__ */ je({
  __name: "StageArea",
  props: {
    stageZone: {},
    pinnedItems: {},
    deviceType: {},
    videoRefHandler: { type: Function },
    hasVideoTrack: { type: Function },
    hasAudioTrack: { type: Function },
    hasScreenShare: { type: Function },
    getSpeakingStatus: { type: Function },
    getAudioLevel: { type: Function }
  },
  emits: ["tile-click", "pin-click"],
  setup(O, { emit: M }) {
    const k = Pe("roomLayout"), e = O, s = M, C = A(1), g = A(0), v = A(0), a = A(0), b = A(0), r = n(() => {
      switch (e.deviceType) {
        case "mobile":
          return 6;
        case "tablet":
          return 12;
        case "desktop":
          return 16;
        default:
          return 16;
      }
    }), u = n(() => Math.ceil(e.stageZone.entities.length / r.value)), m = n(() => {
      const R = (C.value - 1) * r.value, U = R + r.value;
      return e.stageZone.entities.slice(R, U);
    }), V = () => {
      C.value < u.value && C.value++;
    }, h = () => {
      C.value > 1 && C.value--;
    }, D = (R) => {
      R >= 1 && R <= u.value && (C.value = R);
    }, T = (R) => {
      u.value <= 1 || (g.value = R.touches[0].clientX, v.value = R.touches[0].clientY, a.value = g.value, b.value = v.value);
    }, f = (R) => {
      u.value <= 1 || (a.value = R.touches[0].clientX, b.value = R.touches[0].clientY);
    }, w = () => {
      if (u.value <= 1) return;
      const R = a.value - g.value, U = b.value - v.value;
      Math.abs(R) > Math.abs(U) && Math.abs(R) > Bn && (R > 0 ? h() : V()), g.value = 0, v.value = 0, a.value = 0, b.value = 0;
    };
    Ce(
      () => e.stageZone.entities.length,
      () => {
        C.value > u.value && u.value > 0 && (C.value = u.value);
      }
    );
    const j = (R) => {
      u.value <= 1 || (R.key === "ArrowLeft" ? (R.preventDefault(), h()) : R.key === "ArrowRight" && (R.preventDefault(), V()));
    };
    ht(() => {
      window.addEventListener("keydown", j);
    }), ut(() => {
      window.removeEventListener("keydown", j);
    }), Ce(
      m,
      (R) => {
        const U = R.map((Z) => {
          var H;
          return (H = Z.participant) == null ? void 0 : H.identity;
        }).filter((Z) => !!Z);
        k.updateStageVisibleParticipants(U);
      },
      { immediate: !0 }
    );
    const p = (R) => {
      const U = e.pinnedItems.includes(R.participant);
      s("tile-click", {
        participant: R.participant,
        action: U ? "unpin" : "pin"
      });
    }, z = (R) => {
      s("pin-click", R);
    };
    return (R, U) => (i(), c("div", {
      class: De(["stage-area", `stage-mode-${R.stageZone.mode}`]),
      onTouchstart: T,
      onTouchmove: f,
      onTouchend: w
    }, [
      u.value > 1 && C.value > 1 ? (i(), c("button", {
        key: 0,
        class: "pagination-button pagination-prev",
        "aria-label": "Previous page",
        onClick: h
      }, [
        U[0] || (U[0] = t("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none"
        }, [
          t("path", {
            d: "M15 18l-6-6 6-6",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ], -1)),
        t("span", In, se(C.value - 1) + "/" + se(u.value), 1)
      ])) : F("", !0),
      Q(Sa, {
        entities: m.value,
        "pinned-items": R.pinnedItems,
        "device-type": R.deviceType,
        "max-tiles": r.value,
        "stage-mode": R.stageZone.mode,
        "video-ref-handler": R.videoRefHandler,
        "has-video-track": R.hasVideoTrack,
        "has-audio-track": R.hasAudioTrack,
        "has-screen-share": R.hasScreenShare,
        "get-speaking-status": R.getSpeakingStatus,
        "get-audio-level": R.getAudioLevel,
        onTileClick: p,
        onPinClick: z
      }, null, 8, ["entities", "pinned-items", "device-type", "max-tiles", "stage-mode", "video-ref-handler", "has-video-track", "has-audio-track", "has-screen-share", "get-speaking-status", "get-audio-level"]),
      u.value > 1 && C.value < u.value ? (i(), c("button", {
        key: 1,
        class: "pagination-button pagination-next",
        "aria-label": "Next page",
        onClick: V
      }, [
        U[1] || (U[1] = t("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none"
        }, [
          t("path", {
            d: "M9 18l6-6-6-6",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ], -1)),
        t("span", $n, se(C.value + 1) + "/" + se(u.value), 1)
      ])) : F("", !0),
      u.value > 1 ? (i(), c("div", zn, [
        (i(!0), c(He, null, tt(u.value, (Z) => (i(), c("button", {
          key: Z,
          class: De(["pagination-dot", { active: C.value === Z }]),
          "aria-label": `Go to page ${Z}`,
          onClick: (H) => D(Z)
        }, null, 10, Ln))), 128))
      ])) : F("", !0)
    ], 34));
  }
}), Nn = /* @__PURE__ */ We(_n, [["__scopeId", "data-v-c84dd164"]]), Fn = {
  key: 1,
  class: "search-container"
}, Hn = ["onClick", "onMouseenter", "onMouseleave"], Dn = ["disabled", "onClick"], On = ["disabled", "onClick"], Vn = ["onClick"], jn = { class: "dropdown-section" }, Wn = { class: "dropdown-section" }, Un = { class: "dropdown-section" }, Gn = { class: "dropdown-section" }, Kn = /* @__PURE__ */ je({
  __name: "ParticipantsList",
  props: {
    title: {},
    hideHeader: { type: Boolean, default: !1 },
    showCloseButton: { type: Boolean, default: !1 },
    showRoles: { type: Boolean, default: !0 },
    showMoreOptions: { type: Boolean, default: !1 },
    showFooterActions: { type: Boolean, default: !1 },
    showMuteAllButton: { type: Boolean, default: !0 },
    showSearch: { type: Boolean, default: !0 },
    enableMediaControls: { type: Boolean, default: !1 },
    sortBy: { default: "role" },
    avatarSize: { default: "small" },
    iconSize: { default: 20 },
    containerStyle: {},
    headerStyle: {},
    titleStyle: {},
    closeButtonStyle: {},
    scrollAreaStyle: {},
    itemStyle: {},
    avatarContainerStyle: {},
    avatarBackgroundColor: {},
    avatarTextColor: {},
    avatarBorderColor: {},
    infoContainerStyle: {},
    nameStyle: {},
    roleStyle: {},
    controlsContainerStyle: {},
    audioButtonStyle: {},
    videoButtonStyle: {},
    moreOptionsButtonStyle: {},
    footerStyle: {},
    muteAllButtonStyle: {},
    getMediaButtonStyle: {}
  },
  emits: ["close", "participant-click", "participant-audio-toggle", "participant-video-toggle", "participant-more-options", "participant-muted", "participant-kicked"],
  setup(O, { emit: M }) {
    const k = new fa(), e = O, s = M, C = st(), g = Jt(), v = Pe("trackReferences"), a = Pe("speechDetection"), b = Pe("participants"), r = Pe("sessionToken", A("")), { participantCount: u, remoteParticipants: m, getParticipantMetadata: V } = b, h = n(() => {
      var d;
      const o = (d = C.value) == null ? void 0 : d.localParticipant;
      return o ? g.getParticipantRole(o) === "host" : !1;
    }), D = n(() => {
      var o;
      return ((o = C.value) == null ? void 0 : o.name) || "";
    }), T = n(() => {
      var L;
      const o = [], d = (L = C.value) == null ? void 0 : L.localParticipant;
      return d && o.push(d), m.value && o.push(...m.value), o;
    }), f = n(() => {
      const o = [...T.value];
      switch (e.sortBy) {
        case "name":
          return o.sort((d, L) => {
            const K = H(d).toLowerCase(), le = H(L).toLowerCase();
            return K.localeCompare(le);
          });
        case "role":
          return o.sort((d, L) => {
            const K = ee(d), le = ee(L);
            return K === "host" && le !== "host" ? -1 : K !== "host" && le === "host" ? 1 : 0;
          });
        case "speaking":
          return o.sort((d, L) => {
            const K = Te(d.identity), le = Te(L.identity);
            return K && !le ? -1 : !K && le ? 1 : 0;
          });
        case "joinTime":
        default:
          return o;
      }
    }), w = A(""), j = (o) => {
      const L = ".*" + o.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").split("").join(".*") + ".*";
      return new RegExp(L, "i");
    }, p = (o, d) => d.trim() ? j(d.trim()).test(o) : !0, z = n(() => w.value.trim() ? f.value.filter((o) => {
      const d = H(o);
      return p(d, w.value);
    }) : f.value), R = A(null), U = A(null), Z = A({ top: 0, left: 0 }), H = (o) => g.getParticipantDisplayName(o), ee = (o) => {
      const d = g.getParticipantRole(o);
      return o.isLocal ? d === "host" ? "Host (You)" : "You" : d === "host" ? "Host" : "";
    }, ae = (o) => v.hasVideoTrack(o), we = (o) => v.hasAudioTrack(o), Te = (o) => (a == null ? void 0 : a.getParticipantSpeakingStatus(o)) || !1, Ue = (o, d) => d ? e.audioButtonStyle : wt(y({}, e.audioButtonStyle), { opacity: 0.5 }), _e = e.getMediaButtonStyle || Ue, Ge = (o) => {
      s("participant-click", o);
    }, X = (o) => {
      e.enableMediaControls && !o.isLocal && s("participant-audio-toggle", o);
    }, Re = (o) => {
      e.enableMediaControls && !o.isLocal && s("participant-video-toggle", o);
    }, he = (o, d) => {
      if (d.stopPropagation(), U.value === o.identity)
        U.value = null;
      else {
        U.value = o.identity;
        const K = d.currentTarget.getBoundingClientRect(), le = 200;
        Z.value = {
          top: K.bottom + 5,
          left: K.right - le
          // Right-align dropdown with button
        };
      }
    }, de = (o) => {
      h.value && (R.value = o);
    }, Ae = (o) => {
      R.value === o && (R.value = null);
    }, Ee = (o, d) => me(this, null, function* () {
      const L = D.value, K = r.value;
      if (!(!L || !K))
        try {
          const le = yield k.moderateParticipants(
            L,
            K,
            {
              action: d,
              participantIdentities: [o.identity]
            }
          );
          if (le.status === "success") {
            const Be = H(o);
            switch (d) {
              case Le.KICK:
                s("participant-kicked", o);
                break;
              case Le.MUTE_MIC:
                s("participant-muted", o);
                break;
              case Le.TURN_OFF_VIDEO:
                s("participant-muted", o);
                break;
              case Le.ALLOW_AUDIO:
                break;
              case Le.DISABLE_AUDIO:
                break;
              case Le.ALLOW_VIDEO:
                break;
              case Le.DISABLE_VIDEO:
                break;
              case Le.ALLOW_SCREEN_SHARE:
                break;
              case Le.DISABLE_SCREEN_SHARE:
                break;
            }
          } else le.status;
        } catch (le) {
        } finally {
          U.value = null;
        }
    }), Ve = () => {
      U.value = null;
    }, Ke = () => me(this, null, function* () {
      const o = D.value, d = r.value;
      if (!(!o || !d))
        try {
          const L = yield k.moderateParticipants(
            o,
            d,
            {
              action: Le.MUTE_MIC,
              participantIdentities: ["*"]
              // '*' means apply to all participants
            }
          );
          L.status === "success" ? s("participant-muted", null) : L.status;
        } catch (L) {
        }
    });
    return (o, d) => (i(), c("div", {
      class: "participants-list-container",
      style: I(o.containerStyle)
    }, [
      o.hideHeader ? F("", !0) : (i(), c("div", {
        key: 0,
        class: "participants-header",
        style: I(o.headerStyle)
      }, [
        t("h3", {
          class: "participants-title",
          style: I(o.titleStyle)
        }, se(o.title || `Participants (${S(u)})`), 5),
        o.showCloseButton ? (i(), c("button", {
          key: 0,
          class: "close-button",
          style: I(o.closeButtonStyle),
          onClick: d[0] || (d[0] = (L) => o.$emit("close"))
        }, " ✕ ", 4)) : F("", !0)
      ], 4)),
      o.showSearch ? (i(), c("div", Fn, [
        ta(t("input", {
          "onUpdate:modelValue": d[1] || (d[1] = (L) => w.value = L),
          type: "text",
          class: "search-input",
          placeholder: "Search participants..."
        }, null, 512), [
          [aa, w.value]
        ]),
        d[12] || (d[12] = t("div", { class: "search-icon" }, [
          t("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2"
          }, [
            t("circle", {
              cx: "11",
              cy: "11",
              r: "8"
            }),
            t("path", { d: "m21 21-4.35-4.35" })
          ])
        ], -1))
      ])) : F("", !0),
      t("div", {
        class: "participants-scroll-area",
        style: I(o.scrollAreaStyle)
      }, [
        (i(!0), c(He, null, tt(z.value, (L) => {
          var K;
          return i(), c("div", {
            key: L.identity,
            class: "participant-item",
            style: I(o.itemStyle),
            onClick: (le) => Ge(L),
            onMouseenter: (le) => de(L.identity),
            onMouseleave: (le) => Ae(L.identity)
          }, [
            t("div", {
              class: "participant-avatar",
              style: I(o.avatarContainerStyle)
            }, [
              Q(Yt, {
                name: H(L),
                image: (K = S(V)(L.identity)) == null ? void 0 : K.avatar,
                size: o.avatarSize,
                "is-speaking": Te(L.identity),
                "background-color": o.avatarBackgroundColor || "#6b7280",
                "text-color": o.avatarTextColor || "#ffffff",
                "border-color": o.avatarBorderColor || "",
                "show-speaking-animation": !1
              }, null, 8, ["name", "image", "size", "is-speaking", "background-color", "text-color", "border-color"])
            ], 4),
            t("div", {
              class: "participant-info",
              style: I(o.infoContainerStyle)
            }, [
              t("div", {
                class: "participant-name",
                style: I(o.nameStyle)
              }, se(H(L)), 5),
              o.showRoles && ee(L) ? (i(), c("div", {
                key: 0,
                class: "participant-role",
                style: I(o.roleStyle)
              }, se(ee(L)), 5)) : F("", !0)
            ], 4),
            t("div", {
              class: "participant-controls",
              style: I(o.controlsContainerStyle)
            }, [
              t("button", {
                class: De(["media-control", {
                  active: we(L.identity),
                  muted: !we(L.identity)
                }]),
                style: I(
                  S(_e)("audio", we(L.identity))
                ),
                disabled: !o.enableMediaControls || L.isLocal,
                onClick: Ze((le) => X(L), ["stop"])
              }, [
                Q(mt, {
                  variant: we(L.identity) ? "on" : "mute",
                  size: o.iconSize
                }, null, 8, ["variant", "size"])
              ], 14, Dn),
              t("button", {
                class: De(["media-control", {
                  active: ae(L.identity),
                  disabled: !ae(L.identity)
                }]),
                style: I(
                  S(_e)("video", ae(L.identity))
                ),
                disabled: !o.enableMediaControls || L.isLocal,
                onClick: Ze((le) => Re(L), ["stop"])
              }, [
                Q($t, {
                  variant: ae(L.identity) ? "on" : "mute",
                  size: o.iconSize
                }, null, 8, ["variant", "size"])
              ], 14, On),
              h.value && !L.isLocal ? (i(), c("button", {
                key: 0,
                class: "more-options",
                style: I(o.moreOptionsButtonStyle),
                onClick: Ze((le) => he(L, le), ["stop"])
              }, [
                Q(ka, {
                  size: o.iconSize,
                  color: "#6b7280",
                  align: "vertical"
                }, null, 8, ["size"])
              ], 12, Vn)) : F("", !0)
            ], 4)
          ], 44, Hn);
        }), 128))
      ], 4),
      o.showMuteAllButton && h.value || o.$slots["footer-actions"] ? (i(), c("div", {
        key: 2,
        class: "participants-footer",
        style: I(o.footerStyle)
      }, [
        o.showMuteAllButton && h.value ? (i(), c("button", {
          key: 0,
          class: "action-button mute-all",
          style: I(o.muteAllButtonStyle),
          onClick: Ke
        }, [
          Q(mt, {
            variant: "mute",
            size: 16
          }),
          d[13] || (d[13] = t("span", null, "Mute All", -1))
        ], 4)) : F("", !0),
        _t(o.$slots, "footer-actions", {}, void 0, !0)
      ], 4)) : F("", !0),
      U.value ? (i(), c("div", {
        key: 3,
        class: "dropdown-backdrop",
        onClick: Ve
      })) : F("", !0),
      U.value ? (i(), c("div", {
        key: 4,
        class: "moderation-dropdown",
        style: I({
          position: "fixed",
          top: `${Z.value.top}px`,
          left: `${Z.value.left}px`,
          zIndex: 9999
        }),
        onClick: d[11] || (d[11] = Ze(() => {
        }, ["stop"]))
      }, [
        t("div", jn, [
          t("button", {
            class: "dropdown-item",
            onClick: d[2] || (d[2] = (L) => Ee(
              T.value.find((K) => K.identity === U.value),
              S(Le).MUTE_MIC
            ))
          }, [
            Q(mt, {
              variant: "mute",
              size: 16
            }),
            d[14] || (d[14] = t("span", null, "Mute Microphone", -1))
          ]),
          t("button", {
            class: "dropdown-item",
            onClick: d[3] || (d[3] = (L) => Ee(
              T.value.find((K) => K.identity === U.value),
              S(Le).DISABLE_AUDIO
            ))
          }, [
            Q(mt, {
              variant: "mute",
              size: 16
            }),
            d[15] || (d[15] = t("span", null, "Revoke Microphone", -1))
          ]),
          t("button", {
            class: "dropdown-item",
            onClick: d[4] || (d[4] = (L) => Ee(
              T.value.find((K) => K.identity === U.value),
              S(Le).ALLOW_AUDIO
            ))
          }, [
            Q(mt, {
              variant: "on",
              size: 16
            }),
            d[16] || (d[16] = t("span", null, "Grant Microphone", -1))
          ])
        ]),
        t("div", Wn, [
          t("button", {
            class: "dropdown-item",
            onClick: d[5] || (d[5] = (L) => Ee(
              T.value.find((K) => K.identity === U.value),
              S(Le).TURN_OFF_VIDEO
            ))
          }, [
            Q($t, {
              variant: "mute",
              size: 16
            }),
            d[17] || (d[17] = t("span", null, "Turn Off Camera", -1))
          ]),
          t("button", {
            class: "dropdown-item",
            onClick: d[6] || (d[6] = (L) => Ee(
              T.value.find((K) => K.identity === U.value),
              S(Le).DISABLE_VIDEO
            ))
          }, [
            Q($t, {
              variant: "mute",
              size: 16
            }),
            d[18] || (d[18] = t("span", null, "Revoke Camera", -1))
          ]),
          t("button", {
            class: "dropdown-item",
            onClick: d[7] || (d[7] = (L) => Ee(
              T.value.find((K) => K.identity === U.value),
              S(Le).ALLOW_VIDEO
            ))
          }, [
            Q($t, {
              variant: "on",
              size: 16
            }),
            d[19] || (d[19] = t("span", null, "Grant Camera", -1))
          ])
        ]),
        t("div", Un, [
          t("button", {
            class: "dropdown-item",
            onClick: d[8] || (d[8] = (L) => Ee(
              T.value.find((K) => K.identity === U.value),
              S(Le).DISABLE_SCREEN_SHARE
            ))
          }, [
            Q(ia, {
              variant: "off",
              size: 16
            }),
            d[20] || (d[20] = t("span", null, "Revoke Screen Share", -1))
          ]),
          t("button", {
            class: "dropdown-item",
            onClick: d[9] || (d[9] = (L) => Ee(
              T.value.find((K) => K.identity === U.value),
              S(Le).ALLOW_SCREEN_SHARE
            ))
          }, [
            Q(ia, {
              variant: "on",
              size: 16
            }),
            d[21] || (d[21] = t("span", null, "Grant Screen Share", -1))
          ])
        ]),
        t("div", Gn, [
          t("button", {
            class: "dropdown-item dropdown-item-danger",
            onClick: d[10] || (d[10] = (L) => Ee(
              T.value.find((K) => K.identity === U.value),
              S(Le).KICK
            ))
          }, d[22] || (d[22] = [
            t("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 24 24",
              fill: "currentColor"
            }, [
              t("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z" })
            ], -1),
            t("span", null, "Remove", -1)
          ]))
        ])
      ], 4)) : F("", !0)
    ], 4));
  }
}), Yn = /* @__PURE__ */ We(Kn, [["__scopeId", "data-v-4f9f128e"]]), Jn = /* @__PURE__ */ je({
  __name: "ParticipantsModal",
  props: {
    visible: { type: Boolean }
  },
  emits: ["close"],
  setup(O, { emit: M }) {
    const k = O, e = M, s = A(window.innerWidth), C = () => {
      s.value = window.innerWidth;
    };
    ht(() => {
      window.addEventListener("resize", C);
    }), ut(() => {
      window.removeEventListener("resize", C);
    });
    const g = n(() => (s.value < 480 || s.value < 768, "small")), v = n(() => s.value < 480 ? 14 : s.value < 768 ? 15 : 16), a = n(() => ({
      // Let the default styles from ParticipantsList show through
      // Only override size/positioning
      width: "clamp(320px, 90%, 450px)",
      maxWidth: "90%",
      maxHeight: "80vh"
    })), b = n(() => ({})), r = n(() => ({})), u = n(() => ({})), m = () => {
      e("close");
    };
    return (V, h) => k.visible ? (i(), c("div", {
      key: 0,
      class: "participants-modal-overlay",
      onClick: m
    }, [
      Q(Yn, {
        "show-close-button": !0,
        "container-style": a.value,
        "header-style": b.value,
        "scroll-area-style": r.value,
        "item-style": u.value,
        "avatar-size": g.value,
        "icon-size": v.value,
        onClose: m,
        onClick: h[0] || (h[0] = Ze(() => {
        }, ["stop"]))
      }, null, 8, ["container-style", "header-style", "scroll-area-style", "item-style", "avatar-size", "icon-size"])
    ])) : F("", !0);
  }
}), Zn = /* @__PURE__ */ We(Jn, [["__scopeId", "data-v-a338f334"]]), Xn = { class: "emoji-text" }, Qn = {
  key: 0,
  class: "reaction-name"
}, qn = /* @__PURE__ */ je({
  __name: "FloatingReactions",
  props: {
    position: { default: "bottom-left" },
    showNames: { type: Boolean, default: !0 }
  },
  setup(O) {
    const M = O, k = Pe("reactions");
    if (!k)
      throw new Error(
        "FloatingReactions must be used within a provider that provides reactions"
      );
    const { reactions: e } = k, s = (g) => g.id.split("").reduce((a, b) => a + b.charCodeAt(0), 0) % 3 + 1, C = (g) => {
      const v = {}, a = 15 + (g.x || 10) * 0.7;
      M.position.includes("left") ? v.left = `${a}%` : v.right = `${a}%`;
      const b = -15 + Math.random() * 30;
      return v.transform = `rotate(${b}deg)`, v;
    };
    return (g, v) => (i(), c("div", {
      class: De(["floating-reactions-container", `position-${g.position}`])
    }, [
      (i(!0), c(He, null, tt(S(e), (a) => (i(), c("div", {
        key: a.id,
        class: De([
          "reaction-animate",
          `wiggle-${s(a)}`,
          { "with-name": g.showNames }
        ]),
        style: I(C(a))
      }, [
        t("span", Xn, se(a.emoji), 1),
        g.showNames ? (i(), c("span", Qn, se(a.participantName), 1)) : F("", !0)
      ], 6))), 128))
    ], 2));
  }
}), ei = /* @__PURE__ */ We(qn, [["__scopeId", "data-v-90dfe2b5"]]), ti = {
  key: 0,
  class: "participants-strip-container"
}, ai = { class: "page-indicator" }, ni = { class: "page-indicator" }, ii = /* @__PURE__ */ je({
  __name: "ParticipantStrip",
  props: {
    videoRefHandler: {},
    hasVideoTrack: {},
    hasAudioTrack: {},
    getSpeakingStatus: {},
    getParticipantMetadata: {},
    maxParticipants: { default: Number.MAX_SAFE_INTEGER }
  },
  emits: ["pin-click"],
  setup(O, { expose: M }) {
    oa((X) => ({
      "0c95dd62": `${p.value.gap}px`,
      "2d633a9e": `${p.value.tileWidth}px`,
      "134b219c": `${p.value.tileHeight}px`
    }));
    const k = O, e = Pe("trackReferences"), s = Pe("participants"), { remoteParticipants: C } = s, g = Pe("roomLayout"), v = st(), a = n(() => e.trackReferences.value.filter(
      (he) => {
        var de, Ae;
        return he.source === ve.Source.ScreenShare && ((de = he.publication) == null ? void 0 : de.track) && ((Ae = he.publication) == null ? void 0 : Ae.isSubscribed) !== !1;
      }
    )), b = n(() => a.value.length > 0), r = n(() => g.layoutMode.value === "speaker"), u = n(() => g.speakerModeParticipant.value), m = n(() => g.activeSpeaker.value), V = n(() => {
      const X = b.value, Re = r.value && !!u.value, he = g.pinnedEntities.value.length > 0, de = g.layoutMode.value === "grid" || g.layoutMode.value === "auto";
      return X || Re || he && de;
    }), h = n(() => {
      var Ae;
      if (!V.value) return [];
      const X = (Ae = v.value) == null ? void 0 : Ae.localParticipant, Re = [
        ...X ? [X] : [],
        ...C.value || []
      ], he = /* @__PURE__ */ new Set();
      b.value || g.pinnedEntities.value.forEach((Ee) => {
        Ee.type === "participant" && Ee.participant && he.add(Ee.participant.identity);
      }), !b.value && r.value && u.value && g.pinnedEntities.value.length === 0 && he.add(u.value.identity);
      const de = g.getControlledStripParticipants(
        Re,
        he,
        k.maxParticipants
      );
      return b.value || r.value, de;
    }), D = A(null), T = A(!1), f = A(!1), w = A(!1), j = () => {
      const X = window.innerWidth;
      return X <= 768 ? {
        type: "mobile",
        maxVisible: 2,
        tileWidth: 110,
        tileHeight: 62,
        gap: 5
      } : X <= 1024 ? {
        type: "tablet",
        maxVisible: 4,
        tileWidth: 140,
        tileHeight: 79,
        gap: 8
      } : {
        type: "desktop",
        maxVisible: 6,
        tileWidth: 160,
        tileHeight: 90,
        gap: 10
      };
    }, p = A(j()), z = () => {
      p.value = j(), T.value = p.value.type === "mobile";
    }, R = n(() => h.value.length > p.value.maxVisible), U = n(() => h.value.length <= p.value.maxVisible), Z = A(1), H = n(() => Math.ceil(h.value.length / p.value.maxVisible)), ee = n(() => {
      const X = (Z.value - 1) * p.value.maxVisible, Re = X + p.value.maxVisible;
      return h.value.slice(X, Re);
    }), ae = () => {
      f.value = Z.value > 1, w.value = Z.value < H.value;
    }, we = () => {
      ae();
    }, Te = () => {
      Z.value > 1 && Z.value--, ae();
    }, Ue = () => {
      Z.value < H.value && Z.value++, ae();
    };
    ht(() => {
      z(), ae(), window.addEventListener("resize", z), setTimeout(ae, 100);
    }), ut(() => {
      window.removeEventListener("resize", z);
    }), Ce(
      ee,
      (X) => {
        const Re = X.map((he) => he.identity);
        g.updateStripVisibleParticipants(Re);
      },
      { immediate: !0 }
    );
    const _e = n(() => {
      switch (p.value.type) {
        case "mobile":
          return 8;
        case "tablet":
          return 9;
        case "desktop":
        default:
          return 10;
      }
    }), Ge = n(() => {
      switch (p.value.type) {
        case "mobile":
          return 8;
        case "tablet":
          return 9;
        case "desktop":
        default:
          return 10;
      }
    });
    return Ce(
      h,
      () => {
        Z.value > H.value && H.value > 0 && (Z.value = H.value), ae();
      },
      { flush: "post" }
    ), M({
      hasActiveScreenShare: b,
      isSpeakerMode: r,
      activeSpeaker: m,
      speakerModeParticipant: u,
      shouldShowStrip: V,
      pipParticipants: h,
      maxParticipants: k.maxParticipants
    }), (X, Re) => V.value && h.value.length > 0 ? (i(), c("div", ti, [
      R.value && Z.value > 1 ? (i(), c("button", {
        key: 0,
        class: "nav-button nav-button-prev",
        "aria-label": "Previous participants",
        onClick: Te
      }, [
        Re[1] || (Re[1] = t("svg", {
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          t("path", {
            d: "M12 15L7 10L12 5",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ], -1)),
        t("span", ai, se(Z.value - 1) + "/" + se(H.value), 1)
      ])) : F("", !0),
      t("div", {
        ref_key: "stripContainer",
        ref: D,
        class: De(["participants-strip", { centered: U.value }]),
        onScroll: we
      }, [
        (i(!0), c(He, null, tt(ee.value, (he) => (i(), be(Nt, {
          key: he.identity,
          participant: he,
          "participant-metadata": X.getParticipantMetadata(he.identity),
          "video-ref-handler": X.videoRefHandler,
          size: "small",
          "avatar-size": "small",
          "track-source": S(ve).Source.Camera,
          "has-video-track": X.hasVideoTrack(he.identity),
          "has-audio-track": X.hasAudioTrack(he.identity),
          "has-screen-share": !1,
          "is-speaking": X.getSpeakingStatus(he.identity),
          "is-local": !!he.isLocal,
          "is-pinned": S(g).pinnedEntities.value.some(
            (de) => {
              var Ae;
              return de.type === "participant" && ((Ae = de.participant) == null ? void 0 : Ae.identity) === he.identity;
            }
          ),
          "click-action": "pin",
          "tag-font-size": _e.value,
          "tag-icon-size": Ge.value,
          class: "strip-participant-tile",
          onPinClick: Re[0] || (Re[0] = (de) => X.$emit("pin-click", de))
        }, null, 8, ["participant", "participant-metadata", "video-ref-handler", "track-source", "has-video-track", "has-audio-track", "is-speaking", "is-local", "is-pinned", "tag-font-size", "tag-icon-size"]))), 128))
      ], 34),
      R.value && Z.value < H.value ? (i(), c("button", {
        key: 1,
        class: "nav-button nav-button-next",
        "aria-label": "Next participants",
        onClick: Ue
      }, [
        t("span", ni, se(Z.value + 1) + "/" + se(H.value), 1),
        Re[2] || (Re[2] = t("svg", {
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          t("path", {
            d: "M8 5L13 10L8 15",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ], -1))
      ])) : F("", !0)
    ])) : F("", !0);
  }
}), oi = /* @__PURE__ */ We(ii, [["__scopeId", "data-v-4ceb413c"]]), si = { class: "screenshare-view" }, ri = {
  key: 0,
  class: "screenshare-container"
}, li = {
  key: 0,
  class: "screenshare-placeholder"
}, ci = /* @__PURE__ */ je({
  __name: "ScreenshareView",
  props: {
    videoRefHandler: { type: Function },
    hasAudioTrack: { type: Function },
    getSpeakingStatus: { type: Function },
    getParticipantMetadata: { type: Function }
  },
  emits: ["pin-click"],
  setup(O, { expose: M }) {
    const k = Pe("trackReferences"), e = n(() => k.trackReferences.value.filter(
      (v) => {
        var a, b;
        return v.source === ve.Source.ScreenShare && ((a = v.publication) == null ? void 0 : a.track) && ((b = v.publication) == null ? void 0 : b.isSubscribed) !== !1;
      }
    )), s = n(() => e.value.length > 0);
    return M({
      hasActiveScreenShare: s,
      activeScreenShareRefs: e
    }), (C, g) => (i(), c("div", si, [
      s.value ? (i(), c("div", ri, [
        (i(!0), c(He, null, tt(e.value, (v) => (i(), be(Nt, {
          key: v.participant.identity,
          participant: v.participant,
          "participant-metadata": C.getParticipantMetadata(v.participant.identity),
          "video-ref-handler": C.videoRefHandler,
          size: "fullscreen",
          "track-source": S(ve).Source.ScreenShare,
          "has-video-track": !0,
          "has-audio-track": C.hasAudioTrack(v.participant.identity),
          "has-screen-share": !0,
          "is-speaking": C.getSpeakingStatus(v.participant.identity),
          "is-local": v.participant.isLocal,
          "click-action": "none",
          class: "screenshare-tile",
          onPinClick: g[0] || (g[0] = (a) => C.$emit("pin-click", a))
        }, null, 8, ["participant", "participant-metadata", "video-ref-handler", "track-source", "has-audio-track", "is-speaking", "is-local"]))), 128)),
        e.value.length === 0 ? (i(), c("div", li, " 🖥️ Screenshare loading... ")) : F("", !0)
      ])) : F("", !0)
    ]));
  }
}), ui = /* @__PURE__ */ We(ci, [["__scopeId", "data-v-ab40f479"]]), di = { class: "speaker-view" }, pi = {
  key: 1,
  class: "speaker-container"
}, vi = {
  key: 2,
  class: "speaker-container"
}, mi = {
  key: 3,
  class: "speaker-placeholder"
}, hi = /* @__PURE__ */ je({
  __name: "SpeakerView",
  props: {
    videoRefHandler: { type: Function },
    hasVideoTrack: { type: Function },
    hasAudioTrack: { type: Function },
    getSpeakingStatus: { type: Function },
    getParticipantMetadata: { type: Function }
  },
  emits: ["pin-click"],
  setup(O, { expose: M, emit: k }) {
    const e = k, s = Pe("roomLayout"), C = n(() => s.pinnedEntities.value.length > 0), g = n(() => s.pinnedEntities.value.filter(
      (m) => m.type === "participant" && m.participant
    )), v = n(() => g.value.map((m) => m.participant)), a = A(s.speakerModeParticipant.value), b = (m) => {
      e("pin-click", wt(y({}, m), {
        trackSource: ve.Source.Camera
        // Pinned participants are always camera source
      }));
    };
    Ce(
      () => s.speakerModeParticipant.value,
      (m) => {
        var V;
        if (!C.value) {
          if (!m) {
            a.value = null;
            return;
          }
          if (a.value) {
            const h = a.value.identity;
            if (((V = s.activeSpeaker.value) == null ? void 0 : V.identity) === h)
              return;
          }
          a.value = m;
        }
      },
      { immediate: !0 }
    );
    const r = n(() => s.layoutMode.value === "speaker"), u = n(() => {
      const m = !!a.value, V = r.value;
      return m && V;
    });
    return M({
      speakerToShow: a,
      isSpeakerMode: r,
      hasSpeakerToShow: u
    }), (m, V) => (i(), c("div", di, [
      C.value && v.value.length > 1 ? (i(), be(Sa, {
        key: 0,
        entities: g.value,
        "pinned-items": g.value,
        "device-type": "desktop",
        "max-tiles": 16,
        "video-ref-handler": m.videoRefHandler,
        "has-video-track": m.hasVideoTrack,
        "has-audio-track": m.hasAudioTrack,
        "has-screen-share": () => !1,
        "get-speaking-status": m.getSpeakingStatus,
        class: "pinned-grid-container",
        onPinClick: b
      }, null, 8, ["entities", "pinned-items", "video-ref-handler", "has-video-track", "has-audio-track", "get-speaking-status"])) : C.value && v.value.length === 1 ? (i(), c("div", pi, [
        (i(), be(Nt, {
          key: v.value[0].identity,
          participant: v.value[0],
          "participant-metadata": m.getParticipantMetadata(v.value[0].identity),
          "video-ref-handler": m.videoRefHandler,
          size: "fullscreen",
          "track-source": S(ve).Source.Camera,
          "has-video-track": m.hasVideoTrack(v.value[0].identity),
          "has-audio-track": m.hasAudioTrack(v.value[0].identity),
          "has-screen-share": !1,
          "is-speaking": m.getSpeakingStatus(v.value[0].identity),
          "is-local": !!v.value[0].isLocal,
          "is-pinned": !0,
          "click-action": "pin",
          class: "speaker-tile",
          onPinClick: V[0] || (V[0] = (h) => m.$emit("pin-click", h))
        }, null, 8, ["participant", "participant-metadata", "video-ref-handler", "track-source", "has-video-track", "has-audio-track", "is-speaking", "is-local"]))
      ])) : a.value ? (i(), c("div", vi, [
        (i(), be(Nt, {
          key: a.value.identity,
          participant: a.value,
          "participant-metadata": m.getParticipantMetadata(a.value.identity),
          "video-ref-handler": m.videoRefHandler,
          size: "fullscreen",
          "track-source": S(ve).Source.Camera,
          "has-video-track": m.hasVideoTrack(a.value.identity),
          "has-audio-track": m.hasAudioTrack(a.value.identity),
          "has-screen-share": !1,
          "is-speaking": m.getSpeakingStatus(a.value.identity),
          "is-local": !!a.value.isLocal,
          "is-pinned": !1,
          "click-action": "pin",
          class: "speaker-tile",
          onPinClick: V[1] || (V[1] = (h) => m.$emit("pin-click", h))
        }, null, 8, ["participant", "participant-metadata", "video-ref-handler", "track-source", "has-video-track", "has-audio-track", "is-speaking", "is-local"]))
      ])) : (i(), c("div", mi, " 🎤 Waiting for participants to join... "))
    ]));
  }
}), fi = /* @__PURE__ */ We(hi, [["__scopeId", "data-v-bb29316c"]]), yi = { class: "room-container" }, gi = {
  key: 0,
  class: "preview-container"
}, ki = {
  key: 0,
  class: "preview-placeholder"
}, Si = {
  key: 1,
  class: "permission-button-overlay"
}, bi = { class: "permission-prompt-container" }, wi = { class: "permission-prompt-text" }, Ci = {
  key: 3,
  class: "loading-overlay"
}, Pi = {
  key: 0,
  class: "spinner"
}, Ri = { class: "connection-message" }, Ti = {
  key: 1,
  class: "room-content"
}, Ei = {
  key: 0,
  class: "loading-overlay"
}, Mi = {
  key: 0,
  class: "spinner"
}, Ai = { class: "connection-message" }, xi = {
  key: 1,
  class: "permission-button-overlay"
}, Ii = { class: "permission-revoked-container" }, $i = { class: "permission-revoked-text" }, zi = {
  key: 2,
  class: "error-overlay"
}, Li = { class: "error-message" }, Bi = {
  key: 0,
  class: "recording-consent-modal-overlay"
}, _i = {
  key: 0,
  class: "connection-minutes-modal-overlay"
}, Ni = { class: "connection-minutes-message" }, Fi = { class: "leave-session-header" }, Hi = { class: "leave-session-title" }, Di = { class: "leave-session-body" }, Oi = { class: "leave-session-message" }, Vi = { class: "leave-session-actions" }, ji = /* @__PURE__ */ je({
  __name: "RoomView",
  props: {
    participantId: {},
    participantName: {},
    participantAvatar: {},
    role: {},
    licenseId: {},
    videoFit: { default: "cover" },
    backgroundColor: { default: "#000" },
    borderRadius: {},
    connectionMessage: {},
    enableScreenShareSound: { type: Boolean, default: !1 },
    enableParticipantJoinedSound: { type: Boolean, default: !1 },
    enableHandRaiseSound: { type: Boolean, default: !1 }
  },
  emits: ["room-ready", "participant-joined", "participant-left", "session-started", "session-ended", "connection-state-changed", "session-started-at", "recording-available", "drop-out-of-room", "recording-started", "error"],
  setup(O, { expose: M, emit: k }) {
    oa((l) => ({
      "4d51db6d": e.backgroundColor,
      "1995c374": e.borderRadius,
      "05280004": e.videoFit
    })), at("isInsideRoomViewSlot", !0);
    const e = O, s = k, C = A(null), g = A(null), v = A(e.connectionMessage), a = A("idle"), b = A(""), r = A(null), u = A(!1), m = A(null), V = A(!1), h = A(!1), D = A(!1), T = A(!1), f = A(""), w = n(() => {
      const l = ye.cameraPermission.value.state === "denied" || ye.cameraPermission.value.state === "prompt", P = ye.microphonePermission.value.state === "denied" || ye.microphonePermission.value.state === "prompt";
      return l || P;
    }), j = n(() => {
      const l = ye.cameraPermission.value.state === "denied" || ye.cameraPermission.value.state === "prompt", P = ye.microphonePermission.value.state === "denied" || ye.microphonePermission.value.state === "prompt";
      return l && P ? "Allow camera and microphone" : l ? "Allow camera" : P ? "Allow microphone" : "Allow media access";
    }), p = n(() => {
      const l = ye.cameraPermission.value.state === "denied" || ye.cameraPermission.value.state === "prompt", P = ye.microphonePermission.value.state === "denied" || ye.microphonePermission.value.state === "prompt";
      return l && P ? "Do you want people to see and hear you in the session?" : l ? "Do you want people to see you in the session?" : P ? "Do you want people to hear you in the session?" : "Do you want to enable media access?";
    }), z = A(!1), R = A(!1), U = A(!1), Z = A(!1), H = A(!1), ee = A(!1), ae = A(!1);
    Na("permission-denied").on((l) => {
      const P = {
        camera: "Host disabled participant camera",
        microphone: "Host disabled participant microphone",
        screenshare: "Host disabled participant screen sharing"
      };
      f.value = P[l.type], T.value = !0;
    });
    const Te = (l) => {
      D.value = l;
    }, Ue = () => `recording-consent-${e.licenseId}-${e.participantId}`, _e = () => {
      const l = Ue(), P = localStorage.getItem(l);
      if (!P) return !1;
      try {
        const J = JSON.parse(P), pe = J.timestamp, ct = (Date.now() - pe) / (1e3 * 60 * 60);
        return J.agreed === !0 && ct < 24;
      } catch (J) {
        return P === "true";
      }
    }, Ge = () => {
      const l = Ue(), P = {
        agreed: !0,
        timestamp: Date.now(),
        licenseId: e.licenseId,
        participantId: e.participantId
      };
      localStorage.setItem(l, JSON.stringify(P)), X();
    }, X = () => {
      const l = "recording-consent-", P = [];
      for (let J = 0; J < localStorage.length; J++) {
        const pe = localStorage.key(J);
        if (pe && pe.startsWith(l))
          try {
            const te = localStorage.getItem(pe);
            if (te) {
              const ct = JSON.parse(te);
              (Date.now() - ct.timestamp) / (1e3 * 60 * 60) > 24 && P.push(pe);
            }
          } catch (te) {
            P.push(pe);
          }
      }
      P.forEach((J) => localStorage.removeItem(J));
    }, Re = () => {
      Ge(), z.value = !1, R.value = !0;
    }, he = () => {
      z.value = !1, R.value = !0, Mt();
    }, de = () => {
      Z.value = !1;
    }, Ae = () => {
      Z.value = !1, Mt();
    }, Ee = () => {
      ae.value = !0;
    }, Ve = () => {
      ae.value = !1;
    }, Ke = () => {
      Ve();
    }, o = () => me(this, null, function* () {
      ae.value = !1, yield Mt();
    }), d = (l) => {
      if (s("recording-started"), !R.value) {
        if (_e()) {
          R.value = !0;
          return;
        }
        z.value = !0, R.value = !0;
      }
    }, {
      connect: L,
      disconnect: K,
      connectionState: le,
      error: Be,
      transferLocalMediaToRoom: Xe
    } = Gt(), fe = Fa(), xe = Kt(), ye = _a(), G = st(), ke = Pe("trackReferences"), rt = Sn(), E = Pe("roomLayout"), _ = Pe("speechDetection"), W = bn(), Y = Jt(), oe = Pe("participants"), {
      participantCount: ce,
      remoteParticipants: ue,
      onTrackSubscribed: re,
      onTrackUnsubscribed: Se,
      getParticipantMetadata: Ie
    } = oe, { isRecording: ne, remainingMinutes: $e, remainingPercentage: Qe } = Ha(), Oe = sa(), Ye = n(() => le.value === "connected"), Me = n(() => Y.inRoomMode.value ? xe.isCameraEnabled.value : ye.isCameraEnabled.value), Ne = n(() => {
      var J;
      const l = (J = G.value) == null ? void 0 : J.localParticipant;
      return l ? _.getParticipantSpeakingStatus(
        l.identity
      ) : !1;
    }), Je = n(() => {
      var J;
      const l = (J = G.value) == null ? void 0 : J.localParticipant;
      return l ? _.getParticipantAudioLevel(
        l.identity
      ) : 0;
    }), qe = n(() => e.role), St = n(() => {
      const l = $e.value;
      return `${l.toLocaleString()} connection minute${l !== 1 ? "s" : ""}`;
    }), Ct = A(null), Pt = A(
      null
    ), ft = n(() => ke.trackReferences.value.filter(
      (J) => {
        var pe, te;
        return J.source === ve.Source.ScreenShare && ((pe = J.publication) == null ? void 0 : pe.track) && ((te = J.publication) == null ? void 0 : te.isSubscribed) !== !1;
      }
    ).length > 0), Rt = n(() => {
      const l = ke.trackReferences.value;
      return (l != null ? l : []).filter(
        (J) => {
          var pe, te;
          return J.source === ve.Source.ScreenShare && ((pe = J.publication) == null ? void 0 : pe.track) && ((te = J.publication) == null ? void 0 : te.isSubscribed) !== !1;
        }
      ).length;
    });
    Ce(
      Rt,
      (l, P) => me(this, null, function* () {
        if (l > P && e.enableScreenShareSound)
          try {
            yield Oe.playSound(
              Wt.SCREEN_SHARE_STARTED
            );
          } catch (J) {
          }
      }),
      { immediate: !0 }
    );
    const bt = n(() => {
      const l = E.layoutMode.value === "speaker", P = !!E.speakerModeParticipant.value;
      return l && P;
    }), yt = n(() => ft.value ? "screenshare" : bt.value ? "speaker" : "normal"), gt = rt.setParticipantVideoRef, lt = () => {
      var l, P;
      if (g.value) {
        if (!Me.value) {
          g.value.srcObject && (g.value.srcObject = null);
          return;
        }
        try {
          let J = null;
          if (Y.inRoomMode.value) {
            const pe = Y.getLocalParticipant();
            if ((P = (l = pe == null ? void 0 : pe.cameraTrack) == null ? void 0 : l.value) != null && P.track) {
              const te = pe.cameraTrack.value.track;
              J = new MediaStream(), "mediaStreamTrack" in te ? J.addTrack(te.mediaStreamTrack) : "id" in te && "kind" in te && J.addTrack(te);
            }
          } else
            J = ye.cameraStream.value;
          J && J.getTracks().length > 0 && (g.value.srcObject = J, g.value.onloadedmetadata = () => {
            var pe;
            (pe = g.value) == null || pe.play().catch(
              (te) => {
              }
            );
          });
        } catch (J) {
        }
      }
    }, Tt = (l, P, J) => {
      rt.updateParticipantVideoTrack(l.identity, P);
    }, Et = W.updateParticipantAudioTrack, $ = rt.clearParticipantVideo, ge = W.clearParticipantAudio, Fe = () => {
      G.value && G.value.remoteParticipants.forEach((l) => {
        const P = l.getTrackPublication(ve.Source.Microphone);
        P != null && P.track && Et(l, P.track, P);
        const J = l.getTrackPublication(ve.Source.Camera);
        J != null && J.track && Tt(l, J.track);
      });
    }, it = (l) => {
      if (l.trackSource === ve.Source.ScreenShare) {
        const P = {
          id: `${l.participant.identity}-screenshare`,
          type: "screen-share",
          screenShare: {
            participant: l.participant,
            track: {
              trackSid: "unknown",
              // Not needed for pinning
              trackName: "Screen Share",
              source: ve.Source.ScreenShare
            },
            startTime: Date.now()
            // Not needed for pinning
          }
        };
        E.toggleEntityPin(P);
      } else
        E.toggleParticipantPin(
          l.participant
        );
    }, q = () => {
      V.value = !0;
    };
    at("showParticipantsModal", q);
    const zt = Pe("setSessionToken");
    Bt(() => {
      zt && b.value && zt(b.value);
    });
    const Ft = () => {
      var pe;
      const l = (pe = G.value) == null ? void 0 : pe.localParticipant;
      return [
        ...ue.value || [],
        ...l ? [l] : []
      ].some((te) => {
        const ct = Y.getParticipantRole(te);
        return l == null || l.identity, te.identity, ct === "host";
      });
    }, kt = (l, P) => me(this, null, function* () {
      var J;
      b.value = P;
      try {
        v.value = "Connecting to room...", a.value = "connecting", u.value = !0;
        const pe = {
          licenseId: l,
          participantToken: b.value,
          skipMediaTransfer: !1,
          connectOptions: {
            autoSubscribe: !0
            // Ensures we automatically subscribe to remote tracks
          }
        }, te = yield L(pe);
        return te.startedAt && s("session-started-at", te.startedAt), te.recordingAvailable && s("recording-available", te.recordingAvailable), te.canJoin ? (v.value = te.message || "Connecting to room...", yield Xe(), fe.setRole(e.role), s("connection-state-changed", "connected"), s("session-started"), s("room-ready", {
          hasCamera: Me.value,
          hasMicrophone: xe.isMicrophoneEnabled.value,
          participantCount: ce.value
        }), lt(), Fe(), (J = G.value) != null && J.localParticipant && _.setupRemoteAudioAnalysis(
          G.value.localParticipant
        ), e.role === "host" || e.role === "attendee" && Ft() ? (a.value = "connected", u.value = !1, v.value = "") : (a.value = "waiting-for-host", u.value = !0, v.value = "Waiting for host...", Ht()), te) : (v.value = te.message || "Cannot join the room.", te.retryInSeconds ? (u.value = !0, setTimeout(() => {
          kt(l, b.value);
        }, te.retryInSeconds * 1e3)) : (e.role, u.value = !1), te);
      } catch (pe) {
        a.value = "idle", u.value = !1;
        const te = pe instanceof Error ? pe : new Error("Failed to join room");
        s("error", te);
      }
    }), Mt = () => me(this, null, function* () {
      try {
        h.value = !0, a.value = "leaving", v.value = "Dropping out...", u.value = !0, yield K({
          licenseId: e.licenseId,
          participantToken: b.value
        }), e.role === "host" ? (a.value = "ended", v.value = "This session has ended.", u.value = !1, s("session-ended")) : (a.value = "ended", v.value = "You left the session.", u.value = !1), b.value = "", s("drop-out-of-room"), s("connection-state-changed", "completed"), dt();
      } catch (l) {
        const P = l instanceof Error ? l : new Error("Failed to leave room");
        s("error", P);
      }
    }), Ht = () => {
      r.value && (clearInterval(r.value), r.value = null);
      const l = () => me(this, null, function* () {
        if (a.value === "kicked") {
          dt();
          return;
        }
        try {
          const { state: P, recordingEnabled: J } = yield Qa.getLiveSessionState(e.licenseId);
          if (P === qt.COMPLETED) {
            a.value = "ended";
            try {
              b.value && (yield K({
                licenseId: e.licenseId,
                participantToken: b.value
              }));
            } catch (pe) {
            }
            v.value = J ? "This session has ended. A recording will be available soon." : "This session has ended.", u.value = !1, s("connection-state-changed", "completed"), s("session-ended"), dt();
          } else P === qt.DISCONNECTED ? e.role === "attendee" && (a.value = "waiting-for-host", v.value = "The host is reconnecting. Please wait...", u.value = !0) : P === qt.SCHEDULED && e.role === "attendee" && (a.value = "waiting-for-host", v.value = "Waiting for host to start...", u.value = !0);
        } catch (P) {
        }
      });
      l(), r.value = window.setInterval(l, 5e3);
    }, dt = () => {
      r.value && (clearInterval(r.value), r.value = null);
    }, Zt = () => {
      At(), m.value = window.setTimeout(() => {
        Xt();
      }, 1 * 60 * 1e3);
    }, At = () => {
      m.value && (clearTimeout(m.value), m.value = null);
    }, Xt = () => me(this, null, function* () {
      try {
        yield K({
          licenseId: e.licenseId,
          participantToken: b.value
        }), a.value = "ended", v.value = "Connection lost. Please refresh to rejoin.", u.value = !1, s("connection-state-changed", "timeout"), s("session-ended"), s("error", new Error("Reconnection timeout"));
      } catch (l) {
      }
    });
    return Ce(ne, (l) => {
      !U.value && a.value === "connected" && (U.value = !0), l && d();
    }), Ce(Qe, (l) => {
      if (e.role !== "host" || a.value !== "connected")
        return;
      const { THRESHOLDS: P } = Da;
      if (l < P.FORCE_DISCONNECT && l > 0) {
        Mt();
        return;
      }
      if (l <= P.FINAL_WARNING && l >= P.FORCE_DISCONNECT && !ee.value) {
        ee.value = !0, Z.value = !0;
        return;
      }
      if (l <= P.FIRST_WARNING && l > P.FINAL_WARNING && !H.value) {
        H.value = !0, Z.value = !0;
        return;
      }
    }), Ce(
      [
        () => xe.isCameraEnabled.value,
        () => xe.cameraTrack.value
      ],
      () => {
        lt();
      }
    ), Ce(
      [() => Me.value, () => ye.cameraStream.value],
      () => {
        lt();
      }
    ), Ce(
      ue,
      (l, P) => {
        const J = new Set((P || []).map((te) => te.identity)), pe = new Set((l || []).map((te) => te.identity));
        l == null || l.forEach((te) => me(this, null, function* () {
          var ct;
          if (!J.has(te.identity)) {
            s("participant-joined", { participantCount: l.length });
            const xt = (ct = G.value) == null ? void 0 : ct.localParticipant, ra = (xt == null ? void 0 : xt.identity) === te.identity;
            if (e.enableParticipantJoinedSound && !ra)
              try {
                yield Oe.playSound(
                  Wt.PARTICIPANT_JOINED
                );
              } catch (x) {
              }
            _.setupRemoteAudioAnalysis(te);
          }
        })), P == null || P.forEach((te) => {
          pe.has(te.identity) || (s("participant-left", { participantCount: l.length }), ge(te.identity), E.removePinByParticipantId(te.identity));
        });
      },
      { deep: !0 }
    ), Ce(
      () => le.value,
      (l, P) => {
        l === vt.Reconnecting || l === vt.SignalReconnecting ? (a.value = "reconnecting", v.value = "Reconnecting...", u.value = !0, Zt()) : (P === vt.Reconnecting || P === vt.SignalReconnecting) && l === vt.Connected ? (At(), a.value = "connected", v.value = "", u.value = !1) : l === vt.Disconnected && P === vt.Connected && !h.value && a.value !== "leaving" && a.value !== "ended" && (a.value = "kicked", v.value = "You've been disconnected from the session.", u.value = !1, At(), dt(), s("connection-state-changed", "kicked"), s("session-ended")), l === vt.Disconnected && (h.value = !1), s("connection-state-changed", l);
      }
    ), Ce(
      () => xe.isCameraEnabled.value,
      (l) => {
        setTimeout(() => {
          lt();
        }, 500);
      }
    ), Ce(re, (l) => {
      l && (l.trackKind === ve.Kind.Video ? Tt(
        l.participant,
        l.track,
        l.publication
      ) : l.trackKind === ve.Kind.Audio && (Et(
        l.participant,
        l.track,
        l.publication
      ), _.setupRemoteAudioAnalysis(l.participant)));
    }), Ce(Se, (l) => {
      l && (l.trackKind === ve.Kind.Video ? $(l.participant.identity, l.track) : l.trackKind === ve.Kind.Audio && (ge(l.participant.identity, l.track), _.cleanupAudioAnalysis(l.participant.identity)));
    }), Bt(() => me(this, null, function* () {
      if (e.role !== "attendee" || !Ye.value) return;
      const l = Ft();
      l ? l && (dt(), a.value === "waiting-for-host" && (a.value = "connected", v.value = "", u.value = !1)) : (r.value && (clearInterval(r.value), r.value = null), Ht(), u.value = !0, v.value = "Waiting for host...", a.value = "waiting-for-host");
    })), ht(() => me(this, null, function* () {
      lt(), G.value && (G.value.remoteParticipants.forEach((l) => {
        _.setupRemoteAudioAnalysis(l);
      }), G.value.localParticipant && _.setupRemoteAudioAnalysis(
        G.value.localParticipant
      ));
    })), ut(() => {
      var l;
      dt(), At(), rt.cleanup(), W.cleanupAllAudioTracks(), Ye.value && K({
        licenseId: "",
        participantToken: ""
      }).catch(console.error), (l = g.value) != null && l.srcObject && (g.value.srcObject = null);
      try {
        ye.cleanup();
      } catch (P) {
      }
    }), M({
      joinRoom: kt,
      leaveRoom: Ee,
      toggleShowPermissionModal: Te,
      isConnected: Ye,
      participantCount: ce,
      role: qe,
      // Enhanced session state
      roomConnectionState: a,
      connectionMessage: v,
      sessionToken: b,
      // Layout controls
      setLayoutMode: E.setLayoutMode,
      toggleParticipantPin: E.toggleParticipantPin,
      layoutMode: E.layoutMode,
      pinnedItems: E.pinnedEntities,
      // Use new property name
      // Modal controls
      showParticipantsModal: q
    }), (l, P) => (i(), c("div", {
      ref_key: "roomViewRef",
      ref: C,
      class: "room-view"
    }, [
      t("div", yi, [
        Ye.value ? (i(), c("div", Ti, [
          a.value === "connecting" || a.value === "waiting-for-host" || a.value === "reconnecting" || a.value === "ended" || a.value === "kicked" ? (i(), c("div", Ei, [
            u.value ? (i(), c("div", Mi)) : F("", !0),
            t("p", Ai, se(v.value), 1)
          ])) : F("", !0),
          a.value === "connected" ? (i(), be(ei, {
            key: 1,
            position: "bottom-left",
            "show-names": !0
          })) : F("", !0),
          a.value === "connected" ? (i(), c(He, { key: 2 }, [
            Q(oi, {
              "video-ref-handler": S(gt),
              "has-video-track": S(ke).hasVideoTrack,
              "has-audio-track": S(ke).hasAudioTrack,
              "get-speaking-status": S(_).getParticipantSpeakingStatus,
              "get-participant-metadata": S(Ie),
              onPinClick: it
            }, null, 8, ["video-ref-handler", "has-video-track", "has-audio-track", "get-speaking-status", "get-participant-metadata"]),
            t("div", {
              class: De(["stage-section", { "fullscreen-stage": yt.value !== "normal" }])
            }, [
              yt.value === "screenshare" ? (i(), be(ui, {
                key: 0,
                ref_key: "screenshareViewRef",
                ref: Ct,
                "video-ref-handler": S(gt),
                "has-audio-track": S(ke).hasAudioTrack,
                "get-speaking-status": S(_).getParticipantSpeakingStatus,
                "get-participant-metadata": S(Ie),
                onPinClick: it
              }, null, 8, ["video-ref-handler", "has-audio-track", "get-speaking-status", "get-participant-metadata"])) : yt.value === "speaker" ? (i(), be(fi, {
                key: 1,
                ref_key: "speakerViewRef",
                ref: Pt,
                "video-ref-handler": S(gt),
                "has-video-track": S(ke).hasVideoTrack,
                "has-audio-track": S(ke).hasAudioTrack,
                "get-speaking-status": S(_).getParticipantSpeakingStatus,
                "get-participant-metadata": S(Ie),
                onPinClick: it
              }, null, 8, ["video-ref-handler", "has-video-track", "has-audio-track", "get-speaking-status", "get-participant-metadata"])) : (i(), be(Nn, {
                key: 2,
                "stage-zone": S(E).stageZone.value,
                "pinned-items": S(E).pinnedEntities.value,
                "device-type": S(E).deviceType.value,
                "video-ref-handler": S(gt),
                "has-video-track": S(ke).hasVideoTrack,
                "has-audio-track": S(ke).hasAudioTrack,
                "has-screen-share": S(ke).hasScreenShare,
                "get-speaking-status": S(_).getParticipantSpeakingStatus,
                "get-audio-level": S(_).getParticipantAudioLevel,
                onPinClick: it
              }, null, 8, ["stage-zone", "pinned-items", "device-type", "video-ref-handler", "has-video-track", "has-audio-track", "has-screen-share", "get-speaking-status", "get-audio-level"]))
            ], 2),
            V.value ? (i(), be(Zn, {
              key: 0,
              visible: V.value,
              onClose: P[2] || (P[2] = (J) => V.value = !1)
            }, null, 8, ["visible"])) : F("", !0),
            T.value ? (i(), c("div", xi, [
              t("div", Ii, [
                t("p", $i, se(f.value), 1),
                t("button", {
                  class: "permission-revoked-button",
                  onClick: P[3] || (P[3] = (J) => T.value = !1)
                }, P[7] || (P[7] = [
                  t("span", null, "Ok", -1)
                ]))
              ])
            ])) : F("", !0)
          ], 64)) : F("", !0)
        ])) : (i(), c("div", gi, [
          t("video", {
            ref_key: "previewVideo",
            ref: g,
            autoplay: "",
            muted: "",
            playsinline: "",
            class: "preview-video"
          }, null, 512),
          Me.value ? F("", !0) : (i(), c("div", ki, [
            Q(Yt, {
              name: l.participantName,
              image: l.participantAvatar,
              size: "medium",
              "is-speaking": Ne.value,
              "audio-level": Je.value
            }, null, 8, ["name", "image", "is-speaking", "audio-level"])
          ])),
          !Ye.value && w.value ? (i(), c("div", Si, [
            t("div", bi, [
              t("p", wi, se(p.value), 1),
              t("button", {
                class: "permission-button",
                onClick: P[0] || (P[0] = (J) => D.value = !0)
              }, [
                t("span", null, se(j.value), 1)
              ])
            ])
          ])) : F("", !0),
          D.value ? (i(), be(ha, {
            key: 2,
            "camera-permission": S(ye).cameraPermission.value,
            "microphone-permission": S(ye).microphonePermission.value,
            onClose: P[1] || (P[1] = (J) => D.value = !1)
          }, null, 8, ["camera-permission", "microphone-permission"])) : F("", !0),
          a.value !== "connected" && a.value !== "idle" ? (i(), c("div", Ci, [
            u.value ? (i(), c("div", Pi)) : F("", !0),
            t("p", Ri, se(v.value), 1)
          ])) : F("", !0)
        ])),
        _t(l.$slots, "controls", {}, void 0, !0),
        _t(l.$slots, "chat", {}, void 0, !0),
        S(Be) ? (i(), c("div", zi, [
          t("div", Li, [
            P[8] || (P[8] = t("h3", null, "Connection Error", -1)),
            t("p", null, se(S(Be).message), 1)
          ])
        ])) : F("", !0)
      ]),
      (i(), be(jt, { to: "body" }, [
        z.value ? (i(), c("div", Bi, [
          t("div", {
            class: "recording-consent-modal",
            onClick: P[4] || (P[4] = Ze(() => {
            }, ["stop"]))
          }, [
            t("div", { class: "recording-consent-header" }, [
              P[10] || (P[10] = t("h3", { class: "recording-consent-title" }, "This meeting is recorded", -1)),
              t("button", {
                class: "recording-consent-close",
                "aria-label": "Close",
                onClick: he
              }, P[9] || (P[9] = [
                t("svg", {
                  width: "20",
                  height: "20",
                  viewBox: "0 0 20 20",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  t("path", {
                    d: "M15 5L5 15M5 5L15 15",
                    stroke: "currentColor",
                    "stroke-width": "1.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1)
              ]))
            ]),
            P[11] || (P[11] = t("p", { class: "recording-consent-message" }, " By continuing to be in the meeting, you are consenting to be recorded ", -1)),
            t("div", { class: "recording-consent-footer" }, [
              t("div", { class: "recording-consent-buttons" }, [
                t("button", {
                  class: "recording-consent-button recording-consent-leave",
                  onClick: he
                }, " Leave "),
                t("button", {
                  class: "recording-consent-button recording-consent-continue",
                  onClick: Re
                }, " Continue ")
              ])
            ])
          ])
        ])) : F("", !0)
      ])),
      (i(), be(jt, { to: "body" }, [
        Z.value ? (i(), c("div", _i, [
          t("div", {
            class: "connection-minutes-modal",
            onClick: P[5] || (P[5] = Ze(() => {
            }, ["stop"]))
          }, [
            t("button", {
              class: "connection-minutes-close",
              "aria-label": "Close",
              onClick: de
            }, P[12] || (P[12] = [
              t("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                t("path", {
                  d: "M15 5L5 15M5 5L15 15",
                  stroke: "currentColor",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ], -1)
            ])),
            P[13] || (P[13] = t("div", { class: "connection-minutes-icon" }, [
              t("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "32",
                height: "32",
                viewBox: "0 0 32 32",
                fill: "none"
              }, [
                t("path", {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M4 2.66683C4 1.93045 4.59695 1.3335 5.33333 1.3335H26.6667C27.403 1.3335 28 1.93045 28 2.66683C28 3.40321 27.403 4.00016 26.6667 4.00016H25.3333V6.3359C25.3333 6.38782 25.3334 6.43905 25.3334 6.48962C25.3339 7.44208 25.3343 8.1614 25.1502 8.84561C24.9879 9.44873 24.721 10.0187 24.3615 10.5294C23.9538 11.1089 23.4009 11.5691 22.6689 12.1784C22.63 12.2108 22.5906 12.2436 22.5508 12.2768L18.0827 16.0002L22.5508 19.7235C22.5906 19.7568 22.63 19.7895 22.6689 19.8219C23.4009 20.4312 23.9538 20.8915 24.3615 21.4709C24.721 21.9817 24.9879 22.5516 25.1502 23.1547C25.3343 23.8389 25.3339 24.5582 25.3334 25.5107C25.3334 25.5613 25.3333 25.6125 25.3333 25.6644V28.0002H26.6667C27.403 28.0002 28 28.5971 28 29.3335C28 30.0699 27.403 30.6668 26.6667 30.6668H5.33333C4.59695 30.6668 4 30.0699 4 29.3335C4 28.5971 4.59695 28.0002 5.33333 28.0002H6.66667V25.6644C6.66667 25.6125 6.66664 25.5613 6.66661 25.5107C6.66611 24.5582 6.66572 23.8389 6.8498 23.1547C7.01207 22.5516 7.27901 21.9817 7.63847 21.4709C8.04625 20.8915 8.59909 20.4312 9.33112 19.8219C9.36998 19.7895 9.40936 19.7568 9.44924 19.7235L13.9173 16.0002L9.44924 12.2768C9.40935 12.2436 9.36998 12.2108 9.33111 12.1784C8.59909 11.5691 8.04625 11.1089 7.63847 10.5294C7.27901 10.0187 7.01207 9.44873 6.8498 8.84561C6.66572 8.1614 6.66611 7.44208 6.66661 6.48962C6.66664 6.43905 6.66667 6.38781 6.66667 6.3359V4.00016H5.33333C4.59695 4.00016 4 3.40321 4 2.66683ZM9.33333 4.00016V6.3359C9.33333 7.50991 9.34405 7.85229 9.4249 8.1528C9.50603 8.45436 9.63951 8.73933 9.81923 8.99472C9.99834 9.24921 10.2545 9.47663 11.1564 10.2282L16 14.2646L20.8436 10.2282C21.7455 9.47663 22.0017 9.24921 22.1808 8.99472C22.3605 8.73933 22.494 8.45437 22.5751 8.1528C22.6559 7.85229 22.6667 7.50991 22.6667 6.3359V4.00016H9.33333ZM16 17.7358L11.1564 21.7721C10.2545 22.5237 9.99834 22.7511 9.81923 23.0056C9.63951 23.261 9.50603 23.546 9.4249 23.8475C9.34405 24.148 9.33333 24.4904 9.33333 25.6644V28.0002H22.6667V25.6644C22.6667 24.4904 22.6559 24.148 22.5751 23.8475C22.494 23.546 22.3605 23.261 22.1808 23.0056C22.0017 22.7511 21.7455 22.5237 20.8436 21.7721L16 17.7358Z",
                  fill: "#155EEF"
                })
              ])
            ], -1)),
            P[14] || (P[14] = t("h3", { class: "connection-minutes-title" }, "Low Connection Minutes", -1)),
            t("p", Ni, " Your have " + se(St.value) + " left. ", 1),
            t("div", { class: "connection-minutes-footer" }, [
              t("div", { class: "connection-minutes-buttons" }, [
                t("button", {
                  class: "connection-minutes-button connection-minutes-close-btn",
                  onClick: de
                }, " Close "),
                t("button", {
                  class: "connection-minutes-button connection-minutes-upgrade",
                  onClick: Ae
                }, " Leave ")
              ])
            ])
          ])
        ])) : F("", !0)
      ])),
      (i(), be(jt, { to: "body" }, [
        ae.value ? (i(), c("div", {
          key: 0,
          class: "leave-session-modal-overlay",
          onClick: Ke
        }, [
          t("div", {
            class: "leave-session-modal",
            onClick: P[6] || (P[6] = Ze(() => {
            }, ["stop"]))
          }, [
            t("div", Fi, [
              t("h3", Hi, se(qe.value === "host" ? "End session" : "Leave session"), 1)
            ]),
            t("div", Di, [
              t("p", Oi, se(qe.value === "host" ? "Are you sure you want to end this session for everyone?" : "Are you sure you want to leave this session?"), 1)
            ]),
            t("div", Vi, [
              t("button", {
                class: "leave-session-button cancel-button",
                onClick: Ve
              }, " Cancel "),
              t("button", {
                class: "leave-session-button confirm-button",
                onClick: o
              }, se(qe.value === "host" ? "End session" : "Leave session"), 1)
            ])
          ])
        ])) : F("", !0)
      ]))
    ], 512));
  }
}), as = /* @__PURE__ */ We(ji, [["__scopeId", "data-v-350ec68b"]]), Wi = { class: "picker-content" }, Ui = ["onClick"], Gi = { class: "emoji-text" }, Ki = /* @__PURE__ */ je({
  __name: "ReactionPicker",
  props: {
    visible: { type: Boolean },
    emojis: { default: () => ["👍", "❤️", "😂", "👏", "🎉", "😮"] },
    anchorEl: {},
    position: { default: "top" },
    pickerStyle: {},
    emojiButtonStyle: {},
    backgroundColor: { default: "rgba(32, 33, 36, 0.98)" },
    borderRadius: { default: "12px" },
    boxShadow: { default: "0 4px 24px rgba(0, 0, 0, 0.3)" }
  },
  emits: ["select", "close"],
  setup(O, { emit: M }) {
    const k = O, e = M, s = A(), C = n(() => {
      const r = y({
        backgroundColor: k.backgroundColor,
        borderRadius: k.borderRadius,
        boxShadow: k.boxShadow
      }, k.pickerStyle);
      if (k.anchorEl && s.value) {
        const u = k.anchorEl.getBoundingClientRect(), m = 8;
        switch (k.position) {
          case "top":
            r.bottom = `${window.innerHeight - u.top + m}px`, r.left = `${u.left + u.width / 2}px`, r.transform = "translateX(-50%)";
            break;
          case "bottom":
            r.top = `${u.bottom + m}px`, r.left = `${u.left + u.width / 2}px`, r.transform = "translateX(-50%)";
            break;
          case "left":
            r.right = `${window.innerWidth - u.left + m}px`, r.top = `${u.top + u.height / 2}px`, r.transform = "translateY(-50%)";
            break;
          case "right":
            r.left = `${u.right + m}px`, r.top = `${u.top + u.height / 2}px`, r.transform = "translateY(-50%)";
            break;
        }
      }
      return r;
    }), g = n(() => y({}, k.emojiButtonStyle)), v = (r) => {
      e("select", r), e("close");
    }, a = (r) => {
      s.value && !s.value.contains(r.target) && k.anchorEl && !k.anchorEl.contains(r.target) && e("close");
    }, b = (r) => {
      r.key === "Escape" && e("close");
    };
    return ht(() => {
      k.visible && (document.addEventListener("click", a), document.addEventListener("keydown", b));
    }), ut(() => {
      document.removeEventListener("click", a), document.removeEventListener("keydown", b);
    }), Ce(
      () => k.visible,
      (r) => {
        r ? setTimeout(() => {
          document.addEventListener("click", a), document.addEventListener("keydown", b);
        }, 100) : (document.removeEventListener("click", a), document.removeEventListener("keydown", b));
      }
    ), (r, u) => (i(), be(na, { name: "picker-fade" }, {
      default: nt(() => [
        r.visible ? (i(), c("div", {
          key: 0,
          ref_key: "pickerRef",
          ref: s,
          class: "reaction-picker",
          style: I(C.value)
        }, [
          t("div", Wi, [
            (i(!0), c(He, null, tt(r.emojis, (m) => (i(), c("button", {
              key: m,
              type: "button",
              class: "emoji-button",
              style: I(g.value),
              onClick: (V) => v(m)
            }, [
              t("span", Gi, se(m), 1)
            ], 12, Ui))), 128))
          ])
        ], 4)) : F("", !0)
      ]),
      _: 1
    }));
  }
}), Yi = /* @__PURE__ */ We(Ki, [["__scopeId", "data-v-206cd94d"]]), Ji = ["data-control-size", "data-gap-size", "data-dropdown-width", "data-edge-offset"], Zi = {
  key: 0,
  class: "permission-indicator",
  title: "Camera access denied"
}, Xi = {
  key: 0,
  class: "permission-indicator",
  title: "Microphone access denied"
}, Qi = {
  key: 0,
  class: "permission-indicator",
  title: "Screen sharing access denied"
}, qi = {
  key: 3,
  class: "settings-container control-item"
}, eo = {
  key: 0,
  class: "controls-end"
}, to = { class: "dropdown-content" }, ao = { class: "select-wrapper" }, no = ["value"], io = ["value"], oo = { class: "select-wrapper" }, so = ["value"], ro = ["value"], lo = { class: "select-wrapper" }, co = ["value"], uo = ["value"], po = {
  key: 0,
  class: "mic-meter-wrapper"
}, vo = { class: "select-wrapper" }, mo = ["value"], ho = ["value"], fo = /* @__PURE__ */ je({
  __name: "RoomControlBar",
  props: {
    embeddedPosition: { default: "bottom" },
    containerStyle: {},
    barBackgroundColor: { default: "none" },
    buttonStyle: {},
    activeButtonStyle: {},
    hoverButtonStyle: {},
    disabledButtonStyle: {},
    iconStyle: {},
    iconColor: { default: "white" },
    activeIconColor: { default: "#4285f4" },
    dropdownStyle: {},
    dropdownItemStyle: {},
    dropdownItemHoverStyle: {},
    dropdownBackgroundColor: { default: "rgba(32, 33, 36, 0.98)" },
    textStyle: {},
    textColor: { default: "white" },
    fontFamily: {},
    borderRadius: { default: "12px" },
    padding: {},
    boxShadow: {},
    backdropFilter: {},
    controls: { default: () => [] }
  },
  emits: ["camera", "microphone", "screen-share", "camera-flip", "device", "layout-change", "raise-hand", "error"],
  setup(O, { expose: M, emit: k }) {
    oa(($) => ({
      "4a14ae46": Be.value + "px",
      "235b40fc": ke.value ? Xe.value + "px" : "0",
      "548027c2": ke.value ? G.barBackgroundColor : "transparent",
      de9086ee: ke.value ? Xe.value * 0.6 + "px" : "0",
      "4f3ff542": le.value + "px",
      "42501ba3": fe.value + "px",
      "717c87dc": G.iconColor,
      f2f660b0: G.textColor,
      "5c1a86fc": K.value + "px",
      "4eeffa4d": ye.value + "px",
      "7a7bd876": G.dropdownBackgroundColor,
      ff19aaae: Xe.value * 0.6 + "px",
      be676770: xe.value + "px",
      "2c4bd543": Be.value * 0.7 + "px",
      44473046: G.dropdownBackgroundColor === "none" ? "transparent" : G.dropdownBackgroundColor,
      "9e9e5e2a": Xe.value * 0.4 + "px",
      "11691f6a": Xe.value + "px",
      a9615236: fe.value * 0.75 + "px",
      "7788f0ce": K.value * 0.7 + "px",
      e20baf50: Xe.value * 0.25 + "px",
      "424dd5c3": fe.value + "px",
      ed0767a2: G.dropdownBackgroundColor === "none" ? "rgba(32, 33, 36, 0.95)" : G.dropdownBackgroundColor,
      27398867: Be.value
    }));
    const e = A(!0), s = () => {
      e.value = !e.value;
    }, C = n(() => !e.value || G.controls.length <= 3 ? G.controls : G.controls.slice(0, 3)), g = Pe("roomControls");
    if (!g)
      throw new Error("RoomControlBar must be used within a RoomProvider");
    const v = Pe("raiseHand");
    if (!v)
      throw new Error(
        "RoomControlBar must be used within a RoomProvider that provides raiseHand"
      );
    const a = Pe("reactions");
    if (!a)
      throw new Error(
        "RoomControlBar must be used within a RoomProvider that provides reactions"
      );
    const b = Pe("roomLayout");
    if (!b)
      throw new Error(
        "RoomControlBar must be used within a RoomProvider that provides roomLayout"
      );
    const r = [
      {
        value: "auto",
        label: "Auto"
      },
      {
        value: "grid",
        label: "Grid"
      },
      {
        value: "speaker",
        label: "Speaker"
      }
    ], {
      // Device lists
      videoDevices: u,
      audioInputDevices: m,
      audioOutputDevices: V,
      // Media states
      isCameraEnabled: h,
      isMicrophoneEnabled: D,
      isScreenShareEnabled: T,
      isScreenShareSupported: f,
      hasMultipleCameras: w,
      // Browser permission states
      cameraPermission: j,
      microphonePermission: p,
      screenSharePermission: z,
      // Selected devices
      selectedCamera: R,
      selectedMicrophone: U,
      selectedSpeaker: Z,
      // Streams
      cameraStream: H,
      microphoneStream: ee,
      screenShareStream: ae,
      // Control methods
      toggleCamera: we,
      toggleMicrophone: Te,
      toggleScreenShare: Ue,
      startCamera: _e,
      stopCamera: Ge,
      startMicrophone: X,
      stopMicrophone: Re,
      startScreenShare: he,
      stopScreenShare: de,
      // Device management
      handleDeviceChange: Ae,
      handleCameraFlip: Ee
    } = g, Ve = Pe("isInsideRoomViewSlot", !1), Ke = Pe(
      "showParticipantsModal",
      null
    ), o = A(null), d = A(null);
    ht(() => {
      if (o.value) {
        const $ = o.value.parentElement;
        $ && (d.value = $);
      }
    });
    const { width: L } = ya(d), K = n(() => {
      if (L.value <= 0) return 16;
      const q = L.value / 800 * 16;
      return Math.max(12, Math.min(20, q));
    }), le = n(() => {
      const Fe = 28 + 12 * (K.value - 12) / 8;
      return Math.max(28, Math.min(40, Fe));
    }), Be = n(() => {
      const Fe = 16 + 4 * (K.value - 12) / 8;
      return Math.max(16, Math.min(20, Fe));
    }), Xe = n(() => {
      const Fe = 16 + 4 * (K.value - 12) / 8;
      return Math.max(16, Math.min(20, Fe));
    }), fe = n(() => {
      const Fe = 24 + 4 * (K.value - 12) / 8;
      return Math.max(24, Math.min(28, Fe));
    }), xe = n(() => Math.min(280, Math.max(100, L.value * 0.8))), ye = n(() => {
      const it = 8 + Math.min(L.value, 1200) / 1200 * 8;
      return Math.max(8, Math.min(16, it));
    }), G = O;
    at("controlsConfig", G.controls);
    const ke = n(() => G.barBackgroundColor !== "none"), rt = n(() => G.embeddedPosition === "left" || G.embeddedPosition === "right"), E = n(() => Ve), _ = n(() => y(y({
      backgroundColor: G.barBackgroundColor,
      padding: G.padding,
      borderRadius: G.borderRadius,
      boxShadow: G.boxShadow,
      backdropFilter: G.backdropFilter,
      fontFamily: G.fontFamily
    }, G.barBackgroundColor === "none" && !G.containerStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.25))"
    } : {}), G.containerStyle)), W = n(() => y(y({}, G.barBackgroundColor === "none" && !G.buttonStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), G.buttonStyle)), Y = n(() => y(y({}, G.barBackgroundColor === "none" && !G.activeButtonStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), G.activeButtonStyle)), oe = n(() => y({
      backgroundColor: G.dropdownBackgroundColor,
      borderRadius: G.borderRadius,
      boxShadow: G.boxShadow,
      fontFamily: G.fontFamily
    }, G.dropdownStyle)), ce = n(() => y({
      color: G.textColor
    }, G.dropdownItemStyle)), ue = n(() => y(y({
      color: G.textColor,
      fontFamily: G.fontFamily
    }, G.barBackgroundColor === "none" && !G.textStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), G.textStyle)), re = () => j.value.state === "denied" ? "Camera access denied. Please allow camera access in browser settings." : h.value ? "Turn off camera" : "Turn on camera", Se = () => p.value.state === "denied" ? "Microphone access denied. Please allow microphone access in browser settings." : D.value ? "Mute" : "Unmute", Ie = () => z.value.state === "denied" ? "Screen sharing access denied. Please allow screen sharing in browser settings." : f ? T ? "Stop sharing" : "Share screen" : "Screen sharing not supported on this device", ne = k, $e = A(!1), Qe = A(null), Oe = A(!1), Ye = A(), Me = A(!1), Ne = ($) => {
      $ && $.stopPropagation(), $e.value = !$e.value;
    }, Je = () => {
      Ke && Ke();
    }, qe = ($) => {
      Qe.value && !Qe.value.contains($.target) && ($e.value = !1);
    }, St = () => me(this, null, function* () {
      try {
        if (j.value.state === "denied") {
          Me.value = !0;
          return;
        }
        yield we(), ne("camera", h.value, H.value);
      } catch ($) {
        ne(
          "error",
          $ instanceof Error ? $ : new Error("Failed to toggle camera")
        );
      }
    }), Ct = () => me(this, null, function* () {
      try {
        if (p.value.state === "denied") {
          Me.value = !0;
          return;
        }
        yield Te(), ne("microphone", D.value, ee.value);
      } catch ($) {
        ne(
          "error",
          $ instanceof Error ? $ : new Error("Failed to toggle microphone")
        );
      }
    }), Pt = () => me(this, null, function* () {
      try {
        yield Ue(), ne("screen-share", T.value, ae.value);
      } catch ($) {
        ne(
          "error",
          $ instanceof Error ? $ : new Error("Failed to toggle screen share")
        );
      }
    }), ft = ($, ge) => me(this, null, function* () {
      try {
        yield Ae($, ge), ne("device", $, ge);
      } catch (Fe) {
        ne(
          "error",
          Fe instanceof Error ? Fe : new Error(`Failed to change ${$} device`)
        );
      }
    }), Rt = () => me(this, null, function* () {
      try {
        yield Ee(), ne("camera-flip");
      } catch ($) {
        ne(
          "error",
          $ instanceof Error ? $ : new Error("Failed to flip camera")
        );
      }
    }), bt = ($) => {
      b && b.setLayoutMode && (b.clearAllPins(), b.setLayoutMode($)), ne("layout-change", $);
    }, yt = () => me(this, null, function* () {
      try {
        yield v.toggleRaiseHand(), ne("raise-hand", v.isHandRaised.value);
      } catch ($) {
        ne(
          "error",
          $ instanceof Error ? $ : new Error("Failed to toggle raise hand")
        );
      }
    }), gt = ($) => {
      $ && $.stopPropagation(), Oe.value = !Oe.value;
    }, lt = ($) => me(this, null, function* () {
      try {
        yield a.sendReaction($);
      } catch (ge) {
        ne(
          "error",
          ge instanceof Error ? ge : new Error("Failed to send reaction")
        );
      }
    });
    Ce($e, ($) => {
      $ ? setTimeout(() => {
        document.addEventListener("click", qe);
      }, 100) : document.removeEventListener("click", qe);
    });
    const Tt = n(() => rt.value ? e.value ? "down" : "up" : e.value ? "right" : "left"), Et = n(() => {
      var $;
      return {
        currentMode: (($ = b == null ? void 0 : b.layoutMode) == null ? void 0 : $.value) || "auto",
        availableLayouts: r,
        setLayout: bt,
        isLayoutAvailable: !!b
      };
    });
    return M({
      get selectedCamera() {
        return R.value;
      },
      get selectedMicrophone() {
        return U.value;
      },
      get selectedSpeaker() {
        return Z.value;
      },
      get isCameraEnabled() {
        return h.value;
      },
      get isMicrophoneEnabled() {
        return D.value;
      },
      get isScreenShareEnabled() {
        return T.value;
      },
      // Browser permission states
      get cameraPermission() {
        return j.value;
      },
      get microphonePermission() {
        return p.value;
      },
      get screenSharePermission() {
        return z.value;
      },
      get videoDevices() {
        return u.value;
      },
      get audioInputDevices() {
        return m.value;
      },
      get audioOutputDevices() {
        return V.value;
      },
      get videoStream() {
        return H.value;
      },
      get audioStream() {
        return ee.value;
      },
      get screenShareStream() {
        return ae.value;
      },
      toggleCamera: St,
      toggleMicrophone: Ct,
      toggleScreenShare: Pt,
      handleDeviceChange: ft,
      startCamera: () => me(this, null, function* () {
        try {
          yield _e(), ne("camera", !0, H.value);
        } catch ($) {
          ne(
            "error",
            $ instanceof Error ? $ : new Error("Failed to start camera")
          );
        }
      }),
      stopCamera: () => {
        try {
          Ge(), ne("camera", !1, null);
        } catch ($) {
          ne(
            "error",
            $ instanceof Error ? $ : new Error("Failed to stop camera")
          );
        }
      },
      startMicrophone: () => me(this, null, function* () {
        try {
          yield X(), ne("microphone", !0, ee.value);
        } catch ($) {
          ne(
            "error",
            $ instanceof Error ? $ : new Error("Failed to start microphone")
          );
        }
      }),
      stopMicrophone: () => {
        try {
          Re(), ne("microphone", !1, null);
        } catch ($) {
          ne(
            "error",
            $ instanceof Error ? $ : new Error("Failed to stop microphone")
          );
        }
      },
      startScreenShare: () => me(this, null, function* () {
        try {
          yield he(), ne("screen-share", !0, ae.value);
        } catch ($) {
          ne(
            "error",
            $ instanceof Error ? $ : new Error("Failed to start screen share")
          );
        }
      }),
      stopScreenShare: () => {
        try {
          de(), ne("screen-share", !1, null);
        } catch ($) {
          ne(
            "error",
            $ instanceof Error ? $ : new Error("Failed to stop screen share")
          );
        }
      },
      // Layout control functions
      get currentLayoutMode() {
        var $;
        return (($ = b == null ? void 0 : b.layoutMode) == null ? void 0 : $.value) || "auto";
      },
      setLayoutMode: bt,
      get availableLayouts() {
        return r;
      },
      get layoutState() {
        return Et.value;
      },
      // Raise hand control
      get isHandRaised() {
        return v.isHandRaised.value;
      },
      toggleRaiseHand: yt,
      // Reactions control
      sendReaction: ($) => me(this, null, function* () {
        yield lt($);
      }),
      // Participants modal control
      toggleParticipantsModal: Je,
      handleCameraFlip: Rt
    }), ($, ge) => {
      var Fe, it;
      return i(), c("div", {
        ref_key: "controlBarRef",
        ref: o,
        class: De(["control-bar", {
          vertical: rt.value,
          [`position-${G.embeddedPosition}`]: E.value,
          collapsed: e.value,
          "no-background": !ke.value
        }]),
        style: I(_.value),
        "data-control-size": le.value,
        "data-gap-size": Be.value,
        "data-dropdown-width": xe.value,
        "data-edge-offset": ye.value
      }, [
        Q(Ma, {
          name: "controls-animation",
          tag: "div",
          class: "controls-group"
        }, {
          default: nt(() => [
            $.controls && $.controls.length > 0 ? (i(), c(He, { key: 0 }, [
              (i(!0), c(He, null, tt(C.value, (q) => (i(), c(He, { key: q }, [
                q === "camera" ? (i(), be(pt, {
                  key: 0,
                  active: S(h),
                  title: re(),
                  "no-background": !ke.value,
                  style: I(
                    S(h) ? Y.value : W.value
                  ),
                  class: De([{
                    "permission-denied": S(j).state === "denied"
                  }, "control-item"]),
                  onClick: St
                }, {
                  default: nt(() => [
                    Q($t, {
                      variant: S(h) ? "on" : "mute",
                      size: fe.value
                    }, null, 8, ["variant", "size"]),
                    S(j).state === "denied" ? (i(), c("div", Zi, " ! ")) : F("", !0)
                  ]),
                  _: 1
                }, 8, ["active", "title", "no-background", "style", "class"])) : F("", !0),
                q === "microphone" ? (i(), be(pt, {
                  key: 1,
                  active: S(D),
                  title: Se(),
                  "no-background": !ke.value,
                  style: I(
                    S(D) ? Y.value : W.value
                  ),
                  class: De([{
                    "permission-denied": S(p).state === "denied"
                  }, "control-item"]),
                  onClick: Ct
                }, {
                  default: nt(() => [
                    Q(mt, {
                      variant: S(D) ? "on" : "mute",
                      size: fe.value
                    }, null, 8, ["variant", "size"]),
                    S(p).state === "denied" ? (i(), c("div", Xi, " ! ")) : F("", !0)
                  ]),
                  _: 1
                }, 8, ["active", "title", "no-background", "style", "class"])) : F("", !0),
                q === "screen-share" ? (i(), be(pt, {
                  key: 2,
                  active: S(T),
                  disabled: !S(f) || S(z).state === "denied",
                  title: Ie(),
                  "no-background": !ke.value,
                  style: I(
                    S(T) ? Y.value : W.value
                  ),
                  class: De([{
                    "permission-denied": S(z).state === "denied"
                  }, "control-item"]),
                  onClick: ge[0] || (ge[0] = (zt) => S(f) && S(z).state !== "denied" ? Pt() : void 0)
                }, {
                  default: nt(() => [
                    Q(ia, {
                      variant: S(T) ? "on" : "off",
                      size: fe.value
                    }, null, 8, ["variant", "size"]),
                    S(z).state === "denied" ? (i(), c("div", Qi, " ! ")) : F("", !0)
                  ]),
                  _: 1
                }, 8, ["active", "disabled", "title", "no-background", "style", "class"])) : F("", !0),
                q === "settings" ? (i(), c("div", qi, [
                  Q(pt, {
                    active: $e.value,
                    title: "Device settings",
                    "no-background": !ke.value,
                    style: I(
                      $e.value ? Y.value : W.value
                    ),
                    onClick: Ne
                  }, {
                    default: nt(() => [
                      Q(qa, {
                        variant: $e.value ? "on" : "off",
                        size: fe.value
                      }, null, 8, ["variant", "size"])
                    ]),
                    _: 1
                  }, 8, ["active", "no-background", "style"])
                ])) : F("", !0),
                q === "camera-flip" ? (i(), be(pt, {
                  key: 4,
                  disabled: !S(h) || !S(w),
                  title: S(w) ? S(h) ? "Flip camera" : "Enable camera first" : "Camera flip not available - only one camera detected",
                  "no-background": !ke.value,
                  style: I(W.value),
                  class: "control-item",
                  onClick: Rt
                }, {
                  default: nt(() => [
                    Q(en, { size: fe.value }, null, 8, ["size"])
                  ]),
                  _: 1
                }, 8, ["disabled", "title", "no-background", "style"])) : F("", !0),
                q === "participants" ? (i(), be(pt, {
                  key: 5,
                  active: !1,
                  title: "Show participants",
                  "no-background": !ke.value,
                  style: I(W.value),
                  class: "control-item",
                  onClick: Je
                }, {
                  default: nt(() => [
                    Q(on, { size: fe.value }, null, 8, ["size"])
                  ]),
                  _: 1
                }, 8, ["no-background", "style"])) : F("", !0),
                q === "raise-hand" ? (i(), be(pt, {
                  key: 6,
                  active: S(v).isHandRaised.value,
                  title: S(v).isHandRaised.value ? "Lower hand" : "Raise hand",
                  "no-background": !ke.value,
                  style: I(
                    S(v).isHandRaised.value ? Y.value : W.value
                  ),
                  class: "control-item",
                  onClick: yt
                }, {
                  default: nt(() => [
                    Q(sn, {
                      variant: S(v).isHandRaised.value ? "raised" : "lowered",
                      size: fe.value
                    }, null, 8, ["variant", "size"])
                  ]),
                  _: 1
                }, 8, ["active", "title", "no-background", "style"])) : F("", !0),
                q === "reactions" ? (i(), c("div", {
                  key: 7,
                  ref_for: !0,
                  ref_key: "reactionsButtonEl",
                  ref: Ye,
                  class: "reactions-container control-item"
                }, [
                  Q(pt, {
                    active: Oe.value,
                    title: "Send reaction",
                    "no-background": !ke.value,
                    style: I(
                      Oe.value ? Y.value : W.value
                    ),
                    onClick: gt
                  }, {
                    default: nt(() => [
                      Q(rn, {
                        variant: Oe.value ? "active" : "default",
                        size: fe.value
                      }, null, 8, ["variant", "size"])
                    ]),
                    _: 1
                  }, 8, ["active", "no-background", "style"])
                ], 512)) : F("", !0)
              ], 64))), 128)),
              $.controls.length > 3 ? (i(), be(pt, {
                key: "toggle-button",
                class: "control-item toggle-button",
                active: !1,
                title: e.value ? "Show more controls" : "Show fewer controls",
                "no-background": !ke.value,
                style: I(W.value),
                onClick: s
              }, {
                default: nt(() => [
                  Q(tn, {
                    variant: Tt.value,
                    size: fe.value
                  }, null, 8, ["variant", "size"])
                ]),
                _: 1
              }, 8, ["title", "no-background", "style"])) : F("", !0)
            ], 64)) : F("", !0)
          ]),
          _: 1
        }),
        $.$slots["end-controls"] ? (i(), c("div", eo, [
          _t($.$slots, "end-controls", {}, void 0, !0)
        ])) : F("", !0),
        $e.value ? (i(), c("div", {
          key: 1,
          ref_key: "settingsDropdown",
          ref: Qe,
          class: "settings-dropdown",
          style: I(oe.value)
        }, [
          t("div", to, [
            t("div", {
              class: "device-select",
              style: I(ce.value)
            }, [
              t("div", ao, [
                Q(ln, {
                  class: "device-icon",
                  size: fe.value * 0.75
                }, null, 8, ["size"]),
                t("select", {
                  id: "layout-select",
                  value: ((it = (Fe = S(b)) == null ? void 0 : Fe.layoutMode) == null ? void 0 : it.value) || "auto",
                  onChange: ge[1] || (ge[1] = (q) => bt(q.target.value))
                }, [
                  (i(), c(He, null, tt(r, (q) => t("option", {
                    key: q.value,
                    value: q.value
                  }, se(q.label), 9, io)), 64))
                ], 40, no),
                Q(Vt, {
                  class: "arrow-icon",
                  size: fe.value * 0.75
                }, null, 8, ["size"])
              ])
            ], 4),
            $.controls && $.controls.includes("camera") ? (i(), c("div", {
              key: 0,
              class: "device-select",
              style: I(ce.value)
            }, [
              t("div", oo, [
                Q($t, {
                  class: "device-icon",
                  size: fe.value * 0.75
                }, null, 8, ["size"]),
                t("select", {
                  id: "camera-select",
                  value: S(R),
                  onChange: ge[2] || (ge[2] = (q) => ft("camera", q.target.value))
                }, [
                  (i(!0), c(He, null, tt(S(u), (q) => (i(), c("option", {
                    key: q.deviceId,
                    value: q.deviceId
                  }, se(q.label || `Camera ${S(u).indexOf(q) + 1}`), 9, ro))), 128))
                ], 40, so),
                Q(Vt, {
                  class: "arrow-icon",
                  size: fe.value * 0.75
                }, null, 8, ["size"])
              ])
            ], 4)) : F("", !0),
            $.controls && $.controls.includes("microphone") ? (i(), c("div", {
              key: 1,
              class: "device-select",
              style: I(ce.value)
            }, [
              t("div", lo, [
                Q(mt, {
                  class: "device-icon",
                  size: fe.value * 0.75
                }, null, 8, ["size"]),
                t("select", {
                  id: "mic-select",
                  value: S(U),
                  onChange: ge[3] || (ge[3] = (q) => ft("microphone", q.target.value))
                }, [
                  (i(!0), c(He, null, tt(S(m), (q) => (i(), c("option", {
                    key: q.deviceId,
                    value: q.deviceId
                  }, se(q.label || `Microphone ${S(m).indexOf(q) + 1}`), 9, uo))), 128))
                ], 40, co),
                Q(Vt, {
                  class: "arrow-icon",
                  size: fe.value * 0.75
                }, null, 8, ["size"])
              ]),
              S(D) ? (i(), c("div", po, [
                Q(Oa, {
                  "icon-color": G.iconColor,
                  "icon-size": fe.value * 0.75
                }, null, 8, ["icon-color", "icon-size"])
              ])) : (i(), c("div", {
                key: 1,
                class: "mic-disabled-message",
                style: I(ue.value)
              }, " Enable microphone to see audio level ", 4))
            ], 4)) : F("", !0),
            $.controls && $.controls.includes("speaker") ? (i(), c("div", {
              key: 2,
              class: "device-select",
              style: I(ce.value)
            }, [
              t("div", vo, [
                Q(an, {
                  class: "device-icon",
                  size: fe.value * 0.75
                }, null, 8, ["size"]),
                t("select", {
                  id: "speaker-select",
                  value: S(Z),
                  onChange: ge[4] || (ge[4] = (q) => ft("speaker", q.target.value))
                }, [
                  (i(!0), c(He, null, tt(S(V), (q) => (i(), c("option", {
                    key: q.deviceId,
                    value: q.deviceId
                  }, se(q.label || `Speaker ${S(V).indexOf(q) + 1}`), 9, ho))), 128))
                ], 40, mo),
                Q(Vt, {
                  class: "arrow-icon",
                  size: fe.value * 0.75
                }, null, 8, ["size"])
              ])
            ], 4)) : F("", !0)
          ])
        ], 4)) : F("", !0),
        Q(Yi, {
          visible: Oe.value,
          emojis: S(a).availableEmojis,
          "anchor-el": Ye.value,
          position: "top",
          onSelect: lt,
          onClose: ge[5] || (ge[5] = (q) => Oe.value = !1)
        }, null, 8, ["visible", "emojis", "anchor-el"]),
        Me.value ? (i(), be(ha, {
          key: 2,
          "camera-permission": S(j),
          "microphone-permission": S(p),
          onClose: ge[6] || (ge[6] = (q) => Me.value = !1)
        }, null, 8, ["camera-permission", "microphone-permission"])) : F("", !0)
      ], 14, Ji);
    };
  }
}), ns = /* @__PURE__ */ We(fo, [["__scopeId", "data-v-d4b4f36a"]]), yo = { class: "icon-circle-outer" }, go = { class: "icon-circle-inner" }, ko = {
  key: 2,
  class: "message-spacer"
}, So = { class: "message-content" }, bo = ["onClick"], wo = ["src", "alt"], Co = ["src"], Po = ["title"], Ro = { class: "attachment-size" }, To = ["onClick"], Eo = {
  key: 0,
  class: "file-preview-thumbnail"
}, Mo = ["src", "alt"], Ao = ["disabled", "title"], xo = ["placeholder", "maxlength", "disabled"], Io = { class: "buttons-row" }, $o = { class: "icons-group" }, zo = ["disabled"], Lo = ["disabled"], Bo = ["disabled"], _o = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  class: "progress-ring"
}, No = ["stroke-dasharray"], Fo = ["disabled"], Ho = { class: "input-wrapper" }, Do = ["placeholder", "maxlength", "disabled", "onKeydown"], Oo = ["disabled"], Vo = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  class: "progress-ring"
}, jo = ["stroke-dasharray"], Wo = ["accept"], Uo = /* @__PURE__ */ je({
  __name: "RoomChat",
  props: {
    containerStyle: {},
    messageListStyle: {},
    maxHeight: {},
    bubbleStyle: {},
    ownBubbleStyle: {},
    otherBubbleStyle: {},
    bubbleShape: { default: "square" },
    messageTextStyle: {},
    senderNameStyle: {},
    timestampStyle: {},
    fontFamily: {},
    inputContainerStyle: {},
    inputFieldStyle: {},
    sendButtonStyle: {},
    attachmentButtonStyle: {},
    emojiButtonStyle: {},
    emojiPickerConfig: {},
    emojiPickerStyle: {},
    avatarStyle: {},
    emptyStateStyle: {},
    emptyStateContentStyle: {},
    emptyStateIconStyle: {},
    emptyStateHeadingStyle: {},
    emptyStateMessageStyle: {},
    loadingIndicatorStyle: {},
    loadingSpinnerStyle: {},
    loadingTextStyle: {},
    skeletonStyle: {},
    skeletonAvatarStyle: {},
    skeletonContentStyle: {},
    skeletonNameStyle: {},
    skeletonTextStyle: {},
    scrollButtonStyle: {},
    newMessageNotificationStyle: {},
    errorNotificationStyle: {},
    errorNotificationContentStyle: {},
    errorNotificationTextStyle: {},
    errorDismissButtonStyle: {},
    filePreviewStyle: {},
    fileIconStyle: {},
    fileInfoStyle: {},
    fileNameStyle: {},
    fileSizeStyle: {},
    fileRemoveButtonStyle: {},
    attachmentContainerStyle: {},
    imageAttachmentStyle: {},
    videoAttachmentStyle: {},
    documentAttachmentStyle: {},
    downloadButtonStyle: {},
    attachmentInfoStyle: {},
    attachmentDetailsStyle: {},
    hostTagStyle: {},
    showAvatars: { type: Boolean, default: !0 },
    showTimestamps: { type: Boolean, default: !0 },
    showSenderNames: { type: Boolean, default: !0 },
    timestampFormat: { default: "HH:mm" },
    enableEmoji: { type: Boolean, default: !0 },
    enableFileAttachment: { type: Boolean, default: !0 },
    maxMessageLength: { default: 500 },
    maxFileSize: { default: 100 * 1024 * 1024 },
    allowedFileTypes: { default: "image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip" },
    inputPlaceholder: { default: "Type a message..." },
    currentUserName: { default: "You" },
    avatarBackgroundColor: { default: "rgba(0, 0, 0, 0.5)" },
    enableNotificationSound: { type: Boolean, default: !1 },
    autoScroll: { type: Boolean, default: !0 },
    scrollThreshold: { default: 100 }
  },
  emits: ["message-sent", "message-received", "file-selected"],
  setup(O, { expose: M, emit: k }) {
    const e = O, s = k, C = A(), g = A(), v = A(), a = A(), b = A(), r = A(""), u = A(!0), m = A(null), V = A(null), h = A(null), D = A(!1), T = A(!1), f = Pe("isInsideRoomViewSlot", !1), { messages: w, sendMessage: j, clearMessages: p } = Va(), z = n(() => {
      var x;
      return ((x = U.value) == null ? void 0 : x.name) || e.currentUserName;
    }), { connectionState: R } = Gt(), { localParticipant: U } = Kt(), Z = n(() => "file-transfer-room"), H = n(() => R.value === vt.Connected), {
      fileMessages: ee,
      isUploading: ae,
      uploadProgress: we,
      sendFile: Te,
      clearFileMessages: Ue
    } = ja(Z.value), { recordMessage: _e } = Wa(), Ge = Ua(), X = sa(), {
      historicalMessages: Re,
      hasMore: he,
      isInitialLoading: de,
      isLoadingMore: Ae,
      loadMoreHistory: Ee
    } = Ga({
      pageSize: 15,
      onError: (x) => {
      }
    }), Ve = n(() => {
      const x = [], N = /* @__PURE__ */ new Map();
      w.value.forEach((ie) => {
        const ze = ie.text.match(/^\[FILE:([^\]]+)\](.*)$/);
        if (ze) {
          const [, ot, It] = ze;
          N.set(ot, It);
        }
      }), w.value.forEach((ie) => {
        ie.text.startsWith("[FILE:") || x.push(wt(y({}, ie), {
          attachment: void 0
        }));
      }), ee.value.forEach((ie) => {
        const ze = ie.isOwn ? z.value : ie.senderName, ot = N.get(ie.streamId) || "";
        x.push({
          id: ie.id,
          text: ot,
          // Use associated text from data channel
          senderName: ze,
          senderIdentity: ie.senderIdentity,
          senderIdentityType: ie.senderIdentityType,
          senderAvatar: ie.senderAvatar,
          senderRole: ie.senderRole,
          timestamp: ie.timestamp,
          isOwn: ie.isOwn,
          attachment: {
            id: ie.streamId,
            name: ie.fileName,
            size: ie.fileSize,
            type: ie.mimeType,
            url: ie.url
          }
        });
      });
      const B = Re.value.map((ie) => {
        var ze;
        return wt(y({}, ie), {
          isOwn: ie.senderIdentity === ((ze = U.value) == null ? void 0 : ze.identity)
        });
      });
      return Ka(
        B,
        x
      );
    }), Ke = n(() => y(y({
      fontFamily: e.fontFamily
    }, f && !e.containerStyle ? {
      background: "transparent",
      backdropFilter: "none"
    } : {}), e.containerStyle)), o = n(() => y(y({
      maxHeight: e.maxHeight
    }, f && !e.messageListStyle ? {
      background: "transparent"
    } : {}), e.messageListStyle)), d = n(() => y(y({}, f && !e.messageTextStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.messageTextStyle)), L = n(() => y(y({}, f && !e.senderNameStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.senderNameStyle)), K = n(() => y(y({}, f && !e.timestampStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.timestampStyle)), le = n(() => y(y({}, f && !e.inputContainerStyle ? {
      background: "transparent",
      borderTop: "none"
    } : {}), e.inputContainerStyle)), Be = n(() => y(y({
      fontFamily: e.fontFamily
    }, f && !e.inputFieldStyle ? {
      background: "transparent",
      borderColor: "rgba(255, 255, 255)",
      backdropFilter: "none",
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.inputFieldStyle)), Xe = n(() => y(y({}, f && !e.sendButtonStyle ? {
      background: "rgba(0, 0, 0, 0.5)",
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.sendButtonStyle)), fe = n(() => y(y({}, f && !e.attachmentButtonStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.attachmentButtonStyle)), xe = n(() => y(y({}, f && !e.emojiButtonStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.emojiButtonStyle)), ye = n(() => y(y({}, f && !e.avatarStyle ? {
      filter: "drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3))"
    } : {}), e.avatarStyle)), G = n(() => y(y({}, f && !e.emptyStateStyle ? {
      background: "transparent"
    } : {}), e.emptyStateStyle)), ke = n(() => y(y({}, f && !e.emptyStateContentStyle ? {
      filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))"
    } : {}), e.emptyStateContentStyle)), rt = n(() => y(y({}, f && !e.emptyStateIconStyle ? {
      filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.4))"
    } : {}), e.emptyStateIconStyle)), E = n(() => y(y({}, f && !e.emptyStateHeadingStyle ? {
      color: "white",
      textShadow: "0 1px 2px rgba(0, 0, 0, 0.5)"
    } : {}), e.emptyStateHeadingStyle)), _ = n(() => y(y({}, f && !e.emptyStateMessageStyle ? {
      color: "rgba(255, 255, 255, 0.8)",
      textShadow: "0 1px 2px rgba(0, 0, 0, 0.5)"
    } : {}), e.emptyStateMessageStyle)), W = n(() => y(y({}, f && !e.loadingIndicatorStyle ? {
      filter: "drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3))"
    } : {}), e.loadingIndicatorStyle)), Y = n(() => y(y({}, f && !e.loadingSpinnerStyle ? {
      borderColor: "rgba(255, 255, 255, 0.3)",
      borderTopColor: "white"
    } : {}), e.loadingSpinnerStyle)), oe = n(() => y(y({}, f && !e.loadingTextStyle ? {
      color: "rgba(255, 255, 255, 0.8)",
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.3)"
    } : {}), e.loadingTextStyle)), ce = n(() => y(y({}, f && !e.skeletonStyle ? {
      background: "rgba(255, 255, 255, 0.05)",
      borderTopColor: "rgba(255, 255, 255, 0.1)"
    } : {}), e.skeletonStyle)), ue = n(() => y(y({}, f && !e.skeletonAvatarStyle ? {
      background: "linear-gradient(90deg, rgba(255, 255, 255, 0.1) 25%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.1) 75%)"
    } : {}), e.skeletonAvatarStyle)), re = n(() => y(y({}, f && !e.skeletonContentStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2))"
    } : {}), e.skeletonContentStyle)), Se = n(() => y(y({}, f && !e.skeletonNameStyle ? {
      background: "linear-gradient(90deg, rgba(255, 255, 255, 0.1) 25%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.1) 75%)"
    } : {}), e.skeletonNameStyle)), Ie = n(() => y(y({}, f && !e.skeletonTextStyle ? {
      background: "linear-gradient(90deg, rgba(255, 255, 255, 0.1) 25%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.1) 75%)"
    } : {}), e.skeletonTextStyle)), ne = n(() => y(y({}, f && !e.scrollButtonStyle ? {
      background: "rgba(0, 0, 0, 0.7)",
      backdropFilter: "blur(10px)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)"
    } : {}), e.scrollButtonStyle)), $e = n(() => y(y({}, f && !e.newMessageNotificationStyle ? {
      background: "rgba(0, 0, 0, 0.8)",
      backdropFilter: "blur(10px)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)"
    } : {}), e.newMessageNotificationStyle)), Qe = n(() => y(y({}, f && !e.errorNotificationStyle ? {
      filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))"
    } : {}), e.errorNotificationStyle)), Oe = n(() => y(y({}, f && !e.errorNotificationContentStyle ? {
      background: "rgba(255, 215, 0, 0.95)",
      backdropFilter: "blur(8px)"
    } : {}), e.errorNotificationContentStyle)), Ye = n(() => y(y({}, f && !e.errorNotificationTextStyle ? {
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.2)"
    } : {}), e.errorNotificationTextStyle)), Me = n(() => y(y({}, f && !e.errorDismissButtonStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2))"
    } : {}), e.errorDismissButtonStyle)), Ne = n(() => y(y({}, f && !e.filePreviewStyle ? {
      background: "rgba(240, 242, 245, 0.95)",
      backdropFilter: "blur(8px)",
      border: "1px solid rgba(255, 255, 255, 0.2)"
    } : {}), e.filePreviewStyle)), Je = n(() => y(y({}, f && !e.fileIconStyle ? {
      background: "rgba(233, 236, 239, 0.9)",
      color: "rgba(108, 117, 125, 0.9)"
    } : {}), e.fileIconStyle)), qe = n(() => y(y({}, f && !e.fileInfoStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2))"
    } : {}), e.fileInfoStyle)), St = n(() => y(y({}, f && !e.fileNameStyle ? {
      color: "white",
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.3)"
    } : {}), e.fileNameStyle)), Ct = n(() => y(y({}, f && !e.fileSizeStyle ? {
      color: "rgba(255, 255, 255, 0.8)",
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.3)"
    } : {}), e.fileSizeStyle)), Pt = n(() => y(y({}, f && !e.fileRemoveButtonStyle ? {
      background: "rgba(255, 255, 255, 0.1)",
      color: "rgba(255, 255, 255, 0.8)",
      backdropFilter: "blur(4px)"
    } : {}), e.fileRemoveButtonStyle)), ft = n(() => y(y({}, f && !e.attachmentContainerStyle ? {
      filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2))"
    } : {}), e.attachmentContainerStyle)), Rt = n(() => y(y({}, f && !e.imageAttachmentStyle ? {
      border: "2px solid rgba(255, 255, 255, 0.3)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)"
    } : {}), e.imageAttachmentStyle)), bt = n(() => y(y({}, f && !e.videoAttachmentStyle ? {
      border: "2px solid rgba(255, 255, 255, 0.3)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)"
    } : {}), e.videoAttachmentStyle)), yt = n(() => y(y({}, f && !e.documentAttachmentStyle ? {
      background: "rgba(255, 255, 255, 0.1)",
      borderColor: "rgba(255, 255, 255, 0.2)",
      backdropFilter: "blur(8px)"
    } : {}), e.documentAttachmentStyle)), gt = n(() => y(y({}, f && !e.downloadButtonStyle ? {
      background: "rgba(255, 255, 255, 0.1)",
      borderColor: "rgba(255, 255, 255, 0.3)",
      color: "white"
    } : {}), e.downloadButtonStyle)), lt = n(() => y(y({}, f && !e.attachmentInfoStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2))"
    } : {}), e.attachmentInfoStyle)), Tt = n(() => y(y({}, f && !e.attachmentDetailsStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2))"
    } : {}), e.attachmentDetailsStyle)), Et = n(() => y(y({}, f && !e.hostTagStyle ? {
      background: "rgba(87, 115, 255, 0.9)",
      backdropFilter: "blur(4px)",
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.3)"
    } : {}), e.hostTagStyle)), $ = n(() => H.value && (r.value.trim() || m.value) && !ae.value), ge = (x) => {
      let N = e.bubbleStyle || {};
      f && !e.bubbleStyle && (N = y({
        background: "transparent"
      }, N));
      const B = x.isOwn ? e.ownBubbleStyle || (f ? { background: "transparent" } : {}) : e.otherBubbleStyle || (f ? { background: "transparent" } : {});
      return wt(y(y({}, N), B), {
        marginLeft: "0",
        marginRight: "auto"
      });
    }, Fe = (x) => {
      const N = new Date(x);
      return e.timestampFormat === "HH:mm" ? N.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : N.toLocaleString();
    }, it = () => me(this, null, function* () {
      if (!g.value) return;
      const { scrollTop: x, scrollHeight: N, clientHeight: B } = g.value;
      if (u.value = N - x - B < e.scrollThreshold, D.value = !u.value && Ve.value.length > 0, x < 100 && he.value && !Ae.value && !de.value) {
        const ze = N;
        yield Ee(), Lt(() => {
          if (g.value) {
            const It = g.value.scrollHeight - ze;
            g.value.scrollTop = x + It;
          }
        });
      }
    }), q = (x = !0) => {
      g.value && (g.value.scrollTop = g.value.scrollHeight);
    }, zt = (x) => {
      x.shiftKey || (x.preventDefault(), kt());
    }, Ft = () => {
      if (!v.value || f) return;
      const x = v.value;
      x.tagName === "TEXTAREA" && (x.style.height = "auto", x.style.height = Math.min(x.scrollHeight, 120) + "px");
    }, kt = () => me(this, null, function* () {
      if (!$.value) return;
      const x = r.value.trim();
      if (!(!x && !m.value))
        try {
          let N = null;
          if (m.value) {
            const B = yield Te(
              m.value,
              void 0,
              // Don't pass text since attributes aren't supported
              Z.value
            );
            x && (yield j(`[FILE:${B.streamId}]${x}`)), N = {
              id: B.id,
              text: x || "",
              // Text is now sent separately via data channel
              senderName: z.value,
              senderIdentity: B.senderIdentity,
              senderIdentityType: B.senderIdentityType,
              senderAvatar: B.senderAvatar,
              senderRole: B.senderRole,
              timestamp: B.timestamp,
              attachment: {
                id: B.streamId,
                name: B.fileName,
                size: B.fileSize,
                type: B.mimeType,
                url: B.url
              }
            };
          } else if (x) {
            const B = yield j(x);
            B && (N = {
              id: B.id,
              text: x || "",
              // Text is now sent separately via data channel
              senderName: z.value,
              senderAvatar: B.senderAvatar,
              senderRole: B.senderRole,
              senderIdentity: B.senderIdentity,
              senderIdentityType: B.senderIdentityType,
              timestamp: B.timestamp
            });
          }
          N && _e(N).catch((B) => null).then((B) => {
            B && s("message-sent", B);
          }), r.value = "", V.value && (URL.revokeObjectURL(V.value), V.value = null), m.value = null;
        } catch (N) {
        }
    }), Mt = () => {
      var x;
      (x = a.value) == null || x.click();
    }, Ht = () => {
      T.value = !0;
    }, dt = () => me(this, null, function* () {
      if (!(!b.value || !v.value))
        try {
          const N = y(y({}, {
            theme: f ? "dark" : "auto",
            perLine: 8,
            emojiSize: 24,
            emojiButtonSize: 32,
            searchPosition: "none"
          }), e.emojiPickerConfig), B = {};
          e.emojiPickerStyle && Object.entries(e.emojiPickerStyle).forEach(([ie, ze]) => {
            if (ze != null) {
              const ot = ie.replace(/([A-Z])/g, "-$1").toLowerCase();
              B[ot] = String(ze);
            }
          }), yield Ge.togglePicker(
            b.value,
            (ie) => {
              Zt(ie.native);
            },
            N,
            B
          );
        } catch (x) {
        }
    }), Zt = (x) => {
      const N = v.value;
      if (!N) return;
      const B = N.selectionStart || 0, ie = N.selectionEnd || 0, ze = r.value, ot = ze.slice(0, B) + x + ze.slice(ie);
      r.value = ot, Lt(() => {
        const It = B + x.length;
        N.setSelectionRange(It, It), N.focus();
      });
    }, At = (x) => {
      var ie;
      const N = x.target, B = (ie = N.files) == null ? void 0 : ie[0];
      if (B) {
        if (B.size > e.maxFileSize) {
          const ze = Math.round(e.maxFileSize / 1048576);
          h.value = `File too large. Please select a file smaller than ${ze} MB.`, setTimeout(() => {
            h.value = null;
          }, 5e3), N.value = "";
          return;
        }
        m.value = B, pe(B.type) && (V.value = URL.createObjectURL(B)), s("file-selected", B), N.value = "";
      }
    }, Xt = () => {
      ae.value || (V.value && (URL.revokeObjectURL(V.value), V.value = null), m.value = null, a.value && (a.value.value = ""));
    }, l = (x) => {
      if (x === 0) return "0 Bytes";
      const N = 1024, B = ["Bytes", "KB", "MB", "GB"], ie = Math.floor(Math.log(x) / Math.log(N));
      return Math.round(x / Math.pow(N, ie) * 100) / 100 + " " + B[ie];
    }, P = (x) => {
      const N = x.split(".");
      return N.length > 1 ? N[N.length - 1] : "";
    }, J = (x, N = 50) => {
      if (x.length <= N) return x;
      const B = x.lastIndexOf(".");
      if (B === -1)
        return x.substring(0, N) + "...";
      const ie = x.substring(B), ze = x.substring(0, B), ot = N - ie.length - 3;
      return ot <= 0 ? x.substring(0, N) + "..." : ze.length <= ot ? x : ze.substring(0, ot) + "..." + ie;
    }, pe = (x) => x.startsWith("image/"), te = (x) => x.startsWith("video/"), ct = (x) => {
      if (!x.url)
        return;
      const N = document.createElement("a");
      N.href = x.url, N.download = x.name, document.body.appendChild(N), N.click(), document.body.removeChild(N);
    }, xt = (x) => {
      x.url && pe(x.type) && window.open(x.url, "_blank");
    };
    return Ce(Ve, () => {
      e.autoScroll && u.value && Lt(() => q());
    }), Ce(
      () => w.value.length,
      (x, N) => me(this, null, function* () {
        if (x > N) {
          const B = w.value[w.value.length - 1];
          if (B && !B.isOwn && (s("message-received", B), e.enableNotificationSound))
            try {
              yield X.playSound(
                Wt.MESSAGE_RECEIVED
              );
            } catch (ie) {
            }
        }
      })
    ), ht(() => {
      q(!1);
      const x = document.createElement("link");
      x.rel = "prefetch", x.href = "https://cdn.jsdelivr.net/npm/emoji-mart@5.6.0/dist/browser.js", document.head.appendChild(x);
      const N = document.createElement("link");
      N.rel = "prefetch", N.href = "https://cdn.jsdelivr.net/npm/@emoji-mart/data", document.head.appendChild(N);
    }), M({
      // Methods
      sendMessage: kt,
      clearMessages: () => {
        p(), Ue();
      },
      scrollToBottom: q,
      // State
      messages: Ve,
      isConnected: n(() => H.value),
      messageInput: r,
      // Refs
      inputRef: v
    }), (x, N) => (i(), c("div", {
      ref_key: "chatContainerRef",
      ref: C,
      class: De(["room-chat", { "inside-player": S(f) }]),
      style: I(Ke.value)
    }, [
      t("div", {
        ref_key: "messageListRef",
        ref: g,
        class: "message-list",
        style: I(o.value),
        onScroll: it
      }, [
        S(Ae) ? (i(), c("div", {
          key: 0,
          class: "loading-more-indicator",
          style: I(W.value)
        }, [
          t("div", {
            class: "loading-spinner",
            style: I(Y.value)
          }, null, 4),
          t("span", {
            class: "loading-text",
            style: I(oe.value)
          }, "Loading older messages...", 4)
        ], 4)) : F("", !0),
        !S(de) && Ve.value.length === 0 && !S(f) ? (i(), c("div", {
          key: 1,
          class: "empty-state",
          style: I(G.value)
        }, [
          t("div", {
            class: "empty-state-content",
            style: I(ke.value)
          }, [
            T.value ? (i(), c("div", {
              key: 1,
              class: "empty-state-icon",
              style: I(rt.value)
            }, [
              t("div", yo, [
                t("div", go, [
                  Q(nn, { size: 20 })
                ])
              ])
            ], 4)) : (i(), c("img", {
              key: 0,
              src: "https://storage.googleapis.com/revex-assets-drm-staging/live-session-assets/images/no-chat-illustration.webp",
              alt: "No chat illustration",
              class: "empty-state-illustration",
              onError: Ht
            }, null, 32)),
            t("h3", {
              class: "empty-state-heading",
              style: I(E.value)
            }, se(H.value ? "No conversations yet" : "Welcome to Chat"), 5),
            t("p", {
              class: "empty-state-message",
              style: I(_.value)
            }, se(H.value ? "Start a new chat to get the conversation going!" : "Start the session to get conversation going!"), 5)
          ], 4)
        ], 4)) : S(de) ? F("", !0) : (i(), c("div", ko)),
        (i(!0), c(He, null, tt(Ve.value, (B) => (i(), c("div", {
          key: B.id,
          class: De(["message-wrapper", { "own-message": B.isOwn }])
        }, [
          x.showAvatars ? (i(), c("div", {
            key: 0,
            class: "message-avatar",
            style: I(ye.value)
          }, [
            Q(Yt, {
              name: B.senderName,
              image: B.senderAvatar,
              size: "small",
              "background-color": x.avatarBackgroundColor
            }, null, 8, ["name", "image", "background-color"])
          ], 4)) : F("", !0),
          t("div", So, [
            x.showSenderNames ? (i(), c("div", {
              key: 0,
              class: "message-sender",
              style: I(L.value)
            }, [
              Aa(se(B.senderName) + " ", 1),
              B.senderRole === "host" ? (i(), c("span", {
                key: 0,
                class: "host-tag",
                style: I(Et.value)
              }, "Host", 4)) : F("", !0),
              x.showTimestamps ? (i(), c("span", {
                key: 1,
                class: "message-timestamp inline",
                style: I(K.value)
              }, se(Fe(B.timestamp)), 5)) : F("", !0)
            ], 4)) : F("", !0),
            t("div", {
              class: De(["message-bubble", `bubble-${x.bubbleShape}`]),
              style: I(ge(B))
            }, [
              B.text ? (i(), c("p", {
                key: 0,
                class: "message-text preserve-whitespace",
                style: I(d.value)
              }, se(B.text), 5)) : F("", !0),
              B.attachment ? (i(), c("div", {
                key: 1,
                class: "message-attachment-container",
                style: I(ft.value)
              }, [
                pe(B.attachment.type) ? (i(), c("div", {
                  key: 0,
                  class: "message-attachment image-attachment",
                  style: I(Rt.value),
                  onClick: (ie) => xt(B.attachment)
                }, [
                  t("img", {
                    src: B.attachment.url || "#",
                    alt: B.attachment.name,
                    class: "attachment-preview-image"
                  }, null, 8, wo)
                ], 12, bo)) : te(B.attachment.type) ? (i(), c("div", {
                  key: 1,
                  class: "message-attachment video-attachment",
                  style: I(bt.value)
                }, [
                  t("video", {
                    src: B.attachment.url || "#",
                    class: "attachment-preview-video",
                    controls: "",
                    preload: "metadata"
                  }, " Your browser does not support the video tag. ", 8, Co)
                ], 4)) : (i(), c("div", {
                  key: 2,
                  class: "message-attachment document-attachment",
                  style: I(yt.value)
                }, [
                  t("div", {
                    class: "attachment-info",
                    style: I(lt.value)
                  }, [
                    Q(ea, { size: 20 }),
                    t("div", {
                      class: "attachment-details",
                      style: I(Tt.value)
                    }, [
                      t("span", {
                        class: "attachment-name",
                        title: B.attachment.name
                      }, se(J(B.attachment.name)), 9, Po),
                      t("span", Ro, se(l(B.attachment.size)), 1)
                    ], 4)
                  ], 4),
                  t("button", {
                    type: "button",
                    class: "download-button",
                    style: I(gt.value),
                    title: "Download",
                    onClick: (ie) => ct(B.attachment)
                  }, N[6] || (N[6] = [
                    t("svg", {
                      width: "20",
                      height: "20",
                      viewBox: "0 0 20 20",
                      fill: "currentColor"
                    }, [
                      t("path", { d: "M10.75 2.75a.75.75 0 00-1.5 0v8.614L6.295 8.235a.75.75 0 10-1.09 1.03l4.25 4.5a.75.75 0 001.09 0l4.25-4.5a.75.75 0 00-1.09-1.03l-2.955 3.129V2.75z" }),
                      t("path", { d: "M3.5 12.75a.75.75 0 00-1.5 0v2.5A2.75 2.75 0 004.75 18h10.5A2.75 2.75 0 0018 15.25v-2.5a.75.75 0 00-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5z" })
                    ], -1)
                  ]), 12, To)
                ], 4))
              ], 4)) : F("", !0)
            ], 6)
          ])
        ], 2))), 128))
      ], 36),
      S(de) ? (i(), c("div", {
        key: 0,
        class: "initial-loading-bottom",
        style: I(ce.value)
      }, [
        (i(!0), c(He, null, tt(S(f) ? 2 : 3, (B) => (i(), c("div", {
          key: B,
          class: "message-skeleton"
        }, [
          t("div", {
            class: "skeleton-avatar",
            style: I(ue.value)
          }, null, 4),
          t("div", {
            class: "skeleton-content",
            style: I(re.value)
          }, [
            t("div", {
              class: "skeleton-name",
              style: I(Se.value)
            }, null, 4),
            t("div", {
              class: "skeleton-text",
              style: I(Ie.value)
            }, null, 4),
            S(f) ? F("", !0) : (i(), c("div", {
              key: 0,
              class: "skeleton-text short",
              style: I(Ie.value)
            }, null, 4))
          ], 4)
        ]))), 128))
      ], 4)) : F("", !0),
      Q(na, { name: "new-message-notification" }, {
        default: nt(() => [
          D.value && !u.value ? (i(), c("div", {
            key: 0,
            class: "new-message-notification",
            style: I($e.value),
            onClick: N[0] || (N[0] = (B) => q(!0))
          }, N[7] || (N[7] = [
            t("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 20 20",
              fill: "currentColor"
            }, [
              t("path", { d: "M10 3a.75.75 0 01.75.75v10.638l3.96-4.158a.75.75 0 111.08 1.04l-5.25 5.5a.75.75 0 01-1.08 0l-5.25-5.5a.75.75 0 111.08-1.04l3.96 4.158V3.75A.75.75 0 0110 3z" })
            ], -1),
            t("span", { class: "new-message-text" }, "See latest", -1)
          ]), 4)) : F("", !0)
        ]),
        _: 1
      }),
      Q(na, { name: "scroll-button" }, {
        default: nt(() => [
          D.value && u.value ? (i(), c("button", {
            key: 0,
            type: "button",
            class: De(["scroll-to-bottom-button", { "inside-player": S(f) }]),
            style: I(ne.value),
            onClick: N[1] || (N[1] = (B) => q(!0))
          }, N[8] || (N[8] = [
            t("svg", {
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "currentColor"
            }, [
              t("path", { d: "M10 3a.75.75 0 01.75.75v10.638l3.96-4.158a.75.75 0 111.08 1.04l-5.25 5.5a.75.75 0 01-1.08 0l-5.25-5.5a.75.75 0 111.08-1.04l3.96 4.158V3.75A.75.75 0 0110 3z" })
            ], -1)
          ]), 6)) : F("", !0)
        ]),
        _: 1
      }),
      h.value ? (i(), c("div", {
        key: 1,
        class: "file-size-error-notification",
        style: I(Qe.value)
      }, [
        t("div", {
          class: "error-content",
          style: I(Oe.value)
        }, [
          t("span", {
            class: "error-text",
            style: I(Ye.value)
          }, se(h.value), 5),
          t("button", {
            type: "button",
            class: "error-dismiss-button",
            style: I(Me.value),
            onClick: N[2] || (N[2] = (B) => h.value = null)
          }, " × ", 4)
        ], 4)
      ], 4)) : F("", !0),
      t("form", {
        class: "input-container",
        style: I(le.value),
        onSubmit: N[5] || (N[5] = Ze(() => {
        }, ["prevent"]))
      }, [
        S(f) ? (i(), c(He, { key: 1 }, [
          x.enableEmoji ? (i(), c("button", {
            key: 0,
            ref_key: "emojiButtonRef",
            ref: b,
            type: "button",
            class: "emoji-button",
            style: I(xe.value),
            disabled: !H.value || S(Ge).isLoading.value,
            onClick: dt
          }, [
            Q(pa, { size: 20 })
          ], 12, Fo)) : F("", !0),
          t("div", Ho, [
            ta(t("input", {
              id: "message-input",
              ref_key: "inputRef",
              ref: v,
              "onUpdate:modelValue": N[4] || (N[4] = (B) => r.value = B),
              type: "text",
              class: "message-input",
              style: I(Be.value),
              placeholder: x.inputPlaceholder,
              maxlength: x.maxMessageLength,
              disabled: !H.value,
              onKeydown: ua(Ze(kt, ["prevent"]), ["enter"])
            }, null, 44, Do), [
              [aa, r.value]
            ])
          ]),
          t("button", {
            type: "button",
            class: "send-button",
            style: I(Xe.value),
            disabled: !$.value,
            onClick: Ze(kt, ["prevent"])
          }, [
            S(ae) ? (i(), c("svg", Vo, [
              N[11] || (N[11] = t("circle", {
                cx: "10",
                cy: "10",
                r: "8",
                stroke: "currentColor",
                "stroke-width": "2",
                fill: "none",
                opacity: "0.2"
              }, null, -1)),
              t("circle", {
                cx: "10",
                cy: "10",
                r: "8",
                stroke: "currentColor",
                "stroke-width": "2",
                fill: "none",
                "stroke-linecap": "round",
                "stroke-dasharray": `${S(we) * 50.3} 50.3`,
                transform: "rotate(-90 10 10)",
                class: "progress-ring-circle"
              }, null, 8, jo)
            ])) : (i(), be(va, {
              key: 1,
              size: 20
            }))
          ], 12, Oo)
        ], 64)) : (i(), c(He, { key: 0 }, [
          m.value ? (i(), c("div", {
            key: 0,
            class: "file-preview",
            style: I(Ne.value)
          }, [
            V.value && pe(m.value.type) ? (i(), c("div", Eo, [
              t("img", {
                src: V.value,
                alt: m.value.name
              }, null, 8, Mo)
            ])) : (i(), c("div", {
              key: 1,
              class: "file-icon",
              style: I(Je.value)
            }, [
              Q(ea, { size: 24 })
            ], 4)),
            t("div", {
              class: "file-info",
              style: I(qe.value)
            }, [
              t("div", {
                class: "file-name",
                style: I(St.value)
              }, se(m.value.name), 5),
              t("div", {
                class: "file-size",
                style: I(Ct.value)
              }, se(l(m.value.size)) + ", " + se(P(m.value.name)), 5)
            ], 4),
            t("button", {
              type: "button",
              class: "file-remove-button",
              style: I(Pt.value),
              disabled: S(ae),
              title: S(ae) ? "Upload in progress" : "Remove file",
              onClick: Xt
            }, N[9] || (N[9] = [
              t("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "currentColor"
              }, [
                t("path", { d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" })
              ], -1)
            ]), 12, Ao)
          ], 4)) : F("", !0),
          ta(t("textarea", {
            id: "message-input",
            ref_key: "inputRef",
            ref: v,
            "onUpdate:modelValue": N[3] || (N[3] = (B) => r.value = B),
            class: "message-input standalone",
            style: I(Be.value),
            placeholder: x.inputPlaceholder,
            maxlength: x.maxMessageLength,
            disabled: !H.value,
            rows: "2",
            onKeydown: ua(zt, ["enter"]),
            onInput: Ft
          }, null, 44, xo), [
            [aa, r.value]
          ]),
          t("div", Io, [
            t("div", $o, [
              x.enableEmoji ? (i(), c("button", {
                key: 0,
                ref_key: "emojiButtonRef",
                ref: b,
                type: "button",
                class: "emoji-button",
                style: I(xe.value),
                disabled: !H.value || S(Ge).isLoading.value,
                onClick: dt
              }, [
                Q(pa, { size: 20 })
              ], 12, zo)) : F("", !0),
              x.enableFileAttachment ? (i(), c("button", {
                key: 1,
                type: "button",
                class: "attachment-button",
                style: I(fe.value),
                disabled: !H.value,
                onClick: Mt
              }, [
                Q(ea, { size: 20 })
              ], 12, Lo)) : F("", !0)
            ]),
            t("button", {
              type: "button",
              class: "send-button",
              style: I(Xe.value),
              disabled: !$.value,
              onClick: Ze(kt, ["prevent"])
            }, [
              S(ae) ? (i(), c("svg", _o, [
                N[10] || (N[10] = t("circle", {
                  cx: "10",
                  cy: "10",
                  r: "8",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  fill: "none",
                  opacity: "0.2"
                }, null, -1)),
                t("circle", {
                  cx: "10",
                  cy: "10",
                  r: "8",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  fill: "none",
                  "stroke-linecap": "round",
                  "stroke-dasharray": `${S(we) * 50.3} 50.3`,
                  transform: "rotate(-90 10 10)",
                  class: "progress-ring-circle"
                }, null, 8, No)
              ])) : (i(), be(va, {
                key: 1,
                size: 20
              }))
            ], 12, Bo)
          ])
        ], 64))
      ], 36),
      t("input", {
        ref_key: "fileInputRef",
        ref: a,
        type: "file",
        accept: x.allowedFileTypes,
        style: { display: "none" },
        onChange: At
      }, null, 40, Wo)
    ], 6));
  }
}), is = /* @__PURE__ */ We(Uo, [["__scopeId", "data-v-2416e366"]]);
export {
  Yn as P,
  ts as R,
  as as a,
  ns as b,
  is as c,
  Yi as d
};
